/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
var flkty;
function initFlickity() {
    console.log("flkty 1st : ", flkty);
    if (flkty) {
        flkty.destroy();
    }
    flkty = new Flickity('.flickity-slider', {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
        dragThreshold: 30, // Increase this to require a stronger drag to move
        // selectedAttraction: 0.02, // Lower values make the drag feel "heavier"
        // friction: 0.2 // Lower values make the slider settle more slowly
    });
    var thumbnailsMobile = document.querySelectorAll('[data-product-thumbs-slider] .mobile');
    var thumbnailsDesktop = document.querySelectorAll('[data-product-thumbs-slider] .desktop');

    function updateActiveThumbnail(index) {
        thumbnailsMobile.forEach(thumb => thumb.classList.remove('active', 'custom-activated', 'is-activated'));
        thumbnailsDesktop.forEach(thumb => thumb.classList.remove('active', 'custom-activated', 'is-activated'));

        if (thumbnailsMobile[index]) thumbnailsMobile[index].classList.add('active', 'custom-activated');
        if (thumbnailsDesktop[index]) thumbnailsDesktop[index].classList.add('active', 'custom-activated');
    }
    thumbnailsMobile.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
            flkty.select(index);
            updateActiveThumbnail(index);
        });
    });
    thumbnailsDesktop.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
            flkty.select(index);
            updateActiveThumbnail(index);
        });
    });
    updateActiveThumbnail(flkty.selectedIndex);
    flkty.on('change', index => updateActiveThumbnail(index));
}
! function (e, t, i, s, r, n, o, a, l, c, h) {
    "use strict";

    function d(e) {
        var t = Object.create(null);
        return e && Object.keys(e).forEach((function (i) {
            if ("default" !== i) {
                var s = Object.getOwnPropertyDescriptor(e, i);
                Object.defineProperty(t, i, s.get ? s : {
                    enumerable: !0,
                    get: function () {
                        return e[i]
                    }
                })
            }
        })), t.default = e, Object.freeze(t)
    }
    var u = d(r);

    function p(e) {
        const t = e.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        t.forEach((e => {
            i.querySelector(`[id="${e.id}"]`) || i.appendChild(e)
        }))
    }

    function m(e) {
        e.querySelectorAll(".float__wrapper").forEach((e => {
            const t = e.querySelector("label"),
                i = e.querySelector("input, textarea");
            t && i.addEventListener("keyup", (e => {
                "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float")
            })), i && i.value && i.value.length && t.classList.add("label--float")
        }))
    }

    function f(e) {
        e.querySelectorAll(".errors").forEach((e => {
            e.setAttribute("tabindex", "0"), e.setAttribute("aria-live", "assertive"), e.setAttribute("role", "alert")
        }))
    }

    function g(e) {
        e.querySelectorAll("img").forEach((e => {
            e.complete && e.parentNode.classList.remove("loading-shimmer")
        }))
    }

    function y() {
        const e = {};
        return e.windowHeight = window.innerHeight, e.announcementHeight = w("[data-announcement-bar]"), e.toolbarHeight = w("[data-toolbar-height]"), e.footerHeight = w('[data-section-type*="footer"]'), e.menuHeight = w("[data-header-height]"), e.headerHeight = e.menuHeight + e.announcementHeight, e.logoHeight = function () {
            const e = w("[data-footer-logo]");
            return e > 0 ? e + 20 : 0
        }(), e.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? e.menuHeight : 0, e.backfillHeight = w("[data-header-backfill]"), e
    }

    function v() {
        document.addEventListener("theme:resize", b),
            function () {
                const {
                    windowHeight: e,
                    announcementHeight: t,
                    toolbarHeight: i,
                    headerHeight: s,
                    logoHeight: r,
                    menuHeight: n,
                    footerHeight: o,
                    stickyHeader: a,
                    backfillHeight: l
                } = y();
                document.documentElement.style.setProperty("--scrollbar-width", `${S()}px`), document.documentElement.style.setProperty("--footer-logo", `${r}px`), document.documentElement.style.setProperty("--full-screen", `${e}px`), document.documentElement.style.setProperty("--three-quarters", .75 * e + "px"), document.documentElement.style.setProperty("--two-thirds", .66 * e + "px"), document.documentElement.style.setProperty("--one-half", .5 * e + "px"), document.documentElement.style.setProperty("--one-third", .33 * e + "px"), document.documentElement.style.setProperty("--one-fifth", .2 * e + "px"), document.documentElement.style.setProperty("--menu-height", `${n}px`), document.documentElement.style.setProperty("--announcement-height", `${t}px`), document.documentElement.style.setProperty("--toolbar-height", `${i}px`), document.documentElement.style.setProperty("--header-height", `${s}px`), document.documentElement.style.setProperty("--footer-height", `${o}px`), document.documentElement.style.setProperty("--content-full", e - s - r / 2 + "px"), document.documentElement.style.setProperty("--menu-height-sticky", `${a}px`);
                let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
                document.documentElement.style.setProperty("--menu-backfill-height", c)
            }()
    }

    function b() {
        const {
            windowHeight: e,
            announcementHeight: t,
            toolbarHeight: i,
            headerHeight: s,
            logoHeight: r,
            menuHeight: n,
            footerHeight: o,
            stickyHeader: a,
            backfillHeight: l
        } = y();
        document.documentElement.style.setProperty("--scrollbar-width", `${S()}px`), document.documentElement.style.setProperty("--full-screen", `${e}px`), document.documentElement.style.setProperty("--menu-height", `${n}px`), document.documentElement.style.setProperty("--announcement-height", `${t}px`), document.documentElement.style.setProperty("--toolbar-height", `${i}px`), document.documentElement.style.setProperty("--header-height", `${s}px`), document.documentElement.style.setProperty("--footer-height", `${o}px`), document.documentElement.style.setProperty("--content-full", e - s - r / 2 + "px"), document.documentElement.style.setProperty("--menu-height-sticky", `${a}px`);
        let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", c)
    }

    function w(e) {
        const t = document.querySelector(e);
        return t ? t.clientHeight : 0
    }

    function S() {
        const e = document.createElement("div");
        e.style.visibility = "hidden", e.style.overflow = "scroll", e.style.msOverflowStyle = "scrollbar", document.body.appendChild(e);
        const t = document.createElement("div");
        e.appendChild(t);
        const i = e.offsetWidth - t.offsetWidth;
        return e.parentNode.removeChild(e), i
    }

    function E(e, t) {
        let i = 64,
            s = 0;
        t.forEach((e => {
            if (e.offsetHeight > s) {
                const t = parseInt(window.getComputedStyle(e).marginTop) + parseInt(window.getComputedStyle(e).marginBottom);
                t > i && (i = t), s = e.offsetHeight
            }
        }));
        const r = e.querySelectorAll("[data-overflow-background]");
        [e, ...r].forEach((e => {
            e.style.setProperty("min-height", `calc(${s + i}px + var(--menu-height))`)
        }))
    }

    function L(e) {
        let t = document.querySelector("[data-footer-logo]") ? document.querySelector("[data-footer-logo]").clientHeight + 20 : 0;
        const i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if ((null !== s && e.getAttribute("data-section-id") !== s || !i) && (t = 0), window.innerWidth < window.theme.sizes.medium) {
            return void e.querySelectorAll("[data-overflow-frame]").forEach((e => {
                const t = e.querySelectorAll("[data-overflow-content]");
                E(e, t)
            }))
        }
        const r = document.createElement("div");
        e.prepend(r), r.style.display = "none", r.style.width = getComputedStyle(e).getPropertyValue("--outer");
        const n = 2 * parseInt(getComputedStyle(r).getPropertyValue("width"));
        e.firstChild.remove();
        let o = 0;
        const a = e.querySelectorAll("[data-overflow-frame]");
        e.querySelectorAll("[data-overflow-content]").forEach((e => {
            e.offsetHeight > o && (o = e.offsetHeight)
        }));
        [...a, ...e.querySelectorAll("[data-overflow-background]")].forEach((e => {
            e.style.setProperty("min-height", `${o + n}px`)
        })), e.style.setProperty("min-height", `${o + n + 2 + t}px`)
    }

    function k(e) {
        const i = e.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((e => {
                const t = e.querySelectorAll(".js-overflow-content");
                E(e, t), document.addEventListener("theme:resize", (() => {
                    E(e, t)
                }))
            }));
            const s = e.querySelectorAll("[data-slideshow-wrapper]");
            s.length && s.forEach((e => {
                const i = t.data(e);
                void 0 !== i && i.reloadCells()
            }))
        }
        const s = e.querySelectorAll("[data-overflow-wrapper]");
        s && s.forEach((e => {
            L(e), document.addEventListener("theme:resize", (() => {
                L(e)
            }))
        }))
    }

    function T(e, t = 500, i = !1) {
        var s, r, n, o, a;

        function l() {
            var c = Date.now() - o;
            c < t && c >= 0 ? s = setTimeout(l, t - c) : (s = null, i || (a = e.apply(n, r), n = r = null))
        }
        null == t && (t = 100);
        var c = function () {
            n = this, r = arguments, o = Date.now();
            var c = i && !s;
            return s || (s = setTimeout(l, t)), c && (a = e.apply(n, r), n = r = null), a
        };
        return c.clear = function () {
            s && (clearTimeout(s), s = null)
        }, c.flush = function () {
            s && (a = e.apply(n, r), n = r = null, clearTimeout(s), s = null)
        }, c
    } ! function () {
        const e = {
            NODE_ENV: "production"
        };
        try {
            if (process) return process.env = Object.assign({}, process.env), void Object.assign(process.env, e)
        } catch (e) { }
        globalThis.process = {
            env: e
        }
    }(), window.requestIdleCallback = window.requestIdleCallback || function (e) {
        var t = Date.now();
        return setTimeout((function () {
            e({
                didTimeout: !1,
                timeRemaining: function () {
                    return Math.max(0, 50 - (Date.now() - t))
                }
            })
        }), 1)
    }, window.cancelIdleCallback = window.cancelIdleCallback || function (e) {
        clearTimeout(e)
    };
    let x, _ = window.innerWidth,
        A = window.innerHeight;

    function q() {
        document.dispatchEvent(new CustomEvent("theme:resize", {
            bubbles: !0
        })), _ !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
            bubbles: !0
        })), _ = window.innerWidth), A !== window.innerHeight && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
            bubbles: !0
        })), A = window.innerHeight)
    }
    let C = window.pageYOffset,
        P = null,
        $ = null,
        I = null,
        M = null,
        D = 0;

    function O() {
        const e = window.pageYOffset;
        e > C ? ($ = !0, P = !1) : e < C ? ($ = !1, P = !0) : (P = null, $ = null), C = e, document.dispatchEvent(new CustomEvent("theme:scroll", {
            detail: {
                up: P,
                down: $,
                position: e
            },
            bubbles: !1
        })), P && !I && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
            detail: {
                position: e
            },
            bubbles: !1
        })), $ && !M && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
            detail: {
                position: e
            },
            bubbles: !1
        })), M = $, I = P
    }

    function H(e) {
        // setTimeout((() => {
        //     D && clearTimeout(D), i.disablePageScroll(e.detail, {
        //         allowTouchMove: e => "TEXTAREA" === e.tagName
        //     }), document.documentElement.setAttribute("data-scroll-locked", "")
        // }))
    }

    function F(e) {
        const t = e.detail;
        t ? D = setTimeout(B, t) : B()
    }

    function B() {
        // i.clearQueueScrollLocks(), i.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked")
    }
    const W = "time",
        N = "[data-days]",
        R = "[data-hours]",
        j = "[data-minutes]",
        z = "[data-seconds]",
        V = ".shopify-section",
        U = "data-expiration-behavior",
        G = "show-message",
        J = "hidden",
        Q = "hide-section",
        Y = "show-message";
    let K = class extends HTMLElement {
        connectedCallback() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : this.interval = setInterval(this.update, 1e3)
        }
        disconnectedCallback() {
            this.stopTimer()
        }
        convertTime(e) {
            const t = this.formatDigits(parseInt(e / this.daysInMs, 10));
            e -= t * this.daysInMs;
            const i = this.formatDigits(parseInt(e / this.hoursInMs, 10));
            e -= i * this.hoursInMs;
            const s = this.formatDigits(parseInt(e / this.minutesInMs, 10));
            e -= s * this.minutesInMs;
            return {
                days: t,
                hours: i,
                minutes: s,
                seconds: this.formatDigits(parseInt(e / this.secondsInMs, 10))
            }
        }
        formatDigits(e) {
            return e < 10 && (e = "0" + e), e
        }
        render(e) {
            this.days.textContent = e.days, this.hours.textContent = e.hours, this.minutes.textContent = e.minutes, this.seconds.textContent = e.seconds
        }
        stopTimer() {
            clearInterval(this.interval)
        }
        onComplete() {
            this.render({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }), this.shouldHideOnComplete && this.shopifySection.classList.add(J), this.shouldShowMessage && this.classList.add(G)
        }
        update() {
            const e = (new Date).getTime(),
                t = this.endDate - e;
            t <= 0 && (this.stopTimer(), this.onComplete());
            const i = this.convertTime(t);
            this.render(i)
        }
        constructor() {
            super(), this.shopifySection = this.closest(V), this.expirationBehavior = this.getAttribute(U), this.time = this.querySelector(W), this.days = this.querySelector(N), this.hours = this.querySelector(R), this.minutes = this.querySelector(j), this.seconds = this.querySelector(z), this.endDate = Date.parse(this.time.dateTime), this.daysInMs = 864e5, this.hoursInMs = this.daysInMs / 24, this.minutesInMs = this.hoursInMs / 60, this.secondsInMs = this.minutesInMs / 60, this.shouldHideOnComplete = this.expirationBehavior === Q, this.shouldShowMessage = this.expirationBehavior === Y, this.update = this.update.bind(this)
        }
    };
    window.addEventListener("resize", (() => {
        x && window.cancelAnimationFrame(x), x = window.requestAnimationFrame(T(q, 50))
    })),
        function () {
            let e;
            window.addEventListener("scroll", (function () {
                e && window.cancelAnimationFrame(e), e = window.requestAnimationFrame(O)
            }), {
                passive: !0
            }), window.addEventListener("theme:scroll:lock", H), window.addEventListener("theme:scroll:unlock", F)
        }(), g(document), document.addEventListener("load", (e => {
            ! function (e) {
                "IMG" == e.tagName && e.parentNode.classList.contains("loading-shimmer") && e.parentNode.classList.remove("loading-shimmer")
            }(e.target)
        }), !0), window.addEventListener("DOMContentLoaded", (() => {
            v(), m(document), f(document), p(document), window.theme.settings.animate_scroll && e.refresh()
        })), window.addEventListener("load", (() => {
            k(document), g(document)
        })), document.addEventListener("shopify:section:load", (t => {
            const i = t.target;
            m(i), f(i), p(i), k(i), window.theme.settings.animate_scroll && e.refresh()
        })), document.addEventListener("shopify:section:reorder", (() => {
            document.dispatchEvent(new CustomEvent("theme:header:check", {
                bubbles: !1
            }))
        })), customElements.get("countdown-timer") || customElements.define("countdown-timer", K);
    const X = (e, t = !1, i = "block") => {
        e && (t ? e.style.removeProperty("display") : e.style.display = i)
    };

    function Z(e) {
        this.status = e.status || null, this.headers = e.headers || null, this.json = e.json || null, this.body = e.body || null
    }
    Z.prototype = Error.prototype;
    const ee = "data-scrollbar-slider",
        te = "[data-scrollbar-arrow-prev]",
        ie = "[data-scrollbar-arrow-next]",
        se = "is-hidden",
        re = 200;
    let ne = class {
        init() {
            this.arrowNext && this.arrowPrev && (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events())
        }
        resize() {
            document.addEventListener("theme:resize", (() => {
                window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow()
            }))
        }
        events() {
            this.arrowNext.addEventListener("click", (e => {
                e.preventDefault(), this.goToNext()
            })), this.arrowPrev.addEventListener("click", (e => {
                e.preventDefault(), this.goToPrev()
            })), this.scrollbar.addEventListener("scroll", (() => {
                this.togglePrevArrow(), this.toggleNextArrow()
            }))
        }
        goToNext() {
            const e = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
            this.move(e), this.arrowPrev.classList.remove(se), this.toggleNextArrow()
        }
        goToPrev() {
            const e = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
            this.move(e), this.arrowNext.classList.remove(se), this.togglePrevArrow()
        }
        toggleNextArrow() {
            setTimeout((() => {
                window.isRTL ? this.arrowNext.classList.toggle(se, 0 === this.scrollbar.scrollLeft) : this.arrowNext.classList.toggle(se, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }), re)
        }
        togglePrevArrow() {
            setTimeout((() => {
                window.isRTL ? this.arrowPrev.classList.toggle(se, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth) : this.arrowPrev.classList.toggle(se, this.scrollbar.scrollLeft <= 0)
            }), re)
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (e => {
                e.addEventListener("click", (t => {
                    ("a" === t.target.tagName.toLowerCase() || t.currentTarget && "a" === t.currentTarget.tagName.toLowerCase() || t.currentTarget && t.currentTarget.querySelector("a")) && t.preventDefault(), this.move(e.offsetLeft - e.clientWidth)
                }))
            }))
        }
        move(e) {
            this.scrollbar.scrollTo({
                top: 0,
                left: e,
                behavior: "smooth"
            })
        }
        constructor(e) {
            this.scrollbar = e, this.arrowNext = this.scrollbar.parentNode.querySelector(ie), this.arrowPrev = this.scrollbar.parentNode.querySelector(te), this.init(), this.resize(), this.scrollbar.hasAttribute(ee) && this.scrollToVisibleElement()
        }
    };
    const oe = "[data-sibling-inner]";
    let ae = class {
        init() {
            this.siblings.forEach((e => {
                new ne(e)
            }))
        }
        constructor(e) {
            this.siblings = e.querySelectorAll(oe), this.init()
        }
    };
    const le = {
        onLoad() {
            new ae(this.container)
        }
    },
        ce = {
            expires: 7,
            path: "/",
            domain: window.location.hostname
        };
    let he = class {
        write(e) {
            document.cookie = `${this.options.name}=${e}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`
        }
        read() {
            let e = [];
            const t = document.cookie.split("; ").find((e => e.startsWith(this.options.name)));
            if (-1 !== document.cookie.indexOf("; ") && t) {
                const t = document.cookie.split("; ").find((e => e.startsWith(this.options.name))).split("=")[1];
                null !== t && (e = t.split(","))
            }
            return e
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`
        }
        remove(e) {
            const t = this.read(),
                i = t.indexOf(e); - 1 !== i && (t.splice(i, 1), this.write(t))
        }
        constructor(e = {}) {
            this.options = {
                ...ce,
                ...e
            }
        }
    };
    const de = 4,
        ue = 10,
        pe = "[data-recently-viewed-products]",
        me = "data-limit",
        fe = "[data-recent-link-tab]",
        ge = "[data-recent-wrapper]",
        ye = "[data-recently-viewed-tab]",
        ve = "[data-tabs-holder-scroll]",
        be = "[data-api-content]",
        we = "data-minimum",
        Se = "data-item-id",
        Ee = "hide",
        Le = "section-without-title--skip",
        ke = {
            expires: 90,
            name: "shopify_recently_viewed"
        },
        Te = [],
        xe = [];

    const _e = {
        onLoad() {
            Te[this.id] = new class {

                renderProducts() {
                    const e = this.cookie.read(),
                        t = [];

                    let i = 0;

                    if (e.length > 0) {

                        for (let s = 0; s < e.length; s++) {
                            const r = e[s];

                            if (xe.includes(r)) continue;

                            const n = `${window.theme.routes.root_url}products/${r}?section_id=api-product-grid-item`;

                            if (
                                t.push(n),
                                i++,
                                i === this.howManyToShow || i === e.length - 1
                            ) break;
                        }

                        if (t.length > 0 && t.length >= this.minimum) {

                            this.container.classList.remove(Ee);

                            if (
                                this.recentViewedLink &&
                                this.recentViewedLink.previousElementSibling
                            ) {
                                this.tabsHolderScroll.classList.remove(Ee);
                                this.container.classList.add(Le);
                            }

                            const e = t.map((e =>
                                fetch(e, {
                                    mode: "no-cors"
                                }).then(this.handleErrors)
                            )),
                                i = [];

                            Promise.allSettled(e)
                                .then((e =>
                                    Promise.all(
                                        e.map((async e => {
                                            if ("fulfilled" === e.status) {
                                                i.push(await e.value.text());
                                            }
                                        }))
                                    )
                                ))
                                .then((() => {

                                    i.forEach((e => {

                                        const t = document.createElement("div"),
                                            i = document.createElement("div");

                                        t.innerHTML = e;

                                        const productItem = t.querySelector(`[${Se}]`);

                                        if ("" === productItem.getAttribute(Se)) return;

                                        const productContent = t.querySelector(be);

                                        /* Exclude products with "engraving" tag from recently viewed */
                                        const productTags = productContent?.getAttribute("data-product-tags") || "";

                                        if (productTags.includes("engraving")) return;

                                        i.classList.add("product-grid-slide");
                                        i.setAttribute("data-carousel-slide", null);
                                        i.setAttribute("data-item", null);

                                        i.innerHTML = productContent.innerHTML;

                                        this.wrapper.appendChild(i);

                                    }));

                                    new ae(this.container);

                                }))
                                .then((() => {

                                    X(this.wrapper, !0);

                                    this.container.dispatchEvent(
                                        new CustomEvent("theme:recent-products:added", {
                                            bubbles: !0
                                        })
                                    );

                                }));

                        } else if (this.recentViewedTab) {

                            const e = Array.prototype.filter.call(
                                this.recentViewedTab.parentNode.children,
                                (e => e !== this.recentViewedTab)
                            ).length > 1;

                            if (
                                this.recentViewedLink &&
                                this.recentViewedLink.previousElementSibling
                            ) {
                                this.tabsHolderScroll.classList.add(Ee);
                                this.container.classList.remove(Le);
                            }

                            e || this.container.classList.add(Ee);

                        } else {

                            this.container.classList.add(Ee);

                        }
                    }
                }

                handleErrors(e) {
                    return e.ok ?
                        e :
                        e.text().then((function (t) {
                            throw new Z({
                                status: e.statusText,
                                headers: e.headers,
                                text: t
                            });
                        }));
                }

                constructor(e) {

                    this.container = e.container;
                    this.cookie = new he(ke);
                    this.wrapper = this.container.querySelector(pe);

                    if (null !== this.wrapper) {

                        this.howManyToShow =
                            parseInt(
                                this.container.querySelector(ge).getAttribute(me)
                            ) || de;

                        this.minimum = parseInt(
                            this.container.querySelector(ge).getAttribute(we)
                        );

                        this.recentViewedTab = this.container.querySelector(ye);

                        this.recentViewedLink =
                            this.container.querySelector(fe);

                        this.tabsHolderScroll =
                            this.container.querySelector(ve);

                        this.renderProducts();
                    }
                }

            }(this);
        }
    };

    function Ae() {
        const e = "(any-pointer: coarse)",
            t = `(max-width: ${window.theme.sizes.medium}px)`,
            i = `(min-width: ${window.theme.sizes.medium + 1}px) and (max-width: ${window.theme.sizes.large}px)`,
            s = `(min-width: ${window.theme.sizes.large + 1}px)`;
        Ae.isTouch = () => {
            const t = window.matchMedia(e).matches;
            return document.documentElement.classList.toggle("supports-touch", t), t
        }, Ae.isMobile = () => window.matchMedia(t).matches, Ae.isTablet = () => window.matchMedia(i).matches, Ae.isDesktop = () => window.matchMedia(s).matches;
        const r = [
            [e, Ae.isTouch],
            [t, Ae.isMobile],
            [i, Ae.isTablet],
            [s, Ae.isDesktop]
        ];
        Ae.onChange = e => {
            r.forEach((t => {
                window.matchMedia(t[0]).addEventListener("change", (() => {
                    t[1]() && e && e()
                }))
            }))
        }
    }

    function qe() {
        this.entries = []
    }

    function Ce(e, t) {
        Pe(e);
        var i = function (e, t) {
            Pe(e),
                function (e) {
                    if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
                    if (0 === e.length) throw new Error(e + " is empty.");
                    if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
                    if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.")
                }(t);
            var i = [];
            return t.forEach((function (t) {
                for (var s = 0; s < e.options.length; s++) {
                    if ((e.options[s].name || e.options[s]).toLowerCase() === t.name.toLowerCase()) {
                        i[s] = t.value;
                        break
                    }
                }
            })), i
        }(e, t);
        return function (e, t) {
            return Pe(e),
                function (e) {
                    if (Array.isArray(e) && "object" == typeof e[0]) throw new Error(e + "is not a valid array of options.")
                }(t), e.variants.filter((function (e) {
                    return t.every((function (t, i) {
                        return e.options[i] === t
                    }))
                }))[0] || null
        }(e, i)
    }

    function Pe(e) {
        if ("object" != typeof e) throw new TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.")
    }
    Ae(), qe.prototype.add = function (e, t, i) {
        this.entries.push({
            element: e,
            event: t,
            fn: i
        }), e.addEventListener(t, i)
    }, qe.prototype.removeAll = function () {
        this.entries = this.entries.filter((function (e) {
            return e.element.removeEventListener(e.event, e.fn), !1
        }))
    };
    var $e = '[name="id"]',
        Ie = '[name="selling_plan"]',
        Me = '[name^="options"]',
        De = '[name="quantity"]',
        Oe = '[name^="properties"]';
    const He = {};

    function Fe(e = {}) {
        if (e.type || (e.type = "json"), e.url) return He[e.url] ? He[e.url] : function (e, t) {
            const i = new Promise(((i, s) => {
                "text" === t ? fetch(e).then((e => e.text())).then((e => {
                    i(e)
                })).catch((e => {
                    s(e)
                })) : function (e, t, i) {
                    let s = document.getElementsByTagName("head")[0],
                        r = !1,
                        n = document.createElement("script");
                    n.src = e, n.onload = n.onreadystatechange = function () {
                        r || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? i() : (r = !0, t())
                    }, s.appendChild(n)
                }(e, (function () {
                    i()
                }), (function () {
                    s()
                }))
            }));
            return He[e] = i, i
        }(e.url, e.type);
        if (e.json) {
            if (He[e.json]) return Promise.resolve(He[e.json]);
            {
                const t = window.fetch(e.json).then((e => e.json())).then((t => (He[e.json] = t, t))).catch((t => {
                    He[e.json] = null
                }));
                return He[e.json] = t, t
            }
        }
        if (e.name) {
            const t = "".concat(e.name, e.version);
            return He[t] ? He[t] : function (e) {
                const t = "".concat(e.name, e.version),
                    i = new Promise(((t, i) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: e.name,
                                version: e.version,
                                onLoad: e => {
                                    ! function (e, t, i) {
                                        i ? t(i) : e()
                                    }(t, i, e)
                                }
                            }])
                        } catch (e) {
                            i(e)
                        }
                    }));
                return He[t] = i, i
            }(e)
        }
        return Promise.reject()
    }
    const Be = "[data-swapper-wrapper]",
        We = "[data-swapper-target]",
        Ne = "data-swapper-hover";
    let Re = {};

    function je(e) {
        Re[e.id] = [];
        e.querySelectorAll(Be).forEach((t => {
            Re[e.id].push(new class {
                init() {
                    this.hovers.forEach((e => {
                        e.addEventListener("mouseenter", function () {
                            const t = e.getAttribute(Ne);
                            this.target.innerHTML = `${t}`
                        }.bind(this))
                    })), this.hovers.forEach((e => {
                        e.addEventListener("mouseleave", function () {
                            this.target.innerHTML = this.deafaultContent
                        }.bind(this))
                    })), this.hovers.forEach((e => {
                        e.addEventListener("click", function () {
                            const t = e.getAttribute(Ne);
                            this.deafaultContent = `${t}`
                        }.bind(this))
                    }))
                }
                constructor(e) {
                    this.container = e, this.target = this.container.querySelector(We), this.hovers = this.container.querySelectorAll(`[${Ne}]`), this.target && this.hovers.length && (this.deafaultContent = this.target.innerHTML, this.init())
                }
            }(t))
        }))
        Re[""].forEach((event) => {
            if (event.hovers) {
                event.hovers.forEach((event1) => {
                    event1.addEventListener("click", function (event2) {

                    });
                });
            }
        });
    }
    const ze = {
        onLoad() {
            je(this.container)
        }
    },
        Ve = {
            color: "ash"
        },
        Ue = "data-swatch",
        Ge = "[data-grid-item]",
        Je = "data-grid-image-default",
        Qe = "data-grid-image-target",
        Ye = "data-swatch-image",
        Ke = "data-swatch-image-id",
        Xe = "data-swatch-variant",
        Ze = "[data-grid-swatches]",
        et = "[data-swatch-template]",
        tt = "data-swatch-handle",
        it = "data-swatch-label",
        st = "is-fade";
    let rt = class extends HTMLElement {
        init() {
            this.setStyles(), this.variant && this.outer && this.outer.addEventListener("theme:quickview:media", (e => {
                e && e.detail && e.detail.media && (this.media = e.detail.media)
            }))
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", ``), this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"))
        }
        replaceImage() {
            if (this.imageReplace && this.imageSlide && this.imageId) {
                if (this.imageSlide.hasAttribute(Qe) && this.imageSlide.getAttribute(Qe) !== this.imageId) {
                    this.imageSlide.classList.add(st);
                    const e = 1e3 * parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                    setTimeout((() => {
                        this.imageSlide.classList.remove(st)
                    }), e)
                }
                this.imageSlide.setAttribute(Qe, this.imageId), this.imageSlide.style.setProperty("background-color", "#fff"), this.imageSlide.hasAttribute(Je) || this.imageSlide.setAttribute(Je, window.getComputedStyle(this.imageSlide).backgroundImage), this.imageSlide.style.setProperty("background-image", this.imageReplace)
            }
        }
        constructor() {
            super(), this.element = this.querySelector(`[${Ue}]`), this.colorString = this.element.getAttribute(Ue), this.image = this.element.getAttribute(Ye), this.imageId = this.element.getAttribute(Ke), this.variant = this.element.getAttribute(Xe), this.outer = this.element.closest(Ge), this.media = null, this.imageSlide = null, this.imageDefault = null, this.stopSlideAnimation = !1;
            const e = new class {
                getColor() {
                    return this.match
                }
                init() {
                    return Fe({
                        json: window.theme.assets.swatches
                    }).then((e => this.matchColors(e, this.settings.color))).catch((e => {
                        console.log("failed to load swatch colors script"), console.log(e)
                    }))
                }
                matchColors(e, t) {
                    let i = "#E5E5E5",
                        s = null;
                    const r = window.theme.assets.base || "/",
                        n = t.toLowerCase().replace(/\s/g, ""),
                        o = e.colors;
                    if (o) {
                        const e = e => Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n,
                            t = o.findIndex(e);
                        if (t > -1) {
                            const e = Object.values(o[t])[0],
                                n = e.toLowerCase();
                            n.includes(".jpg") || n.includes(".jpeg") || n.includes(".png") || n.includes(".svg") ? (s = `${r}${encodeURIComponent(e)}`, i = "#888888") : i = e
                        }
                    }
                    return {
                        color: this.settings.color,
                        path: s,
                        hex: i
                    }
                }
                constructor(e = {}) {
                    this.settings = {
                        ...Ve,
                        ...e
                    }, this.match = this.init()
                }
            }({
                color: this.colorString
            });
            e.getColor().then((e => {
                this.colorMatch = e, this.init()
            }))
        }
    };

    function nt(e) {
        e.querySelectorAll(Ze).forEach((e => {
            new class {
                init() {
                    this.wrap.innerHTML = "", this.swatches.forEach(((e, t) => {
                        let i = this.product.variants.find((t => t.options.includes(e)));
                        const s = i.featured_media ? i.featured_media.preview_image.src : "",
                            r = i.featured_media ? i.featured_media.id : "",
                            n = Math.floor(9999 * Math.random());
                        this.wrap.innerHTML += u.render(this.template, {
                            color: e,
                            uniq: `${this.product.id}-${i.id}-${n}`,
                            variant: i.id,
                            product_id: this.product.id,
                            image_id: r,
                            image: s,
                            index: t
                        })
                    })), new ne(this.wrap)
                }
                constructor(e) {
                    this.template = document.querySelector(et).innerHTML, this.wrap = e, this.handle = e.getAttribute(tt);
                    const t = e.getAttribute(it).trim().toLowerCase();
                    (function (e) {
                        const t = `${window.theme.routes.root_url}products/${e}.js`;
                        return window.fetch(t).then((e => e.json())).catch((e => {
                            console.error(e)
                        }))
                    })(this.handle).then((e => {
                        this.product = e, this.colorOption = e.options.find((function (e) {
                            return e.name.toLowerCase() === t || null
                        })), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                    }))
                }
            }(e)
        }))
    }
    const ot = {
        onLoad() {
            nt(this.container), je(this.container)
        }
    },
        at = "[data-custom-scrollbar-items]",
        lt = "[data-custom-scrollbar]",
        ct = "[data-custom-scrollbar-track]",
        ht = "hide",
        dt = {};
    let ut = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)), this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)), document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)), document.addEventListener("theme:resize:width", this.calculatePosition.bind(this))
        }
        calculateTrackWidth() {
            const e = document.createElement("div");
            this.holderItems.prepend(e), e.style.display = "none", e.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer");
            const t = parseInt(getComputedStyle(e).getPropertyValue("width"));
            this.holderItems.firstChild.remove(), this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth, setTimeout((() => {
                const e = this.children[0].clientWidth,
                    i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                    s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                this.scrollWidth = this.children.length * (e + i + s) + t - i, this.trackWidth = (this.scrollbarWidth + t) / this.scrollWidth * 100, this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth, this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                const r = Math.ceil(this.trackWidth) >= 100;
                this.scrollbar.classList.toggle(ht, r)
            }), 100)
        }
        calculatePosition() {
            let e = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            e *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth, e = e < 0 ? 0 : e, e = isNaN(e) ? 0 : e, this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`), document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", {
                bubbles: !0,
                detail: {
                    holder: this.holderItems
                }
            }))
        }
        constructor(e, t = null) {
            this.holderItems = e.querySelector(at), this.scrollbar = e.querySelector(lt), this.scrollbarTrack = e.querySelector(ct), this.trackWidth = 0, this.scrollWidth = 0, this.scrollbar && this.holderItems && (this.children = t || this.holderItems.children, this.events(), this.calculateTrackWidth())
        }
    };
    const pt = {
        onLoad() {
            dt[this.id] = new ut(this.container)
        }
    },
        mt = "[data-carousel]",
        ft = "data-carousel-progress",
        gt = "[data-carousel-slide]",
        yt = "[data-grid-slide]",
        vt = "product-grid-item-variant:not([hidden]) [data-grid-slide]",
        bt = "[data-wrapper]",
        wt = "[data-carousel-track]",
        St = "data-options",
        Et = "data-custom-scrollbar-items",
        Lt = ".flickity-button.previous",
        kt = ".flickity-button.next",
        Tt = "data-recently-viewed-products",
        xt = "data-related-products",
        _t = "[data-section-id]",
        At = "flickity-force-arrows-top",
        qt = "not-moved-arrows",
        Ct = "hide",
        Pt = "flickity-enabled",
        $t = "hidden-arrows",
        It = "flickity-static",
        Mt = 112;
    let Dt = class extends HTMLElement {
        connectedCallback() {
            this.carousel = this.container.querySelector(mt), this.carouselTrack = this.container.querySelector(wt), this.wrapper = this.container.closest(bt), this.section = this.container.closest(_t), this.slidesVisible = null, this.carouselInstance = null, this.carouselPrev = null, this.carouselNext = null, this.customOptions = {}, this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier(), this.carousel && this.carousel.hasAttribute(Tt) ? this.section.addEventListener("theme:recent-products:added", (() => {
                this.init()
            })) : this.carousel && this.carousel.hasAttribute(xt) ? this.section.addEventListener("theme:related-products:added", (() => {
                this.init()
            })) : this.init()
        }
        init() {
            this.carousel && (this.slidesTotal = this.carousel.querySelectorAll(gt).length, this.getGridLayout(), this.trackVisibleSlides(), this.carousel.hasAttribute(St) && (this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(St)))), this.initCarousel(), this.calculatedArrowsTopPosition(), this.toggleWrapperModifier(), document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent), this.carousel.hasAttribute(ft) && this.progressBarCalculate(), this.carousel.hasAttribute(Et) && new ut(this.container))
        }
        initCarousel() {
            this.options = {
                accessibility: !0,
                contain: !0,
                freeScroll: !0,
                prevNextButtons: !0,
                wrapArround: !1,
                groupCells: !1,
                autoPlay: !1,
                pageDots: !1,
                cellAlign: window.isRTL ? "right" : "left",
                rightToLeft: window.isRTL,
                dragThreshold: 10,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 67.5,
                    y2: 42.5,
                    x3: 25
                },
                on: {
                    resize: () => {
                        this.toggleArrows(), this.calculatedArrowsTopPosition(), setTimeout((() => {
                            this.visibleSlides()
                        }), 100)
                    }
                },
                ...this.customOptions
            }, this.carouselInstance = new s(this.carousel, this.options), this.carouselPrev = this.carousel.querySelector(Lt), this.carouselNext = this.carousel.querySelector(kt), this.container.addEventListener("theme:tab:change", (() => {
                this.carouselInstance.resize(), this.carouselPrev = this.carousel.querySelector(Lt), this.carouselNext = this.carousel.querySelector(kt)
            })), this.carouselInstance.on("dragStart", (() => {
                this.carouselInstance.slider.style.pointerEvents = "none", Ae.isMobile || this.containDrag()
            })), this.carouselInstance.on("dragEnd", (() => {
                this.carouselInstance.slider.style.pointerEvents = "auto", Ae.isMobile || this.containDrag()
            })), this.carouselInstance.on("change", (e => this.lockArrows(e))), setTimeout((() => {
                this.visibleSlides()
            }), 100), Shopify.designMode && setTimeout((() => {
                this.carouselInstance.options.watchCSS && !this.carousel.classList.contains(Pt) ? (this.carouselInstance.destroy(), this.carouselInstance = new s(this.carousel, this.options), this.carouselInstance.resize(), this.carouselPrev = this.carousel.querySelector(Lt), this.carouselNext = this.carousel.querySelector(kt)) : this.carouselInstance.resize()
            }), 10), this.carousel.classList.toggle(It, this.smallItems === this.carousel.querySelectorAll(gt).length), nt(this.container), new ae(this.container)
        }
        calculatedArrowsTopPosition() {
            const e = this.container.querySelector(yt),
                t = this.container.querySelector(vt);
            if (t) {
                const e = t.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${e}px`)
            } else if (e) {
                const t = e.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${t}px`)
            }
        }
        toggleWrapperModifier() {
            if (!this.wrapper) return;
            const e = Number(getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width").replace("px", "")),
                t = this.wrapper.clientWidth;
            this.wrapperWidthWithGutter = t + Mt + e, window.innerWidth >= this.wrapperWidthWithGutter && (this.wrapper.classList.remove(At), this.section.classList.add(qt)), window.innerWidth < this.wrapperWidthWithGutter && (this.wrapper.classList.add(At), this.section.classList.remove(qt))
        }
        progressBarCalculate() {
            null !== this.carouselInstance && this.carouselTrack && this.carouselInstance.on("scroll", (e => {
                e = 100 * Math.max(0, Math.min(1, e)) + "%", this.carouselTrack.style.width = e
            }))
        }
        getGridLayout() {
            this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3, this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) || this.largeItems, this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) || this.mediumItems || this.largeItems
        }
        visibleSlides() {
            if (!this.carousel) return;
            this.getGridLayout();
            const e = this.carousel.clientWidth || this.carouselInstance.size.width,
                t = null !== this.carouselInstance && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(gt).clientWidth,
                i = null !== this.carouselInstance && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(gt).length,
                s = Math.floor(e / t);
            this.section.classList.remove($t), this.carouselPrev && this.carouselNext && (this.carouselPrev.classList.remove(Ct), this.carouselNext.classList.remove(Ct)), window.innerWidth > window.theme.sizes.large && !this.options.groupCells && s <= this.largeItems && i <= this.largeItems && this.carouselPrev && this.carouselNext && this.hideArrows(), window.innerWidth >= window.theme.sizes.medium && window.innerWidth <= window.theme.sizes.large && !this.options.groupCells && s <= this.mediumItems && i <= this.mediumItems && this.carouselPrev && this.carouselNext && this.hideArrows(), window.innerWidth < window.theme.sizes.medium && !this.options.groupCells && s <= this.smallItems && i <= this.smallItems && this.carouselPrev && this.carouselNext && this.hideArrows()
        }
        trackVisibleSlides() {
            const e = window.matchMedia(`(max-width: ${window.theme.sizes.medium - 1}px)`),
                t = window.matchMedia(`(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large - 1}px)`),
                i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
            e.addEventListener("change", (e => {
                !e.matches || (this.slidesVisible = this.smallItems)
            })), !e.matches || (this.slidesVisible = this.smallItems), t.addEventListener("change", (e => {
                !e.matches || (this.slidesVisible = this.mediumItems)
            })), !t.matches || (this.slidesVisible = this.mediumItems), i.addEventListener("change", (e => {
                !e.matches || (this.slidesVisible = this.largeItems)
            })), !i.matches || (this.slidesVisible = this.largeItems)
        }
        containDrag() {
            const e = this.slidesTotal - this.slidesVisible;
            this.carouselInstance.selectedIndex >= e && (this.carouselInstance.select(e), this.lockArrows(this.carouselInstance.selectedIndex))
        }
        lockArrows(e) {
            if (this.options.wrapAround || this.options.groupCells) return;
            const t = parseInt(e),
                i = this.slidesTotal - this.slidesVisible;
            this.carouselNext.disabled = t >= i
        }
        showArrows() {
            this.carouselPrev.classList.remove(Ct), this.carouselNext.classList.remove(Ct), this.section.classList.remove($t)
        }
        hideArrows() {
            this.carouselPrev.classList.add(Ct), this.carouselNext.classList.add(Ct), this.section.classList.add($t)
        }
        toggleArrows() {
            this.carouselPrev && this.carouselNext && (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows())
        }
        constructor() {
            super(), this.container = this
        }
    };
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", Dt);
    const Ot = "[data-address-wrapper]",
        Ht = "[data-new-address-form]",
        Ft = "[new-address-form-inner]",
        Bt = ".address-new-toggle",
        Wt = ".address-edit-toggle",
        Nt = ".address-delete",
        Rt = "hide",
        jt = "data-form-id",
        zt = "data-confirm-message",
        Vt = "Are you sure you wish to delete this address?",
        Ut = "#EditAddress",
        Gt = "AddressCountryNew",
        Jt = "AddressProvinceNew",
        Qt = "AddressProvinceContainerNew",
        Yt = ".address-country-option",
        Kt = "AddressCountry",
        Xt = "AddressProvince",
        Zt = "AddressProvinceContainer";
    const ei = document.querySelector(Ot);
    ei && new class {
        init() {
            if (this.addressNewForm) {
                const e = this.section,
                    t = this.addressNewForm.querySelector(Ft);
                this.customerAddresses();
                const i = e.querySelectorAll(Bt);
                i.length && i.forEach((e => {
                    e.addEventListener("click", (function () {
                        t.classList.toggle(Rt)
                    }))
                }));
                const s = e.querySelectorAll(Wt);
                s.length && s.forEach((t => {
                    t.addEventListener("click", (function () {
                        const t = this.getAttribute(jt);
                        e.querySelector(`${Ut}_${t}`).classList.toggle(Rt)
                    }))
                }));
                const r = e.querySelectorAll(Nt);
                r.length && r.forEach((e => {
                    e.addEventListener("click", (function () {
                        const e = this.getAttribute(jt),
                            t = this.getAttribute(zt);
                        confirm(t || Vt) && Shopify.postLink(window.theme.routes.account_addresses_url + "/" + e, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
                }))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(Gt, Jt, {
                hideElement: Qt
            }), this.section.querySelectorAll(Yt).forEach((e => {
                const t = e.getAttribute(jt),
                    i = `${Kt}_${t}`,
                    s = `${Xt}_${t}`,
                    r = `${Zt}_${t}`;
                new Shopify.CountryProvinceSelector(i, s, {
                    hideElement: r
                })
            }))
        }
        constructor(e) {
            this.section = e, this.addressNewForm = this.section.querySelector(Ht), this.init()
        }
    }(ei), document.querySelector("#RecoverPassword") && function () {
        var e = {
            recoverPasswordForm: "#RecoverPassword",
            hideRecoverPasswordLink: "#HideRecoverPasswordLink"
        };

        function t(e) {
            e.preventDefault(), s()
        }

        function i() {
            "#recover" === window.location.hash && s()
        }

        function s() {
            var e = document.querySelector("#CustomerEmail").value;
            document.querySelector("#RecoverEmail").value = e, document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"), document.querySelector("#CustomerLoginForm").classList.toggle("display-none")
        }

        function r() {
            document.querySelector(".reset-password-success") && document.querySelector("#ResetSuccess").classList.remove("display-none")
        }
        i(), r(), document.querySelector(e.recoverPasswordForm).addEventListener("click", t), document.querySelector(e.hideRecoverPasswordLink).addEventListener("click", t)
    }(), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const ti = window.Shopify.theme.sections.registered,
        ii = window.Shopify.theme.sections.instances,
        si = "data-section-id",
        ri = "data-section-type";
    let ni = class {
        callFunctions(e, t = null) {
            this.callStack[e].forEach((e => {
                const i = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                t ? e.call(i, t) : e.call(i)
            }))
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(e) {
            this.callFunctions("onSelect", e)
        }
        onDeselect(e) {
            this.callFunctions("onDeselect", e)
        }
        onBlockSelect(e) {
            this.callFunctions("onBlockSelect", e)
        }
        onBlockDeselect(e) {
            this.callFunctions("onBlockDeselect", e)
        }
        onReorder(e) {
            this.callFunctions("onReorder", e)
        }
        constructor(e, t) {
            this.container = function (e) {
                if (!(e instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === e.getAttribute(si)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + si + " attribute.");
                return e
            }(e), this.id = e.getAttribute(si), this.type = t.type, this.callStack = t.getStack();
            try {
                this.onLoad()
            } catch (e) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.error(e)
            }
        }
    };

    function oi(e, t) {
        if ("string" != typeof e) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== ti[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(t) || (t = [t]);
        const i = new class {
            getStack() {
                return this.callStack
            }
            constructor(e = null, t = []) {
                this.type = e, this.components = function (e) {
                    if (void 0 !== e && "object" != typeof e || null === e) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return e
                }(t), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, t.forEach((e => {
                    for (const [t, i] of Object.entries(e)) {
                        const e = this.callStack[t];
                        Array.isArray(e) && "function" == typeof i ? e.push(i) : (console.warn(`Unregisted function: '${t}' in component: '${this.type}'`), console.warn(i))
                    }
                }))
            }
        }(e, t);
        return ti[e] = i, ti
    }

    function ai(e, t) {
        e = hi(e), void 0 === t && (t = document.querySelectorAll("[" + ri + "]")), t = di(t), e.forEach((function (e) {
            const i = ti[e];
            void 0 !== i && (t = t.filter((function (t) {
                return !(li(t).length > 0) && (null !== t.getAttribute(ri) && (t.getAttribute(ri) !== e || (ii.push(new ni(t, i)), !1)))
            })))
        }))
    }

    function li(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
        if (e instanceof Element || i instanceof Element) di(e).forEach((function (e) {
            t = t.concat(ii.filter((function (t) {
                return t.container === e
            })))
        }));
        else if ("string" == typeof e || "string" == typeof i) {
            hi(e).forEach((function (e) {
                t = t.concat(ii.filter((function (t) {
                    return t.type === e
                })))
            }))
        }
        return t
    }

    function ci(e) {
        for (var t, i = 0; i < ii.length; i++)
            if (ii[i].id === e) {
                t = ii[i];
                break
            } return t
    }

    function hi(e) {
        return "*" === e ? e = Object.keys(ti) : "string" == typeof e ? e = [e] : e.constructor === ni ? e = [e.prototype.type] : Array.isArray(e) && e[0].constructor === ni && (e = e.map((function (e) {
            return e.type
        }))), e = e.map((function (e) {
            return e.toLowerCase()
        }))
    }

    function di(e) {
        return NodeList.prototype.isPrototypeOf(e) && e.length > 0 ? e = Array.prototype.slice.call(e) : NodeList.prototype.isPrototypeOf(e) && 0 === e.length || null === e ? e = [] : !Array.isArray(e) && e instanceof Element && (e = [e]), e
    }

    function ui(e, t) {
        t = t || {}, e.focus(), void 0 !== t.className && e.classList.add(t.className), e.addEventListener("blur", (function i(s) {
            s.target.removeEventListener(s.type, i), void 0 !== t.className && e.classList.remove(t.className)
        }))
    }

    function pi(e) {
        e = e || {};
        var t = window.location.hash,
            i = document.getElementById(t.slice(1));
        if (i && e.ignore && i.matches(e.ignore)) return !1;
        t && i && ui(i, e)
    }

    function mi(e) {
        return e = e || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function (t) {
            if ("#" === t.hash || "" === t.hash) return !1;
            if (e.ignore && t.matches(e.ignore)) return !1;
            if (i = t.hash.substr(1), null === document.getElementById(i)) return !1;
            var i, s = document.querySelector(t.hash);
            return !!s && (t.addEventListener("click", (function () {
                ui(s, e)
            })), !0)
        }))
    }

    function fi(e) {
        return Array.prototype.slice.call(e.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter((function (e) {
            return Boolean(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
        }))
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function (e) {
        var t = e.detail.sectionId,
            i = e.target.querySelector("[" + si + '="' + t + '"]');
        null !== i && ai(i.getAttribute(ri), i)
    })), document.addEventListener("shopify:section:reorder", (function (e) {
        var t = e.detail.sectionId,
            i = e.target.querySelector("[" + si + '="' + t + '"]');
        "object" == typeof li(i)[0] && li(i).forEach((function (e) {
            e.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function (e) {
        var t = e.detail.sectionId,
            i = e.target.querySelector("[" + si + '="' + t + '"]');
        "object" == typeof li(i)[0] && li(i).forEach((function (e) {
            var t = ii.map((function (e) {
                return e.id
            })).indexOf(e.id);
            ii.splice(t, 1), e.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function (e) {
        var t = ci(e.detail.sectionId);
        "object" == typeof t && t.onSelect(e)
    })), document.addEventListener("shopify:section:deselect", (function (e) {
        var t = ci(e.detail.sectionId);
        "object" == typeof t && t.onDeselect(e)
    })), document.addEventListener("shopify:block:select", (function (e) {
        var t = ci(e.detail.sectionId);
        "object" == typeof t && t.onBlockSelect(e)
    })), document.addEventListener("shopify:block:deselect", (function (e) {
        var t = ci(e.detail.sectionId);
        "object" == typeof t && t.onBlockDeselect(e)
    })));
    var gi = {};

    function yi(e, t) {
        t = t || {};
        var i = fi(e),
            s = t.elementToFocus || e,
            r = i[0],
            n = i[i.length - 1];
        vi(), gi.focusin = function (t) {
            e !== t.target && !e.contains(t.target) && r && r === t.target && r.focus(), t.target !== e && t.target !== n && t.target !== r || document.addEventListener("keydown", gi.keydown)
        }, gi.focusout = function () {
            document.removeEventListener("keydown", gi.keydown)
        }, gi.keydown = function (t) {
            "Tab" === t.code && (t.target !== n || t.shiftKey || (t.preventDefault(), r.focus()), t.target !== e && t.target !== r || !t.shiftKey || (t.preventDefault(), n.focus()))
        }, document.addEventListener("focusout", gi.focusout), document.addEventListener("focusin", gi.focusin), ui(s, t)
    }

    function vi() {
        document.removeEventListener("focusin", gi.focusin), document.removeEventListener("focusout", gi.focusout), document.removeEventListener("keydown", gi.keydown)
    }
    var bi = Object.freeze({
        __proto__: null,
        forceFocus: ui,
        focusHash: pi,
        bindInPageLinks: mi,
        focusable: fi,
        trapFocus: yi,
        removeTrapFocus: vi,
        accessibleLinks: function (e, t) {
            if ("string" != typeof e) throw new TypeError(e + " is not a String.");
            if (0 !== (e = document.querySelectorAll(e)).length) {
                (t = t || {}).messages = t.messages || {};
                var i, s, r, n = {
                    newWindow: t.messages.newWindow || "Opens in a new window.",
                    external: t.messages.external || "Opens external website.",
                    newWindowExternal: t.messages.newWindowExternal || "Opens external website in a new window."
                },
                    o = t.prefix || "a11y",
                    a = {
                        newWindow: o + "-new-window-message",
                        external: o + "-external-message",
                        newWindowExternal: o + "-new-window-external-message"
                    };
                e.forEach((function (e) {
                    var t = e.getAttribute("target"),
                        i = e.getAttribute("rel"),
                        s = function (e) {
                            return e.hostname !== window.location.hostname
                        }(e),
                        r = "_blank" === t,
                        n = null === i || -1 === i.indexOf("noopener");
                    if (r && n) {
                        var o = null === i ? "noopener" : i + " noopener";
                        e.setAttribute("rel", o)
                    }
                    s && r ? e.setAttribute("aria-describedby", a.newWindowExternal) : s ? e.setAttribute("aria-describedby", a.external) : r && e.setAttribute("aria-describedby", a.newWindow)
                })), i = n, s = document.createElement("ul"), r = Object.keys(i).reduce((function (e, t) {
                    return e + "<li id=" + a[t] + ">" + i[t] + "</li>"
                }), ""), s.setAttribute("hidden", !0), s.innerHTML = r, document.body.appendChild(s)
            }
        }
    });
    const wi = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';

    function Si(e) {
        const t = `data-popup-${e}`;
        n.init({
            openTrigger: t,
            disableScroll: !0,
            onShow: (e, t, i) => {
                i.preventDefault();
                const s = e.querySelector(wi);
                yi(e, {
                    elementToFocus: s
                })
            },
            onClose: (e, t, i) => {
                i.preventDefault(), vi(), t.focus()
            }
        })
    }
    const Ei = "[data-toggle-password-modal]",
        Li = ".storefront-password-form .errors",
        ki = {};
    oi("password", {
        onLoad() {
            ki[this.id] = new class {
                init() {
                    Si("password"), this.errors && this.trigger.click()
                }
                constructor(e) {
                    this.container = e.container, this.trigger = this.container.querySelector(Ei), this.errors = this.container.querySelector(Li), this.init()
                }
            }(this)
        }
    }),
        function () {
            var e = "#QrCode",
                t = ".giftcard__code";
            const i = document.querySelector(e);
            if (i) {
                function r() {
                    const e = i.getAttribute("data-identifier");
                    new QRCode(i, {
                        text: e,
                        width: 120,
                        height: 120
                    })
                }
                window.addEventListener("load", r)
            }
            const s = document.querySelector(t);
            if (s) {
                function n() {
                    var e = document.querySelector("#GiftCardDigits"),
                        t = "";
                    if (document.body.createTextRange) (t = document.body.createTextRange()).moveToElementText(e), t.select();
                    else if (window.getSelection) {
                        var i = window.getSelection();
                        (t = document.createRange()).selectNodeContents(e), i.removeAllRanges(), i.addRange(t)
                    }
                }
                s.addEventListener("click", n())
            }
        }();
    const Ti = "[data-parallax-wrapper]",
        xi = "[data-parallax-img]";
    let _i = {};
    const Ai = {
        onLoad() {
            _i[this.id] = [];
            this.container.querySelectorAll(Ti).forEach((e => {
                const t = e.querySelector(xi);
                _i[this.id].push(new o(t, {
                    center: !0,
                    round: !0,
                    frame: e
                }))
            }))
        },
        onUnload: function () {
            _i[this.id].forEach((e => {
                "function" == typeof e.destroy && e.destroy()
            }))
        }
    };
    oi("article", Ai);
    const qi = "[data-ticker-frame]",
        Ci = "[data-ticker-scale]",
        Pi = "[data-ticker-text]",
        $i = "data-clone",
        Ii = "aria-hidden",
        Mi = "ticker--animated",
        Di = "ticker--unloaded",
        Oi = "ticker__comparitor",
        Hi = {};
    let Fi = class {
        init() {
            this.addComparitor(), this.resizeEvent = T((() => this.checkWidth()), 300), this.listen()
        }
        addComparitor() {
            this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(Oi), this.frame.appendChild(this.comparitor), this.scale.classList.remove(Di)
        }
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent)
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth()
        }
        checkWidth() {
            const e = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
            if (Array.from(this.text.parentNode.children).forEach((e => {
                e.classList.add(Mi)
            })), this.frame.clientWidth - e < this.comparitor.clientWidth || this.stopClone) {
                if (1 === this.scale.childElementCount && (this.clone = this.text.cloneNode(!0), this.clone.setAttribute(Ii, !0), this.clone.setAttribute($i, ""), this.scale.appendChild(this.clone), this.stopClone))
                    for (let e = 0; e < 10; e++) {
                        const e = this.text.cloneNode(!0);
                        e.setAttribute(Ii, !0), e.setAttribute($i, ""), this.scale.appendChild(e)
                    }
                const e = this.text.clientWidth / this.space * this.timeIndex;
                this.scale.style.setProperty("--animation-time", `${e}s`)
            } else {
                let e = this.scale.querySelector(`[${$i}]`);
                e && this.scale.removeChild(e), this.text.classList.remove(Mi)
            }
        }
        constructor(e, t = !1) {
            this.frame = e, this.stopClone = t, this.scale = this.frame.querySelector(Ci), this.text = this.frame.querySelector(Pi), this.space = 100, this.timeIndex = 1.63, this.init()
        }
    };
    const Bi = {
        onLoad() {
            Hi[this.id] = [];
            this.container.querySelectorAll(qi).forEach((e => {
                Hi[this.id].push(new Fi(e))
            }))
        },
        onUnload() {
            Hi[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        }
    },
        Wi = "[data-ticker-frame]",
        Ni = "data-slide",
        Ri = "[data-ticker-scale]",
        ji = "[data-ticker-text]",
        zi = "ticker--animated",
        Vi = {};
    oi("logos", {
        onLoad() {
            Vi[this.id] = [], Vi[this.id].push(new class {
                init() {
                    this.initTickers(!0)
                }
                initTickers(e = !1) {
                    const t = this.container.querySelector(Wi);
                    t && new Fi(t, e)
                }
                toggleTicker(e, t) {
                    const i = this.container.querySelector(Ri),
                        s = this.container.querySelector(`[${Ni}="${e.detail.blockId}"]`);
                    if (s && i) {
                        if (t) {
                            const e = Number(getComputedStyle(s).getPropertyValue("--gutter").replace("px", "")),
                                t = -(s.offsetLeft - e);
                            i.setAttribute("data-stop", ""), i.querySelectorAll(ji).forEach((e => {
                                e.classList.remove(zi), e.style.transform = `translate3d(${t}px, 0, 0)`
                            }))
                        }
                        t || (i.querySelectorAll(ji).forEach((e => {
                            e.classList.add(zi), e.removeAttribute("style")
                        })), i.removeAttribute("data-stop"))
                    }
                }
                onBlockSelect(e) {
                    this.toggleTicker(e, !0)
                }
                onBlockDeselect(e) {
                    this.toggleTicker(e, !1)
                }
                constructor(e) {
                    this.container = e.container, this.init()
                }
            }(this))
        },
        onBlockSelect(e) {
            Vi[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }))
        },
        onBlockDeselect(e) {
            Vi[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockDeselect(e)
            }))
        }
    }), oi("blog", Ai);
    var Ui = "[data-drawer]",
        Gi = "[data-drawer-scrolls]",
        Ji = "[data-predictive-search-input]",
        Qi = "[data-drawer-underlay]",
        Yi = "[data-stagger-animation]",
        Ki = "data-drawer-toggle",
        Xi = ":scope > * > [data-animates]",
        Zi = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        es = "drawer--visible",
        ts = "display-none",
        is = {};
    const ss = {
        onLoad() {
            is[this.id] = [];
            this.container.querySelectorAll(Ui).forEach((e => {
                is[this.id].push(new class {
                    unload() { }
                    connectToggle() {
                        this.buttons.forEach((e => {
                            e.addEventListener("click", function (e) {
                                e.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                    bubbles: !1
                                }))
                            }.bind(this))
                        }))
                    }
                    connectDrawer() {
                        this.drawer.addEventListener("theme:drawer:toggle", function () {
                            this.drawer.classList.contains(es) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                                bubbles: !1
                            })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                bubbles: !1
                            }))
                        }.bind(this)), this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)), this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this))
                    }
                    staggerChildAnimations() {
                        this.staggers.forEach((e => {
                            e.querySelectorAll(Xi).forEach(((e, t) => {
                                e.style.transitionDelay = 50 * t + 10 + "ms"
                            }))
                        }))
                    }
                    closers() {
                        this.drawer.addEventListener("keyup", function (e) {
                            "Escape" === e.code && (this.hideDrawer(), this.buttons[0].focus())
                        }.bind(this)), this.underlay.addEventListener("click", function () {
                            this.hideDrawer()
                        }.bind(this))
                    }
                    focusFirst() {
                        const e = this.drawer.querySelector(Ji);
                        if (e) e.focus();
                        else {
                            const e = this.drawer.querySelector(Zi);
                            yi(this.drawer, {
                                elementToFocus: e
                            })
                        }
                    }
                    showDrawer() {
                        this.drawer.classList.remove(ts), setTimeout((() => {
                            this.buttons.forEach((e => e.setAttribute("aria-expanded", !0))), this.drawer.classList.add(es), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                bubbles: !0,
                                detail: this.drawerScrolls
                            })), this.drawer.addEventListener("transitionend", this.focusFirst.bind(this), {
                                once: !0
                            }), this.drawer.addEventListener("transitioncancel", this.focusFirst.bind(this), {
                                once: !0
                            })

                        }), 1500)
                    }
                    hideDrawer() {
                        window.theme.state.cartOpen = !1, this.buttons.forEach((e => e.setAttribute("aria-expanded", !0))), this.drawer.classList.remove(es), this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })), document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                            bubbles: !1
                        })), vi(), setTimeout((() => {
                            this.drawer.classList.contains(es) || this.drawer.classList.add(ts)
                        }), 800)
                    }
                    constructor(e) {
                        this.drawer = e, this.drawerScrolls = this.drawer.querySelector(Gi), this.underlay = this.drawer.querySelector(Qi), this.key = this.drawer.dataset.drawer;
                        const t = `[${Ki}='${this.key}']`;
                        this.buttons = document.querySelectorAll(t), this.staggers = this.drawer.querySelectorAll(Yi), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations()
                    }
                }(e))
            }))
        },
        onUnload: function () {
            is[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        }
    },
        rs = "[data-announcement-bar]",
        ns = "data-header-transparent",
        os = "[data-header-wrapper] header",
        as = "js__header__stuck",
        ls = "js__header__stuck--animated",
        cs = "js__header__stuck--trigger-animation",
        hs = "js__header__stuck__backdrop";
    let ds = {};
    const us = {
        onLoad() {
            ds = new class {
                unload() {
                    document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional)
                }
                listen() {
                    (this.sticks || this.animated) && document.addEventListener("theme:scroll", (e => {
                        e.detail.down ? (!this.currentlyStuck && e.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && e.detail.position > this.blur && this.addBlur()) : (e.detail.position <= this.stickUp && this.unstickSimple(), e.detail.position <= this.blur && this.removeBlur())
                    })), this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)))
                }
                stickSimple() {
                    this.animated && this.cls.add(ls), this.cls.add(as), this.wrapper.setAttribute(ns, !1), this.currentlyStuck = !0
                }
                unstickSimple() {
                    this.cls.remove(as), this.wrapper.setAttribute(ns, this.transparent), this.animated && this.cls.remove(ls), this.currentlyStuck = !1
                }
                scrollDownInit() {
                    window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur()
                }
                stickDirectional() {
                    this.cls.add(cs)
                }
                unstickDirectional() {
                    this.cls.remove(cs)
                }
                scrollDownDirectional() {
                    this.unstickDirectional()
                }
                scrollUpDirectional() {
                    window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional()
                }
                addBlur() {
                    this.cls.add(hs), this.currentlyBlurred = !0
                }
                removeBlur() {
                    this.cls.remove(hs), this.currentlyBlurred = !1
                }
                constructor(e) {
                    this.wrapper = e, this.type = this.wrapper.dataset.headerSticky, this.transparent = this.wrapper.dataset.headerTransparent, this.sticks = "sticky" === this.type, this.animated = "directional" === this.type, this.currentlyStuck = !1, this.cls = this.wrapper.classList;
                    const t = document.querySelector(rs),
                        i = t ? t.clientHeight : 0,
                        s = document.querySelector(os).clientHeight;
                    this.blur = s + i, this.stickDown = s + i, this.stickUp = i, "false" !== this.wrapper.getAttribute(ns) && (this.blur = i), this.sticks && (this.stickDown = i, this.scrollDownInit()), this.listen()
                }
            }(this.container)
        },
        onUnload: function () {
            "function" == typeof ds.unload && ds.unload()
        }
    },
        ps = "data-hover-disclosure-toggle",
        ms = "[data-hover-disclosure]",
        fs = "[data-top-link]",
        gs = "[data-header-wrapper]",
        ys = "[data-stagger]",
        vs = "[data-stagger-first]",
        bs = "[data-stagger-second]",
        ws = "[data-grid-item], [data-header-image]",
        Ss = "is-visible",
        Es = "meganav--visible",
        Ls = "grandparent";
    let ks = {},
        Ts = {};
    const xs = {
        onLoad() {
            ks[this.id] = [], Ts = this.container.querySelectorAll(ms), Ts.forEach((e => {
                ks[this.id].push(new class {
                    onBlockSelect(e) {
                        this.disclosure.contains(e.target) && this.showDisclosure()
                    }
                    onBlockDeselect(e) {
                        this.disclosure.contains(e.target) && this.hideDisclosure()
                    }
                    showDisclosure() {
                        this.grandparent ? this.wrapper.classList.add(Es) : this.wrapper.classList.remove(Es), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(Ss), this.disclosure.classList.add(Ss)
                    }
                    hideDisclosure() {
                        this.disclosure.classList.remove(Ss), this.trigger.classList.remove(Ss), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Es)
                    }
                    staggerChildAnimations() {
                        this.disclosure.querySelectorAll(ys).forEach(((e, t) => {
                            e.style.transitionDelay = 50 * t + 10 + "ms"
                        })), this.disclosure.querySelectorAll(vs).forEach(((e, t) => {
                            const i = 150 * t;
                            e.style.transitionDelay = `${i}ms`, e.parentElement.querySelectorAll(bs).forEach(((e, t) => {
                                const s = 20 * (t + 1);
                                e.style.transitionDelay = `${i + s}ms`
                            }))
                        })), this.disclosure.querySelectorAll(ws).forEach(((e, t) => {
                            e.style.transitionDelay = 80 * (t + 1) + "ms"
                        }))
                    }
                    handleTablets() {
                        this.trigger.addEventListener("touchstart", function (e) {
                            this.disclosure.classList.contains(Ss) || (e.preventDefault(), this.showDisclosure())
                        }.bind(this), {
                            passive: !0
                        })
                    }
                    connectHoverToggle() {
                        this.trigger.addEventListener("pointerenter", this.showDisclosure.bind(this)), this.link.addEventListener("focus", this.showDisclosure.bind(this)), this.trigger.addEventListener("pointerleave", this.hideDisclosure.bind(this)), this.trigger.addEventListener("focusout", function (e) {
                            this.trigger.contains(e.relatedTarget) || this.hideDisclosure()
                        }.bind(this)), this.disclosure.addEventListener("keyup", function (e) {
                            "Escape" === e.code && this.hideDisclosure()
                        }.bind(this))
                    }
                    constructor(e) {
                        this.disclosure = e, this.wrapper = e.closest(gs), this.key = this.disclosure.id;
                        const t = `[${ps}='${this.key}']`;
                        this.trigger = document.querySelector(t), this.link = this.trigger.querySelector(fs), this.grandparent = this.trigger.classList.contains(Ls), this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                    }
                }(e))
            }))
        },
        onBlockSelect(e) {
            ks[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }))
        },
        onBlockDeselect(e) {
            ks[this.id].forEach((t => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            }))
        },
        onUnload: function () {
            ks[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        }
    },
        _s = "[data-main-menu-text-item]",
        As = "[data-text-items-wrapper]",
        qs = ".navtext",
        Cs = "data-menu-active",
        Ps = "[data-header-wrapper]",
        $s = "data-underline-current",
        Is = ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
    let Ms = {},
        Ds = null;
    const Os = {
        onLoad() {
            Ms[this.id] = [];
            this.container.querySelectorAll(As).forEach((e => {
                Ms[this.id].push(new class {
                    init() {
                        if (this.itemList.length) {
                            if (this.listen(), this.listenResize(), this.textBottom = null, this.setHeight(), Ds) {
                                if (this.defaultItem) {
                                    const e = this.defaultItem.offsetLeft || 0;
                                    this.sectionOuter.style.setProperty("--bar-left", `${e}px`)
                                }
                                this.reset()
                            } else {
                                const e = this.sectionOuter.querySelector(_s).offsetLeft;
                                this.sectionOuter.style.setProperty("--bar-left", `${e}px`), this.sectionOuter.style.setProperty("--bar-width", "0px")
                            }
                            this.sectionOuter.style.setProperty("--bar-opacity", "1")
                        }
                    }
                    unload() {
                        document.removeEventListener("theme:resize", this.reset), Ds = null
                    }
                    listenResize() {
                        document.addEventListener("theme:resize", this.reset.bind(this))
                    }
                    setDefault() {
                        this.defaultItem && (Ds = {
                            left: this.defaultItem.offsetLeft || null,
                            width: this.defaultItem.clientWidth || null
                        })
                    }
                    setHeight() {
                        const e = this.wrapper.clientHeight,
                            t = this.itemList[0].querySelector(qs).clientHeight,
                            i = Math.floor(e / 2 - t / 2) - 4;
                        this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-text", `${t}px`), this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`), this.textBottom = i)
                    }
                    listen() {
                        this.itemList.forEach((e => {
                            e.addEventListener("pointerenter", (e => {
                                const t = e.target.querySelector(qs);
                                this.startBar(t)
                            }))
                        })), this.wrapper.addEventListener("pointerleave", this.clearBar.bind(this))
                    }
                    startBar(e) {
                        this.setHeight();
                        let t = "false" !== this.sectionOuter.getAttribute(Cs),
                            i = e.offsetLeft,
                            s = e.clientWidth;
                        t ? this.render(s, i) : (this.sectionOuter.setAttribute(Cs, !0), this.render(0, i), setTimeout((() => {
                            this.render(s, i)
                        }), 10))
                    }
                    render(e, t) {
                        this.sectionOuter.style.setProperty("--bar-left", `${t}px`), this.sectionOuter.style.setProperty("--bar-width", `${e}px`)
                    }
                    reset() {
                        this.setDefault(), Ds && Ds.left && Ds.width ? (this.sectionOuter.style.setProperty("--bar-left", `${Ds.left}px`), this.sectionOuter.style.setProperty("--bar-width", `${Ds.width}px`)) : this.sectionOuter.style.setProperty("--bar-width", "0px")
                    }
                    clearBar() {
                        this.sectionOuter.setAttribute(Cs, !1), setTimeout((() => {
                            "false" !== this.sectionOuter.getAttribute(Cs) || this.reset()
                        }), 150)
                    }
                    constructor(e) {
                        this.wrapper = e, this.itemList = this.wrapper.querySelectorAll(_s), this.sectionOuter = document.querySelector(Ps), this.underlineCurrent = "true" === this.sectionOuter.getAttribute($s), this.defaultItem = null, this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(Is)), this.setDefault(), document.fonts.ready.then((() => {
                            this.init()
                        }))
                    }
                }(e))
            }))
        },
        onUnload: function () {
            Ms[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            })), delete Ms[this.id]
        }
    },
        Hs = "data-header-cart-price",
        Fs = "data-header-cart-count",
        Bs = "data-header-cart-full";
    const Ws = {
        onLoad() {
            new class {
                listen() {
                    document.addEventListener("theme:cart:change", function (e) {
                        this.cart = e.detail.cart, this.update()
                    }.bind(this))
                }
                update() {
                    this.cart && (this.prices.forEach((e => {
                        e.setAttribute(Hs, this.cart.total_price);
                        const t = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                        e.innerHTML = t
                    })), this.counts.forEach((e => {
                        e.setAttribute(Fs, this.cart.item_count), e.innerHTML = `(${this.cart.item_count})`
                    })), this.dots.forEach((e => {
                        const t = this.cart.item_count > 0;
                        e.setAttribute(Bs, t)
                    })))
                }
                constructor(e) {
                    this.section = e, this.counts = this.section.querySelectorAll(`[${Fs}]`), this.prices = this.section.querySelectorAll(`[${Hs}]`), this.dots = this.section.querySelectorAll(`[${Bs}]`), this.cart = null, this.listen()
                }
            }(this.container)
        }
    },
        Ns = "[data-search-popdown-wrap]",
        Rs = "data-popdown-toggle",
        js = "[data-close-popdown]",
        zs = "[data-predictive-search-input]",
        Vs = "[data-search-underlay]",
        Us = "underlay--visible",
        Gs = "is-visible";
    let Js = {};
    const Qs = {
        onLoad() {
            Js[this.id] = {};
            const e = this.container.querySelector(`[${Rs}]`);
            e && (Js[this.id] = new class {
                initTriggerEvents() {
                    this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.trigger.addEventListener("click", function (e) {
                        e.preventDefault(), this.showPopdown()
                    }.bind(this)), this.trigger.addEventListener("keyup", function (e) {
                        "Space" === e.code && this.showPopdown()
                    }.bind(this))
                }
                initPopdownEvents() {
                    this.popdown.addEventListener("keyup", function (e) {
                        "Escape" === e.code && this.hidePopdown()
                    }.bind(this)), this.close.addEventListener("click", function () {
                        this.hidePopdown()
                    }.bind(this)), this.underlay.addEventListener("click", function () {
                        this.hidePopdown()
                    }.bind(this))
                }
                hidePopdown() {
                    this.popdown.classList.remove(Gs), this.underlay.classList.remove(Us), this.trigger.focus(), vi(), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                showPopdown() {
                    this.popdown.classList.add(Gs), this.underlay.classList.add(Us), yi(this.popdown, {
                        elementToFocus: this.input
                    }), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    }))
                }
                constructor(e) {
                    this.trigger = e, this.key = this.trigger.getAttribute(Rs), this.popdown = document.querySelector(`[id='${this.key}']`), this.input = this.popdown.querySelector(zs), this.close = this.popdown.querySelector(js), this.wrapper = this.popdown.closest(Ns), this.underlay = this.wrapper.querySelector(Vs), this.initTriggerEvents(), this.initPopdownEvents()
                }
            }(e))
        },
        onUnload: function () {
            "function" == typeof Js[this.id].unload && Js[this.id].unload()
        }
    },
        Ys = "[data-product-add-popdown-wrapper]",
        Ks = "[data-close-popdown]",
        Xs = "[data-api-content]",
        Zs = '[data-ajax-disable="false"]',
        er = '[data-ajax-disable="true"]',
        tr = '[data-drawer-toggle="drawer-cart"]',
        ir = '[data-drawer="drawer-cart"]',
        sr = "is-visible";
    let rr;
    const nr = {
        onLoad() {
            new class {
                renderPopdown(e) {
                    const t = e.detail.variant,
                        i = `${window.theme.routes.root_url}variants/${t.id}/?section_id=api-product-popdown`,
                        s = this;
                    l.get(i).then((function (e) {
                        const t = document.createElement("div");
                        t.innerHTML = e.data, s.drawer.innerHTML = t.querySelector(Xs).innerHTML, s.connectCartButton(), s.connectCloseButton()
                    })).catch((function (e) {
                        console.warn(e)
                    }))
                }
                connectCloseButton() {
                    this.drawer.classList.add(sr), this.drawer.querySelector(Ks).addEventListener("click", function (e) {
                        e.preventDefault(), this.drawer.classList.remove(sr)
                    }.bind(this)), this.popdownTimer()
                }
                connectCartButton() {
                    const e = this.drawer.querySelector(tr),
                        t = document.querySelector(ir);
                    t && e.addEventListener("click", function (e) {
                        e.preventDefault(), this.drawer.classList.remove(sr), t.dispatchEvent(new CustomEvent("theme:drawer:open", {
                            bubbles: !1
                        }))
                    }.bind(this))
                }
                popdownTimer() {
                    clearTimeout(rr), rr = setTimeout((() => {
                        this.drawer.classList.remove(sr)
                    }), 5e3)
                }
                constructor() {
                    this.drawer = document.querySelector(Ys), this.cartAjaxEnabled = document.querySelector(Zs), this.cartAjaxDisabled = document.querySelector(er), document.addEventListener("theme:cart:popdown", (e => {
                        this.cartAjaxEnabled ? this.cartAjaxEnabled.dispatchEvent(new CustomEvent("theme:cart:reload", {
                            bubbles: !0
                        })) : this.cartAjaxDisabled ? window.location.reload() : this.renderPopdown(e)
                    }))
                }
            }(this)
        }
    },
        or = "data-grid-item-variant";
    let ar = class extends HTMLElement {
        connectedCallback() {
            this.gridItemVariantLinks.length && this.gridItemVariantLinks.forEach((e => {
                e.hasAttribute(or) && (this.swatchHoverEvent(e), this.swatchClickEvent(e))
            }))
        }
        swatchHoverEvent(e) {
            e.addEventListener("mouseenter", (() => {
                if (e.hasAttribute(or)) {
                    const t = e.getAttribute(or);
                    this.container.querySelectorAll(`product-grid-item-variant[${or}="${t}"] product-grid-item-image`).forEach((e => {
                        e.setAttribute("loading", "eager")
                    }))
                }
            }))
        }
        swatchClickEvent(e) {
            e.addEventListener("click", (t => {
                if (t.preventDefault(), this.container.querySelectorAll(`a[${or}]`).forEach((e => e.removeAttribute("aria-selected"))), e.setAttribute("aria-selected", "true"), e.hasAttribute(or)) {
                    const t = e.getAttribute(or);
                    this.container.querySelectorAll(`product-grid-item-variant[${or}]`).forEach((e => {
                        e.getAttribute(or) === t ? e.removeAttribute("hidden") : e.setAttribute("hidden", "")
                    }))
                }
            }))
        }
        constructor() {
            super(), this.container = this, this.gridItemVariantLinks = this.container.querySelectorAll(`a[${or}]`)
        }
    };
    const lr = "[data-grid-link]",
        cr = "data-grid-images",
        hr = "data-grid-image",
        dr = "data-grid-image-target",
        ur = "data-grid-current-image",
        pr = "data-grid-pagination",
        mr = "data-grid-page",
        fr = "data-slide-for-filter-selected-variant",
        gr = "data-slide-for-variant-media",
        yr = "data-slideshow-style",
        vr = "--width",
        br = "is-active",
        wr = "is-mobile",
        Sr = "product-grid-item__pagination";
    let Er = class extends HTMLElement {
        static get observedAttributes() {
            return ["hidden"]
        }
        preloadImage(e) {
            if (this.isMobile) return;
            const t = [...this.images][e];
            if (!t) throw new Error(`No child element at index ${e}`);
            t.setAttribute("loading", "eager")
        }
        preloadImages() {
            [...this.imagesHolder.children].forEach(((e, t) => this.preloadImage(t)))
        }
        connectedCallback() {
            this.toggleMobile(), document.addEventListener("theme:resize:width", (() => this.toggleMobile())), this.isMobile || (this.imageCount > 1 && (this.createPaging(), this.container.addEventListener("theme:swatch:change", this.swatchChangeEvent), this.container.addEventListener("mouseenter", this.mouseEnterEvent), this.container.addEventListener("mouseleave", this.mouseLeaveEvent)), this.intersectionObserver.observe(this.container))
        }
        disconnectedCallback() {
            this.container.removeEventListener("theme:swatch:change", this.swatchChangeEvent), this.container.removeEventListener("mouseenter", this.mouseEnterEvent), this.container.removeEventListener("mouseleave", this.mouseLeaveEvent)
        }
        swatchChangeEvent(e) {
            const t = e.detail.id,
                i = this.container.querySelector(`[${dr}="${t}"]`);
            if (i) {
                const t = i.getAttribute(hr);
                this.pagingProgressCounter = 0, this.changeImage(t), e.detail.stopSlideAnimation && this.stopPaging()
            }
        }
        mouseEnterEvent() {
            switch (this.preloadImages(), this.slideshowStyle) {
                case "cycle_images":
                    this.pagingProgressPause = this.isMobile, this.progressPaging();
                    break;
                case "second_immediately":
                    this.changeImage(this.getNextIndex());
                    break;
                case "disabled":
                    break;
                default:
                    throw new Error(`Unknown option ${this.slideshowStyle}`)
            }
        }
        mouseLeaveEvent() {
            this.pagingProgressPause = !0, this.resetSlideshow(), this.progressPaging()
        }
        attributeChangedCallback(e, t, i) {
            "hidden" === e && null == t && null != i && this.showVariant()
        }
        toggleMobile() {
            this.container.classList.toggle(wr, this.isMobile)
        }
        get isMobile() {
            return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < window.theme.sizes.medium
        }
        resetSlideshow() {
            const e = this.container.querySelector(`[${fr}]`);
            if (e) {
                let t = Number(e.getAttribute(hr));
                this.changeImage(t)
            } else this.changeImage(0);
            this.pagingProgressPause = !0
        }
        showVariant() {
            const e = this.container.querySelector(`[${gr}]`);
            if (e) {
                let t = Number(e.getAttribute(hr));
                this.changeImage(t)
            } else this.changeImage(0);
            this.pagingProgressPause = !0
        }
        getNextIndex() {
            let e = this.container.querySelector(`[${hr}][${ur}]`);
            if (e) {
                return (Number(e.getAttribute(hr)) + 1) % this.imageCount
            }
            return 0
        }
        changeImage(e) {
            const t = this.images[e % this.imageCount];
            t && (this.activeImages.forEach((e => e.removeAttribute(ur))), t.setAttribute(ur, "true"), "cycle_images" === this.slideshowStyle && this.changePaging(e))
        }
        changePaging(e = 0) {
            const t = this.container.querySelector(`[${mr}].${br}`),
                i = this.container.querySelector(`[${mr}="${e}"]`);
            t && (t.style.setProperty(vr, "100%"), t.classList.remove(br)), i && (i.classList.add(br), this.progressPaging())
        }
        progressPaging() {
            const e = this.container.querySelector(`[${mr}].${br}`);
            e && !this.isMobile && (this.stopPaging(), 0 === this.pagingProgressCounter && e.style.setProperty(vr, "0%"), this.interval = setInterval((() => {
                this.pagingProgressCounter >= 100 && !this.pagingProgressPause ? (this.stopPaging(), this.pagingProgressCounter = 0, this.changeImage(this.getNextIndex())) : this.pagingProgressPause || (this.pagingProgressCounter++, e.style.setProperty(vr, `${this.pagingProgressCounter}%`))
            }), this.timeout / 100))
        }
        stopPaging() {
            this.interval && clearInterval(this.interval)
        }
        createPaging() {
            if (this.imagesHolder && "cycle_images" === this.slideshowStyle) {
                let e = "";
                for (let t = 0; t < this.imageCount; t++) {
                    let i = "";
                    0 === t && (i = `class="${br}"`), e += `<span ${i} ${mr}="${t}">${t + 1}</span>`
                }
                if ("" !== e) {
                    let t = this.container.querySelector(`[${pr}]`);
                    t || (t = document.createElement("div"), t.className = Sr, t.setAttribute(pr, "")), t.innerHTML = e, this.imagesHolder.parentElement.prepend(t)
                }
            }
        }
        removePaging() {
            const e = this.container.querySelector(`[${pr}]`);
            e && e.remove()
        }
        get imagesHolder() {
            return this.container.querySelector(`[${cr}]`)
        }
        get images() {
            return this.imagesHolder.querySelectorAll(`[${hr}]`)
        }
        get activeImages() {
            return this.imagesHolder.querySelectorAll(`[${hr}][${ur}]`)
        }
        get links() {
            return this.container.querySelectorAll(lr)
        }
        get slideshowStyle() {
            return this.container.getAttribute(yr)
        }
        get imageCount() {
            return this.images.length
        }
        constructor() {
            super(), this.container = this, this.mobileStopSlideshow = "true", this.timeout = 1e3 * window.theme.settings.cycle_images_hover_delay || 1500, this.interval = null, this.pagingProgressPause = !1, this.pagingProgressCounter = 0, this.siblingsFetchCounter = 0, this.siblingLoadImageIndex = null, this.intersectionObserver = new IntersectionObserver((e => {
                e.forEach((e => {
                    e.isIntersecting && this.imageCount > 1 && this.preloadImage(1)
                }))
            }), {
                threshold: .1
            })
        }
    };
    const Lr = "data-grid-current-image",
        kr = "is-active";
    let Tr = class extends HTMLElement {
        static get observedAttributes() {
            return ["loading", Lr]
        }
        connectedCallback() {
            null === this.getAttribute(Lr) ? this.hide() : this.show()
        }
        attributeChangedCallback(e, t, i) {
            switch (e) {
                case "loading":
                    null !== i && "eager" !== i || this.eagerLoad();
                    break;
                case Lr:
                    null === i ? this.hide() : this.show()
            }
        }
        show() {
            this.classList.add(kr)
        }
        hide() {
            this.classList.remove(kr)
        }
        eagerLoad() {
            const e = this.firstElementChild;
            switch (e.nodeName) {
                case "TEMPLATE":
                    const t = e,
                        i = t.content;
                    i.querySelectorAll("img").forEach((e => {
                        e.setAttribute("loading", "eager"), e.setAttribute("fetchpriority", "high")
                    })), t.replaceWith(i);
                    break;
                case "IMG":
                    e.setAttribute("loading", "eager"), e.setAttribute("fetchpriority", "high")
            }
        }
    };
    const xr = "[data-popout]",
        _r = "[data-popout-list]",
        Ar = "data-popout-list-scroll",
        qr = "data-popout-toggle",
        Cr = "[data-popout-input]",
        Pr = "[data-popout-option]",
        $r = "data-popout-prevent",
        Ir = "data-quantity-field",
        Mr = "data-value",
        Dr = "aria-expanded",
        Or = "aria-current",
        Hr = "popout-list--visible",
        Fr = "--current";
    let Br = class extends HTMLElement {
        unload() {
            this.popoutOptions.length && this.popoutOptions.forEach((e => {
                e.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), e.removeEventListener("click", this._connectOptionsDispatch.bind(this))
            })), this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)), this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)), this.container.removeEventListener("keyup", this.containerKeyup.bind(this)), this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)))
        }
        popupToggleClick(e) {
            const t = "true" === e.currentTarget.getAttribute(Dr);
            e.currentTarget.setAttribute(Dr, !t), this.popoutList.classList.toggle(Hr), this.popupListMaxWidth(), this.popoutList.hasAttribute(Ar) && setTimeout((() => {
                this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                }))
            }), 1)
        }
        popupToggleFocusout(e) {
            this.container.contains(e.relatedTarget) || this._hideList()
        }
        popupListFocusout(e) {
            const t = e.currentTarget.contains(e.relatedTarget);
            this.popoutList.classList.contains(Hr) && !t && this._hideList()
        }
        popupListMaxWidth() {
            this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`
        }
        popupOptionsClick(e) {
            if ("#" === e.target.closest(Pr).attributes.href.value) {
                e.preventDefault();
                let t = "";
                if (e.currentTarget.getAttribute(Mr) && (t = e.currentTarget.getAttribute(Mr)), this.popoutInput.value = t, this.popoutPrevent) {
                    this.popoutInput.dispatchEvent(new Event("change")), !e.detail.preventTrigger && this.popoutInput.hasAttribute(Ir) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${Fr}"]`);
                    let s = Fr;
                    if (i && i.classList.length)
                        for (const e of i.classList)
                            if (e.includes(Fr)) {
                                s = e;
                                break
                            } const r = this.popoutList.querySelector(`.${s}`);
                    r && (r.classList.remove(`${s}`), e.currentTarget.parentElement.classList.add(`${s}`));
                    const n = this.popoutList.querySelector(`[${Or}]`);
                    n && n.hasAttribute(`${Or}`) && (n.removeAttribute(`${Or}`), e.currentTarget.setAttribute(`${Or}`, "true")), "" !== t && (this.replaceTextContent(this.popoutToggle, t), this.outsidePopupToggle && this.replaceTextContent(this.outsidePopupToggle, t)), this.popupToggleFocusout(e), this.popupListFocusout(e)
                } else this._submitForm(t)
            }
        }
        replaceTextContent(e, t) {
            Array.from(e.childNodes).forEach((e => {
                e.nodeType === Node.TEXT_NODE && (e.textContent = t)
            }))
        }
        updatePopout(e) {
            const t = this.popoutList.querySelector(`[${Mr}="${this.popoutInput.value}"]`);
            t && t.dispatchEvent(new CustomEvent("theme:popout:click", {
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !0
                }
            }))
        }
        containerKeyup(e) {
            "Escape" === e.code && (this._hideList(), this.popoutToggle.focus())
        }
        bodyClick(e) {
            const t = this.container.contains(e.target),
                i = this.popoutList.classList.contains(Hr);
            this.outsidePopupToggle, e.target, i && !t && this._hideList()
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this))
        }
        _connectOptions() {
            this.popoutOptions.length && this.popoutOptions.forEach((e => {
                e.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), e.addEventListener("click", this._connectOptionsDispatch.bind(this))
            }))
        }
        _connectOptionsDispatch(e) {
            const t = new CustomEvent("theme:popout:click", {
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !1
                }
            });
            e.target.dispatchEvent(t) || e.preventDefault()
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)), this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)), this.container.addEventListener("keyup", this.containerKeyup.bind(this)), document.body.addEventListener("click", this.bodyClick.bind(this))
        }
        _submitForm(e) {
            const t = this.container.closest("form");
            t && t.submit()
        }
        _hideList() {
            this.popoutList.classList.remove(Hr), this.popoutToggle.setAttribute(Dr, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(Dr, !1)
        }
        constructor() {
            super(), this.container = this.querySelector(xr), this.popoutList = this.container.querySelector(_r), this.popoutToggle = this.container.querySelector(`[${qr}]`), this.outsidePopupToggle = document.querySelector(`[${qr}="${this.popoutList.id}"]`), this.popoutInput = this.container.querySelector(Cr), this.popoutOptions = this.container.querySelectorAll(Pr), this.popoutPrevent = "true" === this.container.getAttribute($r), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth(), this.popoutInput && this.popoutInput.hasAttribute(Ir) && document.addEventListener("theme:popout:update", this.updatePopout.bind(this)), document.addEventListener("theme:resize", (() => {
                this.popupListMaxWidth()
            }))
        }
    };
    const Wr = (e, t = 500, i = !0) => {
        let s = window.getComputedStyle(e).display;
        if (i && "none" !== s) return;
        e.style.removeProperty("display"), "none" === s && (s = "block"), e.style.display = s;
        let r = e.offsetHeight;
        e.style.overflow = "hidden", e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0, e.style.marginTop = 0, e.style.marginBottom = 0, e.offsetHeight, e.style.boxSizing = "border-box", e.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)", e.style.transitionProperty = "height, margin, padding", e.style.transitionDuration = t + "ms", e.style.height = r + "px", e.style.removeProperty("padding-top"), e.style.removeProperty("padding-bottom"), e.style.removeProperty("margin-top"), e.style.removeProperty("margin-bottom"), window.setTimeout((() => {
            e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), e.style.removeProperty("transition-timing-function")
        }), t)
    },
        Nr = (e, t = 500) => {
            e.style.transitionProperty = "height, margin, padding", e.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)", e.style.transitionDuration = t + "ms", e.style.boxSizing = "border-box", e.style.height = e.offsetHeight + "px", e.offsetHeight, e.style.overflow = "hidden", e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0, e.style.marginTop = 0, e.style.marginBottom = 0, window.setTimeout((() => {
                e.style.display = "none", e.style.removeProperty("height"), e.style.removeProperty("padding-top"), e.style.removeProperty("padding-bottom"), e.style.removeProperty("margin-top"), e.style.removeProperty("margin-bottom"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), e.style.removeProperty("transition-timing-function")
            }), t)
        },
        Rr = "[data-accordion-group]",
        jr = "data-accordion-trigger",
        zr = "[data-accordion-body]",
        Vr = "data-accordion-body-mobile",
        Ur = "data-range-holder",
        Gr = "[data-section-id]",
        Jr = "accordion-is-open";
    let Qr = {},
        Yr = class {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")), document.addEventListener("theme:resize", (() => {
                    window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"))
                }))
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.setDefaultState(), this.trigger.addEventListener("click", this.toggleEvent), this.body.addEventListener("keyup", this.keyboardEvent), this.body.addEventListener("theme:accordion:close", this.hideEvent)
            }
            hideEvents() {
                this.hideAccordion()
            }
            clickEvents(e) {
                e.preventDefault(), this.toggleState()
            }
            keyboardEvents(e) {
                "Escape" === e.code && (this.hideAccordion(), this.trigger.focus())
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent)
            }
            setDefaultState() {
                this.trigger.classList.contains(Jr) ? X(this.body) : this.hideAccordion()
            }
            getSiblings() {
                const e = [...this.body.closest(Gr).querySelectorAll(Rr)].filter((e => e.contains(this.body))).shift();
                if (e) {
                    return [...e.querySelectorAll(zr)].filter((e => !e.contains(this.body)))
                }
                return []
            }
            closeSiblings() {
                this.syncBodies.forEach((e => {
                    e.dispatchEvent(new CustomEvent("theme:accordion:close", {
                        bubbles: !1
                    }))
                }))
            }
            toggleState() {
                this.trigger.classList.contains(Jr) ? this.hideAccordion() : (this.showAccordion(), this.closeSiblings(), this.body.hasAttribute(Ur) && setTimeout((() => {
                    document.dispatchEvent(new CustomEvent("theme:price-range:reset", {
                        bubbles: !1
                    }))
                }), 400))
            }
            hideAccordion() {
                this.trigger.classList.remove(Jr), Nr(this.body)
            }
            showAccordion() {
                this.trigger.classList.add(Jr), Wr(this.body), setTimeout((() => {
                    this.checkInViewportAndScrollTo()
                }), 600)
            }
            checkInViewportAndScrollTo() {
                const e = this.trigger.getBoundingClientRect(),
                    t = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth) || window.scrollTo({
                    top: t + e.top,
                    left: 0,
                    behavior: "smooth"
                })
            }
            onBlockSelect(e) {
                this.body.contains(e.target) && this.showAccordion()
            }
            onBlockDeselect(e) {
                this.body.contains(e.target) && this.hideAccordion()
            }
            constructor(e) {
                this.body = e, this.key = this.body.id;
                const t = `[${jr}='${this.key}']`;
                this.trigger = document.querySelector(t), this.toggleEvent = e => this.clickEvents(e), this.keyboardEvent = e => this.keyboardEvents(e), this.hideEvent = () => this.hideEvents(), this.syncBodies = this.getSiblings(), this.body.hasAttribute(Vr) ? this.mobileAccordions() : this.init()
            }
        };
    const Kr = {
        onLoad() {
            Qr[this.id] = [];
            this.container.querySelectorAll(zr).forEach((e => {
                Qr[this.id].push(new Yr(e))
            }))
        },
        onUnload: function () {
            Qr[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        },
        onSelect: function () {
            "accordion-single" === this.type && this.container.querySelector(`[${jr}]`).click()
        },
        onDeselect: function () {
            "accordion-single" === this.type && this.container.querySelector(`[${jr}]`).click()
        },
        onBlockSelect(e) {
            Qr[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }))
        },
        onBlockDeselect(e) {
            Qr[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockDeselect(e)
            }))
        }
    },
        Xr = e => {
            e && (e.style.display = "none")
        },
        Zr = 'input[type="search"]',
        en = '[aria-selected="true"] a',
        tn = 'button[type="reset"]',
        sn = "is-hidden";
    let rn = class extends HTMLElement {
        toggleResetButton() {
            const e = this.resetButton.classList.contains(sn);
            this.input.value.length > 0 && e ? this.resetButton.classList.remove(sn) : 0 !== this.input.value.length || e || this.resetButton.classList.add(sn)
        }
        onChange() {
            this.toggleResetButton()
        }
        shouldResetForm() {
            return !document.querySelector(en)
        }
        onFormReset(e) {
            e.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), e.target.querySelector(Zr).focus())
        }
        constructor() {
            super(), this.input = this.querySelector(Zr), this.resetButton = this.querySelector(tn), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", T((e => {
                this.onChange(e)
            }), 300).bind(this)))
        }
    };
    customElements.define("header-search-form", rn);
    const nn = '[role="option"]',
        on = '[aria-selected="true"]',
        an = "predictive-search",
        ln = "[data-predictive-search-results]",
        cn = "[data-predictive-search-status]",
        hn = "[data-predictive-search-input]",
        dn = "[data-predictive-search-live-region-count-value]",
        un = "data-search-results-groups-wrapper",
        pn = "[data-predictive-search-search-for-text]",
        mn = "#shopify-section-predictive-search",
        fn = '[aria-selected="true"] a',
        gn = '[aria-selected="true"] a, button[aria-selected="true"]',
        yn = "[data-loading-indicator]";
    let vn = class extends rn {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            super.onChange();
            const e = this.getQuery();
            var t;
            this.searchTerm && e.startsWith(this.searchTerm) || (null === (t = this.querySelector(un)) || void 0 === t || t.remove());
            this.updateSearchForTerm(this.searchTerm, e), this.searchTerm = e, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset()
        }
        onFormSubmit(e) {
            this.getQuery().length && !this.querySelector(fn) || e.preventDefault()
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(fn)
        }
        onFocus() {
            const e = this.getQuery();
            e.length && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout((() => {
                this.contains(document.activeElement) || this.close()
            }))
        }
        onKeyup(e) {
            switch (this.getQuery().length || this.close(!0), e.preventDefault(), e.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(e) {
            "ArrowUp" !== e.code && "ArrowDown" !== e.code || e.preventDefault()
        }
        updateSearchForTerm(e, t) {
            const i = this.querySelector(pn),
                s = null == i ? void 0 : i.innerText;
            if (s) {
                var r;
                if ((null === (r = s.match(e)) || void 0 === r ? void 0 : r.length) > 1) return;
                const n = s.replace(e, t);
                i.innerText = n
            }
        }
        switchOption(e) {
            if (!this.getAttribute("open")) return;
            const t = "up" === e,
                i = this.querySelector(on),
                s = Array.from(this.querySelectorAll(nn)).filter((e => null !== e.offsetParent));
            let r = 0;
            if (t && !i) return;
            let n = -1,
                o = 0;
            for (; - 1 === n && o <= s.length;) s[o] === i && (n = o), o++;
            if (this.statusElement.textContent = "", !t && i ? r = n === s.length - 1 ? 0 : n + 1 : t && (r = 0 === n ? s.length - 1 : n - 1), r === n) return;
            const a = s[r];
            a.setAttribute("aria-selected", !0), i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id)
        }
        selectOption() {
            const e = this.querySelector(gn);
            e && e.click()
        }
        getSearchResults(e) {
            const t = e.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(), this.cachedResults[t] ? this.renderSearchResults(this.cachedResults[t]) : (X(this.loader), fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then(this.handleErrors).then((e => e.text())).then((e => {
                const i = (new DOMParser).parseFromString(e, "text/html").querySelector(mn).innerHTML;
                this.allPredictiveSearchInstances.forEach((e => {
                    e.cachedResults[t] = i
                })), this.renderSearchResults(i)
            })).catch((e => {
                console.error(e)
            })).finally((() => {
                Xr(this.loader)
            })))
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(cn), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(e) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = e, setTimeout((() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }), 1e3)
        }
        renderSearchResults(e) {
            this.predictiveSearchResults.innerHTML = e, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(dn).textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0
        }
        close(e = !1) {
            this.closeResults(e), this.isOpen = !1
        }
        closeResults(e = !1) {
            var t;
            e && (this.input.value = "", this.removeAttribute("results"));
            const i = this.querySelector(on);
            i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), null === (t = this.predictiveSearchResults) || void 0 === t || t.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus()
        }
        handleErrors(e) {
            return e.ok ? e : e.json().then((function (t) {
                throw new Z({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                })
            }))
        }
        constructor() {
            super(), this.wrapper = this, this.a11y = bi, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(an), this.cachedResults = {}, this.input = this.wrapper.querySelector(hn), this.isOpen = !1, this.predictiveSearchResults = this.querySelector(ln), this.searchTerm = "", this.loader = this.wrapper.querySelector(yn)
        }
    };

    function bn() {
        return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.small
    }
    const wn = 'input[type="search"]';
    let Sn = class extends rn {
        setupEventListeners() {
            let e = [];
            this.allSearchInputs.forEach((t => e.push(t.form))), this.input.addEventListener("focus", this.onInputFocus.bind(this)), e.length < 2 || (e.forEach((e => e.addEventListener("reset", this.onFormReset.bind(this)))), this.allSearchInputs.forEach((e => e.addEventListener("input", this.onInput.bind(this)))))
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(e) {
            const t = e.target;
            this.keepInSync(t.value, t)
        }
        onInputFocus() {
            bn() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(e, t) {
            this.allSearchInputs.forEach((i => {
                i !== t && (i.value = e)
            }))
        }
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll(wn), this.setupEventListeners()
        }
    };
    const En = {
        drawer: "data-drawer-scrolls",
        slideruleOpen: "data-sliderule-open",
        slideruleClose: "data-sliderule-close",
        sliderulePane: "data-sliderule-pane",
        slideruleWrappper: "[data-sliderule]",
        dataAnimates: "data-animates",
        children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *"
    },
        Ln = "is-visible",
        kn = "is-hiding",
        Tn = "is-hidden";
    let xn = {};
    const _n = {
        onLoad() {
            xn[this.id] = [];
            this.container.querySelectorAll(En.slideruleWrappper).forEach((e => {
                xn[this.id].push(new class {
                    clickEvents() {
                        this.trigger.addEventListener("click", function () {
                            this.showSliderule()
                        }.bind(this)), this.exit.forEach((e => {
                            e.addEventListener("click", function () {
                                this.hideSliderule()
                            }.bind(this))
                        }))
                    }
                    keyboardEvents() {
                        this.trigger.addEventListener("keyup", function (e) {
                            "Space" === e.code && this.showSliderule()
                        }.bind(this)), this.sliderule.addEventListener("keyup", function (e) {
                            "Escape" === e.code && (this.hideSliderule(), this.buttons[0].focus())
                        }.bind(this))
                    }
                    staggerChildAnimations(e = !1) {
                        (e ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach(((e, t) => {
                            e.style.transitionDelay = 50 * t + 10 + "ms"
                        }))
                    }
                    hideSliderule(e = !1) {
                        const t = window.getComputedStyle(this.pane),
                            i = 1e3 * parseFloat(t.getPropertyValue("transition-duration")),
                            s = e ? this.pane.querySelectorAll(`.${Ln}`) : this.children;
                        this.pane.style.setProperty("--sliderule-height", "auto"), this.staggerChildAnimations(!0), this.pane.classList.add(kn), this.sliderule.classList.add(kn), this.sliderule.classList.remove(Ln), s.forEach((e => {
                            e.classList.remove(Ln)
                        }));
                        const r = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                        this.pane.setAttribute(En.sliderulePane, r);
                        const n = e ? `[${En.dataAnimates}].${Tn}` : `[${En.dataAnimates}="${r}"].${Tn}`,
                            o = this.pane.querySelectorAll(n);
                        o.length && o.forEach((e => {
                            e.classList.remove(Tn)
                        })), setTimeout((() => {
                            this.pane.classList.remove(kn), this.sliderule.classList.remove(kn), this.staggerChildAnimations()
                        }), i)
                    }
                    showSliderule() {
                        this.pane.style.setProperty("--sliderule-height", "auto"), this.sliderule.classList.add(Ln), this.children.forEach((e => {
                            e.classList.add(Ln)
                        }));
                        const e = parseInt(this.pane.dataset.sliderulePane, 10),
                            t = e + 1;
                        this.pane.setAttribute(En.sliderulePane, t);
                        const i = this.pane.querySelectorAll(`[${En.dataAnimates}="${e}"]`);
                        if (i.length) {
                            const e = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                            setTimeout((() => {
                                i.forEach((e => {
                                    e.classList.add(Tn)
                                }))
                            }), e)
                        }
                        const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                        this.pane.style.setProperty("--sliderule-height", `${s}px`);
                        const r = this.drawer.scrollTop,
                            n = this.pane.offsetTop;
                        n < r && this.pane.offsetHeight >= this.drawer.offsetHeight && this.drawer.scrollTo({
                            top: n,
                            left: 0,
                            behavior: "smooth"
                        })
                    }
                    closeSliderule() {
                        this.pane && this.pane.hasAttribute(En.sliderulePane) && parseInt(this.pane.getAttribute(En.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(En.sliderulePane)) > 0 && this.pane.setAttribute(En.sliderulePane, 0))
                    }
                    constructor(e) {
                        this.sliderule = e, this.wrapper = e.closest(En.wrapper), this.key = this.sliderule.id;
                        const t = `[${En.slideruleOpen}='${this.key}']`,
                            i = `[${En.slideruleClose}='${this.key}']`;
                        this.trigger = document.querySelector(t), this.drawer = document.querySelector(`[${En.drawer}]`), this.exit = document.querySelectorAll(i), this.pane = document.querySelector(`[${En.sliderulePane}]`), this.children = this.sliderule.querySelectorAll(En.children), this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.clickEvents(), this.staggerChildAnimations(), document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this))
                    }
                }(e))
            }))
        }
    },
        An = "[data-takes-space]",
        qn = "[data-header-desktop]",
        Cn = "js__header__clone",
        Pn = "js-show-mobile",
        $n = "[data-header-backfill]",
        In = "data-header-transparent",
        Mn = "header-override-border",
        Dn = ".main-content > .shopify-section:first-child [data-overlay-header]",
        On = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        Hn = '.navlink[href="#"]',
        Fn = "has-overlay";
    let Bn = {};
    oi("header", [{
        onLoad() {
            Bn = new class {
                unload() {
                    document.removeEventListener("theme:resize", this.checkWidth)
                }
                checkForImage() {
                    this.overlayedImages = document.querySelectorAll(Dn);
                    let e = document.querySelectorAll(On).length;
                    this.overlayedImages.length && !e && this.transparent ? (document.querySelector($n).style.display = "none", this.listenOverlay()) : this.wrapper.setAttribute(In, !1), !this.overlayedImages.length || e || this.transparent || (this.wrapper.classList.add(Mn), this.subtractHeaderHeight())
                }
                listenOverlay() {
                    document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight()
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth()
                }
                killDeadLinks() {
                    this.deadLinks.forEach((e => {
                        e.onclick = e => {
                            e.preventDefault()
                        }
                    }))
                }
                subtractAnnouncementHeight() {
                    const {
                        windowHeight: e,
                        announcementHeight: t
                    } = y();
                    this.overlayedImages.forEach((i => {
                        i.style.setProperty("--full-screen", e - t + "px"), i.classList.add(Fn)
                    }))
                }
                subtractHeaderHeight() {
                    const {
                        windowHeight: e,
                        headerHeight: t
                    } = y();
                    this.overlayedImages.forEach((i => {
                        i.style.setProperty("--full-screen", e - t + "px")
                    }))
                }
                checkWidth() {
                    document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(Pn) : this.wrapper.classList.remove(Pn)
                }
                getMinWidth() {
                    const e = this.wrapper.cloneNode(!0);
                    e.classList.add(Cn), document.body.appendChild(e);
                    const t = e.querySelectorAll(An);
                    let i = 0;
                    return i = 3 === t.length ? function (e) {
                        let t = [];
                        return e.forEach((e => {
                            t.push(e.clientWidth)
                        })), t[0] > t[2] ? t[2] = t[0] : t[0] = t[2], t.reduce(((e, t) => e + t))
                    }(t) : function (e) {
                        let t = 0;
                        return e.forEach((e => {
                            t += e.clientWidth
                        })), t
                    }(t), document.body.removeChild(e), i + 20 * t.length
                }
                constructor(e) {
                    this.wrapper = e, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(qn), this.transparent = "false" !== this.wrapper.getAttribute(In), this.overlayedImages = document.querySelectorAll(Dn), this.deadLinks = document.querySelectorAll(Hn), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.checkForImage(), window.dispatchEvent(new Event("resize")), document.addEventListener("theme:header:check", this.checkForImage.bind(this))
                }
            }(this.container)
        },
        onUnload: function () {
            "function" == typeof Bn.unload && Bn.unload()
        }
    }, ss, _n, us, xs, Os, Ws, Qs, nr, ot, Kr, Bi]), customElements.get("popout-select") || customElements.define("popout-select", Br), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr), customElements.get("predictive-search") || customElements.define("predictive-search", vn), customElements.get("main-search") || customElements.define("main-search", Sn);
    const Wn = "[data-newsletter-form]",
        Nn = "has-success",
        Rn = "has-error",
        jn = {};
    const zn = {
        onLoad() {
            jn[this.id] = [];
            this.container.querySelectorAll(Wn).forEach((e => {
                jn[this.id].push(new class {
                    init() {
                        this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                    }
                    newsletterSubmitEvent(e) {
                        this.stopSubmit && (e.preventDefault(), e.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                    }
                    checkForChallengePage() {
                        this.isChallengePage = "/challenge" === window.location.pathname
                    }
                    writeStorage() {
                        void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                    }
                    readStorage() {
                        this.formID = this.sessionStorage.getItem("newsletter_form_id")
                    }
                    removeStorage() {
                        this.sessionStorage.removeItem("newsletter_form_id")
                    }
                    showMessage() {
                        if (this.readStorage(), this.newsletter.id === this.formID) {
                            const e = document.getElementById(this.formID); - 1 !== window.location.search.indexOf("?customer_posted=true") ? (e.classList.remove(Rn), e.classList.add(Nn)) : -1 !== window.location.search.indexOf("accepts_marketing") && (e.classList.remove(Nn), e.classList.add(Rn)), this.removeStorage(), this.scrollToForm(e)
                        }
                    }
                    scrollToForm(e) {
                        const t = e.getBoundingClientRect();
                        t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth) || setTimeout((() => {
                            window.scroll({
                                top: t.top,
                                left: 0,
                                behavior: "smooth"
                            })
                        }), 400)
                    }
                    unload() {
                        this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                    }
                    constructor(e) {
                        this.sessionStorage = window.sessionStorage, this.newsletter = e, this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = e => this.newsletterSubmitEvent(e), this.isChallengePage || this.init()
                    }
                }(e))
            }))
        },
        onUnload() {
            jn[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        }
    },
        Vn = "[data-shop-pay-wrapper]",
        Un = "shop-login-button",
        Gn = "shop-follow-button",
        Jn = "follow-on-shop-button",
        Qn = "heart-icon",
        Yn = "shop-logo",
        Kn = {};
    const Xn = {
        onLoad() {
            Kn[this.id] = new class {
                init() {
                    this.shopLoginButton && this.shopPayWrapper && (this.mainButtonStyles = `\n      :host {\n        --bg-color: ${this.shopPayWrapper.dataset.bg};\n        --text-color: ${this.shopPayWrapper.dataset.text};\n        --hover-color: ${this.shopPayWrapper.dataset.hover};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `, this.svgIconsStyles = `\n      :host {\n        color: ${this.shopPayWrapper.dataset.text};\n      }\n    `, customElements.whenDefined(Un).then((e => {
                        requestAnimationFrame((() => {
                            const e = this.shopLoginButton.shadowRoot,
                                t = null == e ? void 0 : e.querySelector(Gn),
                                i = null == t ? void 0 : t.shadowRoot,
                                s = null == i ? void 0 : i.querySelector(Jn),
                                r = null == s ? void 0 : s.shadowRoot;
                            r && this.overwriteStyles(r.host.shadowRoot, this.mainButtonStyles);
                            const n = r.querySelector(Qn),
                                o = null == n ? void 0 : n.shadowRoot,
                                a = r.querySelector(Yn),
                                l = null == a ? void 0 : a.shadowRoot;
                            o && this.overwriteStyles(o.host.shadowRoot, this.svgIconsStyles), l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles)
                        }))
                    })))
                }
                overwriteStyles(e, t) {
                    let i = document.createElement("style");
                    i.innerHTML = t, e.appendChild(i)
                }
                constructor(e) {
                    this.container = e, this.shopPayWrapper = document.querySelector(Vn), this.shopLoginButton = document.querySelector(Un), this.init()
                }
            }(this.container)
        }
    };
    oi("footer", [Kr, zn, Xn]), customElements.get("popout-select") || customElements.define("popout-select", Br);
    const Zn = {
        cc_load_policy: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        controls: 1,
        showinfo: 0,
        ecver: 2,
        fs: 1,
        rel: 0
    },
        eo = "iframe, [data-replace]",
        to = "data-video-id";

    function io(e, t) {
        const i = {
            ...Zn,
            ...t
        },
            s = document.querySelector(`[data-player="${e}"]`),
            r = s.querySelector(eo),
            n = s.querySelector(`[${to}]`).getAttribute(to);
        Fe({
            url: "https://www.youtube.com/iframe_api"
        });
        return window.youtubeLoaderPromise.then((() => {
            let e = new window.YT.Player(r, {
                videoId: n,
                playerVars: {
                    ...i
                },
                events: {
                    onStateChange: e => {
                        1 == e.data ? s.dispatchEvent(new CustomEvent("play")) : 2 == e.data && s.dispatchEvent(new CustomEvent("pause"))
                    }
                }
            });
            return s.addEventListener("pause", (() => {
                try {
                    e.pauseVideo()
                } catch (e) {
                    console.warn(e)
                }
            })), s.addEventListener("play", (() => {
                try {
                    e.playVideo ? e.playVideo() : e.addEventListener("onReady", (() => {
                        e.playVideo()
                    }))
                } catch (e) {
                    console.warn(e)
                }
            })), s.addEventListener("destroy", (() => {
                try {
                    e.destroy && e.destroy()
                } catch (e) {
                    console.warn(e)
                }
            })), e
        })).catch((e => {
            console.error(e)
        }))
    }
    window.youtubeLoaderPromise = new Promise((e => {
        window.onYouTubeIframeAPIReady = function () {
            e()
        }
    }));
    const so = {
        autoplay: !0,
        loop: !0,
        controls: !0,
        muted: !1,
        playsinline: !0
    },
        ro = "iframe, [data-replace]",
        no = "data-video-id";

    function oo(e, t) {
        const i = {
            ...so,
            ...t
        },
            s = document.querySelector(`[data-player="${e}"]`),
            r = s.querySelector(ro),
            n = s.querySelector(`[${no}]`).getAttribute(no),
            o = Fe({
                url: "https://player.vimeo.com/api/player.js"
            }),
            a = `select-${e}`;
        r.setAttribute("id", a);
        return o.then((() => {
            const e = new window.Vimeo.Player(a, {
                ...i,
                id: n
            });
            return e.on("play", (() => {
                s.dispatchEvent(new CustomEvent("play"))
            })), e.on("pause", (() => {
                s.dispatchEvent(new CustomEvent("pause"))
            })), s.addEventListener("pause", (() => {
                try {
                    e.pause && e.pause()
                } catch (e) {
                    console.warn(e)
                }
            })), s.addEventListener("play", (() => {
                e.play && e.getPaused().then((t => {
                    t && e.play()
                }))
            })), s.addEventListener("destroy", (() => {
                try {
                    e.destroy && e.destroy()
                } catch (e) {
                    console.log(e)
                }
            })), e
        })).catch((e => {
            console.error(e)
        }))
    }
    const ao = "[data-video-popup]",
        lo = "[data-video-autoplay]",
        co = "data-unique",
        ho = "data-video-id",
        uo = "data-video-type",
        po = "data-player";
    const mo = {
        onLoad() {
            new class {
                init() {
                    this.triggers.forEach((e => {
                        const t = e.getAttribute(co),
                            i = e.getAttribute(ho),
                            s = e.getAttribute(uo),
                            r = `${i}-${t}`,
                            o = document.querySelector(`[${po}="${r}"]`);
                        n.init({
                            onShow: () => {
                                this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                let e = {};
                                "youtube" === s ? e = io(r) : "vimeo" === s && (e = oo(r)), e.then((() => {
                                    o.dispatchEvent(new CustomEvent("play"))
                                }))
                            },
                            onClose: (e, t, i) => {
                                i.preventDefault(), o.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play()
                            },
                            openTrigger: `data-trigger-${i}-${t}`
                        })
                    }))
                }
                constructor(e) {
                    this.container = e.container, this.triggers = this.container.querySelectorAll(ao), this.backgroundVideo = this.container.querySelector(lo), this.init()
                }
            }(this)
        }
    },
        fo = "[data-scroll-down]";
    const go = {
        onLoad() {
            this.scrollButton = new class {
                init() {
                    const e = this.wrapper.querySelectorAll(fo);
                    e && e.forEach((e => {
                        e.addEventListener("click", this.scroll.bind(this))
                    }))
                }
                scroll() {
                    const e = this.wrapper.offsetTop + this.wrapper.clientHeight;
                    window.scroll({
                        top: e,
                        left: 0,
                        behavior: "smooth"
                    })
                }
                constructor(e) {
                    this.wrapper = e, this.init()
                }
            }(this.container)
        },
        onUnload: function () {
            delete this.scrollButton
        }
    };
    oi("video", [Ai, go, mo]), oi("page-faq", Kr), oi("hero", [Ai, go, pt]);
    const yo = "[data-slider]",
        vo = "[data-grid-slide]",
        bo = "[data-wrapper]",
        wo = "data-custom-scrollbar-items",
        So = "data-show-dots",
        Eo = "wrapper",
        Lo = "wrapper--full",
        ko = window.innerWidth - document.documentElement.clientWidth,
        To = 112,
        xo = {};
    const _o = {
        onLoad() {
            xo[this.id] = [];
            this.container.querySelectorAll(yo).forEach((e => {
                xo[this.id].push(new class {
                    init() {
                        const e = this,
                            t = {
                                initialIndex: 0,
                                accessibility: !0,
                                autoPlay: !1,
                                contain: !0,
                                pageDots: this.pageDots,
                                adaptiveHeight: !1,
                                wrapAround: !1,
                                groupCells: !1,
                                cellAlign: "left",
                                freeScroll: !0,
                                prevNextButtons: !0,
                                draggable: !0,
                                rightToLeft: window.isRTL,
                                watchCSS: !0,
                                arrowShape: {
                                    x0: 10,
                                    x1: 60,
                                    y1: 50,
                                    x2: 67.5,
                                    y2: 42.5,
                                    x3: 25
                                },
                                on: {
                                    ready: function () {
                                        e.removeIncorrectAria()
                                    }
                                }
                            };
                        this.flkty = new s(this.slideshow, t), this.container.addEventListener("theme:tab:change", (() => {
                            this.flkty.resize()
                        })), this.toggleWrapperModifier(), document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)), this.slideshow.hasAttribute(wo) && new ut(this.container), new ae(this.container)
                    }
                    toggleWrapperModifier() {
                        this.wrapper.classList.contains(Eo) && this.wrapper.classList.toggle(Lo, this.wrapperWidthWithGutter >= window.innerWidth)
                    }
                    removeIncorrectAria() {
                        this.slideshow.querySelectorAll('[aria-hidden="true"]').forEach((e => e.removeAttribute("aria-hidden")))
                    }
                    onUnload() {
                        this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
                    }
                    constructor(e, t) {
                        if (this.container = e, this.slideshow = t, this.wrapper = this.container.querySelector(bo), this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", "")), this.wrapperWidthWithGutter = this.wrapperWidth + To + ko, this.pageDots = "true" === this.slideshow.getAttribute(So), this.firstPhoto = this.container.querySelector(vo), this.firstPhoto) {
                            const e = this.firstPhoto.offsetHeight / 2;
                            this.slideshow.style.setProperty("--buttons-top", `${e}px`)
                        }
                        this.slideshow && (this.flkty = null, this.init())
                    }
                }(this.container, e))
            }))
        },
        onUnload(e) {
            xo[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload(e)
            }))
        }
    };
    oi("custom-content", [Ai, mo, ot, _o]), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr);
    const Ao = [],
        qo = "[data-slideshow-wrapper]",
        Co = "data-slideshow-speed",
        Po = "data-slideshow-autoplay",
        $o = "data-slideshow-slides",
        Io = "[data-slide-custom-prev]",
        Mo = "[data-slide-custom-next]",
        Do = "data-slideshow-index",
        Oo = "flickity-enabled";
    const Ho = {
        onLoad() {
            Ao[this.id] = new class {
                init() {
                    const e = {
                        autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                        contain: !1,
                        pageDots: !0,
                        adaptiveHeight: !0,
                        accessibility: !0,
                        wrapAround: 2 !== this.slideCount,
                        prevNextButtons: !1,
                        draggable: !0,
                        fade: !0,
                        rightToLeft: window.isRTL
                    };
                    this.flkty = new t(this.wrapper, e), this.prevButtons.length && this.prevButtons.forEach((e => {
                        e.onclick = () => {
                            this.flkty.previous(!0, !1)
                        }
                    })), this.nextButtons.length && this.nextButtons.forEach((e => {
                        e.onclick = () => {
                            this.flkty.next(!0, !1)
                        }
                    })), document.addEventListener("theme:scroll", this.scrollEvent)
                }
                scrollEvents() {
                    if (this.flkty && this.autoplay && this.speed) {
                        const e = this.flkty.element,
                            t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
                        window.pageYOffset > t ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer()
                    }
                }
                unload() {
                    document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.wrapper && this.wrapper.classList.contains(Oo) && this.flkty.destroy()
                }
                onBlockSelect(e) {
                    const t = e.target.closest(`[${Do}]`).getAttribute(Do),
                        i = parseInt(t);
                    this.flkty.selectCell(i), this.flkty.stopPlayer()
                }
                onBlockDeselect() {
                    this.autoplay && this.flkty.playPlayer()
                }
                constructor(e) {
                    this.container = e.container, this.wrapper = e.container.querySelector(qo), this.speed = this.wrapper.getAttribute(Co), this.autoplay = "true" === this.wrapper.getAttribute(Po), this.slideCount = parseInt(this.wrapper.getAttribute($o), 10), this.prevButtons = this.wrapper.querySelectorAll(Io), this.nextButtons = this.wrapper.querySelectorAll(Mo), this.flkty = null, this.scrollEvent = () => this.scrollEvents(), this.init()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof Ao[this.id].unload && Ao[this.id].unload()
        },
        onBlockSelect(e) {
            "function" == typeof Ao[this.id].onBlockSelect && Ao[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            "function" == typeof Ao[this.id].onBlockSelect && Ao[this.id].onBlockDeselect(e)
        }
    };
    oi("slideshow", [Ho, Ai, go]);
    const Fo = "[data-range-slider]",
        Bo = "[data-range-left]",
        Wo = "[data-range-right]",
        No = "[data-range-line]",
        Ro = "[data-range-holder]",
        jo = "data-se-min",
        zo = "data-se-max",
        Vo = "data-se-min-value",
        Uo = "data-se-max-value",
        Go = "data-se-step",
        Jo = "data-range-filter-update",
        Qo = "[data-field-price-min]",
        Yo = "[data-field-price-max]",
        Ko = "is-initialized";
    let Xo = class {
        init() {
            this.setDefaultValues(), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent), this.touchRight.addEventListener("touchstart", this.onStartEvent), this.slider.classList.add(Ko)
        }
        setDefaultValues() {
            let e = this.min;
            this.slider.hasAttribute(Vo) && (e = parseFloat(this.slider.getAttribute(Vo)));
            let t = this.max;
            this.slider.hasAttribute(Uo) && (t = parseFloat(this.slider.getAttribute(Uo))), e < this.min && (e = this.min), t > this.max && (t = this.max), e > t && (e = t), this.slider.getAttribute(Go) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Go)))), this.reset(), this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(e), this.setMaxValue(t)
        }
        reset() {
            this.touchLeft.style.left = "0px", this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0
        }
        setMinValue(e) {
            const t = (e - this.min) / (this.max - this.min);
            this.touchLeft.style.left = Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(Vo, e)
        }
        setMaxValue(e) {
            const t = (e - this.min) / (this.max - this.min);
            this.touchRight.style.left = Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(Uo, e)
        }
        onStart(e) {
            e.preventDefault();
            let t = e;
            e.touches && (t = e.touches[0]), e.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : e.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = t.pageX - this.x, this.selectedTouch = e.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent), document.addEventListener("touchend", this.onStopEvent)
        }
        onMove(e) {
            let t = e;
            if (e.touches && (t = e.touches[0]), this.x = t.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.slider.getAttribute("on-change")) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(Vo), this.slider.getAttribute(Uo))
            }
            this.onChange(this.slider.getAttribute(Vo), this.slider.getAttribute(Uo))
        }
        onStop(e) {
            document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent), document.removeEventListener("touchend", this.onStopEvent), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.slider.getAttribute(Vo), this.slider.getAttribute(Uo))
        }
        onChange(e, t) {
            const i = this.slider.closest(Ro);
            if (i) {
                const s = i.querySelector(Qo),
                    r = i.querySelector(Yo);
                if (s && r) {
                    const changed = (s.value !== String(e) || r.value !== String(t));
                    s.value = e;
                    r.value = t;
                    if (changed) {
                        s.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }
        }
        onChanged(e, t) {
            this.slider.hasAttribute(Jo) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", {
                bubbles: !0
            }))
        }
        calculateValue() {
            const e = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let t = this.lineSpan.offsetLeft / this.initialValue,
                i = t + e;
            if (t = t * (this.max - this.min) + this.min, i = i * (this.max - this.min) + this.min, 0 !== this.step) {
                let e = Math.floor(t / this.step);
                t = this.step * e, e = Math.floor(i / this.step), i = this.step * e
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(Vo, t), this.selectedTouch === this.touchRight && this.slider.setAttribute(Uo, i)
        }
        constructor(e) {
            this.container = e.container, this.slider = e.querySelector(Fo), this.slider && (this.onMoveEvent = e => this.onMove(e), this.onStopEvent = e => this.onStop(e), this.onStartEvent = e => this.onStart(e), this.startX = 0, this.x = 0, this.touchLeft = this.slider.querySelector(Bo), this.touchRight = this.slider.querySelector(Wo), this.lineSpan = this.slider.querySelector(No), this.min = parseFloat(this.slider.getAttribute(jo)), this.max = parseFloat(this.slider.getAttribute(zo)), this.step = 0, this.normalizeFact = 26, this.init(), this.resetListener = () => {
                if (this.slider && this.slider.isConnected) {
                    this.setDefaultValues();
                } else {
                    document.removeEventListener("theme:price-range:reset", this.resetListener);
                }
            }, document.addEventListener("theme:price-range:reset", this.resetListener))
        }
    };
    window.RangeSlider = Xo;
    const Zo = (e, t) => {
        let i, s;
        return function r(...n) {
            const o = Date.now();
            s = clearTimeout(s), !i || o - i >= t ? (e.apply(null, n), i = o) : s = setTimeout(r.bind(null, ...n), t - (o - i))
        }
    },
        ea = "data-filters",
        ta = "[data-filters-underlay]",
        ia = "data-default-hide",
        sa = "data-filters-toggle",
        ra = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        na = "data-group-heading",
        oa = "data-show-more",
        aa = "drawer--visible",
        la = "filters--default-visible",
        ca = "hidden",
        ha = "is-hidden",
        da = "focus-enabled",
        ua = {};
    let pa = class {
        unload() {
            this.filtersToggleButtons.length && this.filtersToggleButtons.forEach((e => {
                e.removeEventListener("click", this.connectToggleMemory)
            })), this.showMoreButtons.length && this.showMoreButtons.forEach((e => {
                e.removeEventListener("click", this.connectShowHiddenOptions)
            }))
        }
        expandingEvents() {
            this.showMoreButtons.length && this.showMoreButtons.forEach((e => {
                e.addEventListener("click", Zo(this.connectShowHiddenOptions, 500))
            }))
        }
        showHiddenOptions(e) {
            const t = e.target.hasAttribute(oa) ? e.target : e.target.closest(`[${oa}]`);
            t.classList.add(ha), t.previousElementSibling.querySelectorAll(`.${ha}`).forEach((e => {
                e.classList.remove(ha)
            }))
        }
        connectToggle(e = !1) {
            this.filtersToggleButtons.forEach((t => {
                const i = null !== t.closest(`[${ea}]`);
                (i && e || i && !e || !i && !e) && t.addEventListener("click", this.connectToggleMemory.bind(this))
            }))
        }
        connectToggleFunction(e) {
            "true" === e.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters()
        }
        onFocusOut() {
            this.container.addEventListener("focusout", function (e) {
                if (window.innerWidth >= window.theme.sizes.medium) return;
                const t = e.currentTarget.contains(e.relatedTarget),
                    i = this.container.classList.contains(aa);
                document.body.classList.contains(da) && i && !t && this.hideFilters()
            }.bind(this)), this.container.addEventListener("keyup", function (e) {
                "Escape" === e.code && (this.hideFilters(), this.filtersToggleButtons[0].focus())
            }.bind(this)), this.underlay.addEventListener("click", function () {
                this.hideFilters()
            }.bind(this))
        }
        getShowOnLoad() {
            const e = `[${ia}='false']`,
                t = document.querySelector(e),
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!t || !i)
        }
        showFilters() {
            this.filtersToggleButtons = document.querySelectorAll(this.selector), this.container.classList.remove(ca), setTimeout((() => {
                this.filtersToggleButtons.forEach((e => e.setAttribute("aria-expanded", !0))), this.filtersToggleButtons.forEach((e => e.classList.add(aa))), this.container.classList.add(aa), this.container.querySelector(ra).focus()
            }), 1)
        }
        hideFilters() {
            this.filtersToggleButtons = document.querySelectorAll(this.selector), this.filtersToggleButtons.forEach((e => e.setAttribute("aria-expanded", !1))), this.container.classList.remove(aa), this.container.classList.remove(la), this.filtersToggleButtons.forEach((e => e.classList.remove(aa))), this.filtersToggleButtons.forEach((e => e.classList.remove(la))), setTimeout((() => {
                this.container.classList.contains(aa) || this.container.classList.add(ca)
            }), 800)
        }
        constructor(e, t = !1) {
            this.container = e, this.underlay = this.container.querySelector(ta), this.groupHeadings = this.container.querySelectorAll(`[${na}]`), this.showMoreButtons = this.container.querySelectorAll(`[${oa}]`), this.triggerKey = this.container.getAttribute(ea), this.selector = `[${sa}='${this.triggerKey}']`, this.filtersToggleButtons = document.querySelectorAll(this.selector), this.connectToggleMemory = e => this.connectToggleFunction(e), this.connectShowHiddenOptions = e => this.showHiddenOptions(e), this.connectToggle(t), this.onFocusOut(), this.expandingEvents(), this.getShowOnLoad() ? this.showFilters() : this.hideFilters()
        }
    };
    const ma = {
        onLoad() {
            ua[this.id] = [];
            this.container.querySelectorAll(`[${ea}]`).forEach((e => {
                ua[this.id].push(new pa(e))
            }))
        },
        onUnload: function () {
            ua[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        }
    },
        fa = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]"
        },
        ga = "is-hidden",
        ya = "is-loading",
        va = 1e3,
        ba = 1e3;
    const wa = {
        onLoad() {
            this.filterForm = new class {
                init() {
                    this.showAllOptions(), this.form && (new Xo(this.form), this.sidebar.addEventListener("input", T((e => {
                        const t = e.type,
                            i = e.target;
                        if (!fa.inputs.includes(t) || !this.form || "function" != typeof this.form.submit) return;
                        const s = this.form.querySelector(`[${fa.priceMin}]`),
                            r = this.form.querySelector(`[${fa.priceMax}]`);
                        if (i.hasAttribute(fa.priceMin) || i.hasAttribute(fa.priceMax)) {
                            const e = this.form.querySelector(`[${fa.rangeMin}]`),
                                t = this.form.querySelector(`[${fa.rangeMax}]`),
                                i = parseInt(e.getAttribute(fa.rangeMinDefault)),
                                n = parseInt(t.getAttribute(fa.rangeMaxDefault));
                            s.value && !r.value && (r.value = n), r.value && !s.value && (s.value = i), s.value <= i && r.value >= n && (s.placeholder = i, r.placeholder = n, s.value = "", r.value = "")
                        }
                        this.filtering(e)
                    }), 1500)), this.form.addEventListener("theme:range:update", (e => this.updateRange(e)))), this.sidebar && this.sidebar.addEventListener("click", (e => this.updateFilterFromUrl(e))), this.activeFiltersHolder && this.activeFiltersHolder.addEventListener("click", (e => this.updateFilterFromUrl(e))), this.productsContainer && this.productsContainer.addEventListener("click", (e => this.updateFilterFromUrl(e))), je(this.sidebar)
                }
                updateRange(e) {
                    if (this.form && "function" == typeof this.form.submit) {
                        const t = this.form.querySelector(`[${fa.rangeMin}]`),
                            i = this.form.querySelector(`[${fa.rangeMax}]`),
                            s = this.form.querySelector(`[${fa.priceMin}]`),
                            r = this.form.querySelector(`[${fa.priceMax}]`);
                        if (t && i && s && r && t.hasAttribute(fa.rangeMin) && i.hasAttribute(fa.rangeMax)) {
                            const n = parseInt(s.placeholder),
                                o = parseInt(r.placeholder),
                                a = parseInt(t.getAttribute(fa.rangeMin)),
                                l = parseInt(i.getAttribute(fa.rangeMax));
                            n === a && o === l || (s.value = a, r.value = l, this.filtering(e))
                        }
                    }
                }
                updateFilterFromUrl(e) {
                    const t = e.target;
                    if (t.matches(fa.filterUpdateUrlButton) || t.closest(fa.filterUpdateUrlButton) && t) {
                        e.preventDefault();
                        const i = t.matches(fa.filterUpdateUrlButton) ? t : t.closest(fa.filterUpdateUrlButton);
                        this.filtering(e, i.getAttribute("href"))
                    }
                }
                addToHistory(e, t = "") {
                    const i = this.sort ? this.sort.getAttribute(fa.dataSort) : "";
                    if (!e || e && "popstate" !== e.type) {
                        if ("" === t) {
                            const t = new window.URL(window.location.href).searchParams,
                                s = Object.fromEntries(t),
                                r = t.toString();
                            if (r.includes("filter.") || r.includes("sort_by") || r.includes("page"))
                                for (const e in s) (e.includes("filter.") || e.includes("sort_by") || e.includes("page")) && t.delete(e);
                            if (this.form) {
                                const e = new URLSearchParams(new FormData(this.form));
                                for (let [i, s] of e.entries()) i.includes("filter.") && s && t.append(i, s);
                                const i = this.form.querySelector(`[${fa.rangeMin}]`),
                                    s = this.form.querySelector(`[${fa.rangeMax}]`),
                                    r = this.form.querySelector(`[${fa.priceMin}]`),
                                    n = this.form.querySelector(`[${fa.priceMax}]`);
                                if (i && s && r && n && i.hasAttribute(fa.rangeMinDefault) && s.hasAttribute(fa.rangeMaxDefault)) {
                                    const e = parseFloat(i.getAttribute(fa.rangeMinDefault), 10),
                                        o = parseFloat(s.getAttribute(fa.rangeMaxDefault), 10),
                                        a = "" === r.value ? parseFloat(r.placeholder, 10) : parseFloat(r.value, 10),
                                        l = "" === n.value ? parseFloat(n.placeholder, 10) : parseFloat(n.value, 10);
                                    a <= e && l >= o && (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"))
                                }
                            }
                            if (i || e && e.detail && e.detail.href) {
                                const s = i || e.detail.params;
                                t.set("sort_by", s)
                            }
                            const n = t.toString(),
                                o = n ? `?${n}` : location.pathname;
                            return void window.history.pushState(null, "", o)
                        }
                        window.history.pushState(null, "", t)
                    }
                }
                getFilterResult() {
                    this.productsContainer.classList.add(ya), this.getGridValues();
                    const e = new window.URL(window.location.href);
                    e.searchParams.set("section_id", this.section.id), fetch(`${window.location.pathname}${e.search}`).then((e => e.text())).then((e => {
                        const t = document.createElement("div");
                        t.innerHTML = e, this.sidebar && (this.sidebar.innerHTML = t.querySelector(fa.collectionSidebar).innerHTML), this.activeFiltersCount && (this.activeFiltersCount.innerHTML = t.querySelector(fa.activeFiltersCount).innerHTML), this.productsContainer.innerHTML = t.querySelector(fa.productsContainer).innerHTML, this.activeFiltersHolder.innerHTML = t.querySelector(fa.activeFiltersHolder).innerHTML, this.activeFiltersHolder.parentNode.classList.toggle(ga, "" === this.activeFiltersHolder.innerHTML), this.productsCount && (this.productsCount.innerHTML = t.querySelector(fa.productsCount).innerHTML), this.setGridValues(), this.refreshFunctionalities(), setTimeout((() => {
                            this.productsContainer.classList.remove(ya)
                        }), va)
                    }))
                }
                refreshFunctionalities() {
                    this.form = this.container.querySelector(fa.form), this.form && (new Xo(this.form), this.form.addEventListener("theme:range:update", (e => this.updateRange(e)))), this.container.querySelectorAll(fa.filtersWrappper).forEach((e => {
                        new pa(e, !0)
                    })), this.container.querySelectorAll(fa.accordionBody).forEach((e => {
                        new Yr(e)
                    })), new ae(this.container), this.sidebar && je(this.sidebar), nt(this.container), this.showAllOptions()
                }
                getGridValues() {
                    this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(fa.gridLarge)), this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(fa.gridSmall))
                }
                setGridValues() {
                    this.layoutLarge && (this.layoutLarge = this.container.querySelector(`[${fa.gridLarge}]`), this.layoutLarge.setAttribute(fa.gridLarge, this.layoutLargeValue)), this.layoutSmall && (this.layoutSmall = this.container.querySelector(`[${fa.gridSmall}]`), this.layoutSmall.setAttribute(fa.gridSmall, this.layoutSmallValue))
                }
                showAllOptions() {
                    this.container.querySelectorAll(fa.checkedOption).forEach((e => {
                        if (e.closest(fa.optionHolder) && e.closest(fa.optionHolder).classList.contains(ga)) {
                            const t = e.closest(fa.accordionBody).nextElementSibling;
                            t.classList.contains(fa.classHidden) || t.dispatchEvent(new Event("click"))
                        }
                    }))
                }
                filtering(e, t = "") {
                    const i = this.headerIsSticky ? document.querySelector(fa.headerHeight).getBoundingClientRect().height : 0,
                        s = this.container.offsetTop - i,
                        r = new IntersectionObserver((i => {
                            const [n] = i;
                            setTimeout((() => {
                                this.addToHistory(e, t), this.getFilterResult()
                            }), n.isIntersecting ? 10 : ba), r.unobserve(this.productsContainer), n.isIntersecting || window.scrollTo({
                                top: s,
                                left: 0,
                                behavior: "smooth"
                            })
                        }), {
                            root: null,
                            rootMargin: `${i}px`,
                            threshold: 1
                        });
                    r.observe(this.productsContainer)
                }
                constructor(e) {
                    this.section = e, this.container = this.section.container, this.sidebar = this.container.querySelector(fa.collectionSidebar), this.form = e.container.querySelector(fa.form), this.sort = this.container.querySelector(`[${fa.dataSort}]`), this.productsContainer = this.container.querySelector(fa.productsContainer), this.activeFiltersHolder = this.container.querySelector(fa.activeFiltersHolder), this.activeFiltersCount = this.container.querySelector(fa.activeFiltersCount), this.productsCount = this.container.querySelector(fa.productsCount), this.headerIsSticky = null !== document.querySelector(fa.headerSticky), this.layoutLarge = this.container.querySelector(`[${fa.gridLarge}]`), this.layoutSmall = this.container.querySelector(`[${fa.gridSmall}]`), this.productsContainer && this.sidebar && this.init(), this.sort && this.container.addEventListener("theme:form:filter", (e => this.filtering(e))), (this.sidebar || this.sort) && window.addEventListener("popstate", (e => this.filtering(e)))
                }
            }(this)
        },
        onUnload() {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload()
        }
    };
    // oi("search-page", [ma, wa, ot, Kr]), customElements.get("popout-select") || customElements.define("popout-select", Br), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr);
    oi("search-page", [ma, wa, ot, Kr]), customElements.get("popout-select") || customElements.define("popout-select", Br), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr);
    const Sa = "[data-image-zoom]",
        Ea = "[data-modal-container]",
        La = "data-unique",
        ka = "data-src";
    const Ta = {
        onLoad() {
            new class {
                init() {
                    this.triggers.forEach((e => {
                        const t = e.getAttribute(La),
                            i = this.modalContainer.querySelector(`#zoom-${t}`);
                        if (i) {
                            const e = this.container.querySelector(`#zoom-${t}`);
                            e && (i.parentNode.removeChild(i), this.modalContainer.appendChild(e))
                        }
                        n.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${t}`,
                            onShow: e => {
                                e.querySelectorAll(`[${ka}]`, e).forEach((e => {
                                    if (null === e.getAttribute("src")) {
                                        const t = e.getAttribute(ka);
                                        e.setAttribute("src", t)
                                    }
                                }))
                            },
                            onClose: (e, t, i) => {
                                i.preventDefault()
                            }
                        })
                    }))
                }
                constructor(e) {
                    this.container = e, this.triggers = this.container.querySelectorAll(Sa), this.modalContainer = document.querySelector(Ea), this.init()
                }
            }(this.container)
        }
    };
    oi("gallery", [Ta, mo, pt]);
    const xa = (e, t) => {
        const {
            el: i,
            elStyle: s,
            elHeight: r,
            rowsLimit: n,
            rowsWrapped: o,
            options: a
        } = e;
        let l = e.buffer,
            c = l;
        if (o === n + 1) return {
            ...e
        };
        const h = l;
        let d = o,
            u = r;
        return i.innerHTML = c = l.length ? `${l}${a.delimiter}${t}${a.replaceStr}` : `${t}${a.replaceStr}`, parseFloat(s.height) > parseFloat(r) && (d++, u = s.height, d === n + 1) ? (i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`, {
            ...e,
            elHeight: u,
            rowsWrapped: d
        }) : (i.innerHTML = c = h.length ? `${h}${a.delimiter}${t}` : `${t}`, {
            ...e,
            buffer: c,
            elHeight: u,
            rowsWrapped: d
        })
    };
    ! function () {
        const e = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        document.documentElement.classList.toggle("supports-touch", e)
    }();
    let _a = {},
        Aa = {},
        qa = {};
    const Ca = "[data-product-slideshow]",
        Pa = "[data-shopify-xr]",
        $a = "data-media-id",
        Ia = "data-model-id",
        Ma = "model-viewer",
        Da = "data-shopify-model3d-id",
        Oa = "#ModelJson-";

    function Ha(e) {
        if (e) console.warn(e);
        else if (window.ShopifyXR) {
            for (const e in _a)
                if (_a.hasOwnProperty(e)) {
                    const t = _a[e];
                    if (t.loaded) continue;
                    const i = document.querySelector(`${Oa}${e}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), t.loaded = !0)
                } window.ShopifyXR.setupXRElements()
        } else document.addEventListener("shopify_xr_initialized", (function () {
            Ha()
        }))
    }

    function Fa(e) {
        if (e) console.warn(e);
        else
            for (const e in Aa)
                if (Aa.hasOwnProperty(e)) {
                    const t = Aa[e];
                    t.modelViewerUi || (t.modelViewerUi = new Shopify.ModelViewerUI(t.$element)), Ba(t)
                }
    }

    function Ba(e) {
        const t = qa[e.sectionId];
        e.$container.addEventListener("pause", (function () {
            e.modelViewerUi.pause && e.modelViewerUi.pause()
        })), e.$container.addEventListener("play", (function () {
            e.modelViewerUi.play && (e.modelViewerUi.play(), t && t.$element && e && e.modelId && Da && t.$element.setAttribute(Da, e.modelId))
        })), e.$element.addEventListener("shopify_model_viewer_ui_toggle_play", (() => {
            e.$container.dispatchEvent(new CustomEvent("theme:media:play"))
        })), e.$element.addEventListener("shopify_model_viewer_ui_toggle_pause", (() => {
            e.$container.dispatchEvent(new CustomEvent("theme:media:pause"))
        }))
    }
    async function Wa(e) {
        const t = document.querySelector(`[data-player="${e}"]`);
        if (!t) return null;
        if (t.querySelector(".plyr")) return null;
        const i = t.querySelector("video");
        if (!i) return null;

        try {
            await Fe({
                name: "video-ui",
                version: "1.0"
            });
        } catch (err) {
            console.warn("Fe video-ui load error:", err);
        }

        if (!window.Shopify || typeof window.Shopify.Plyr !== "function") {
            setTimeout(() => {
                Wa(e);
            }, 200);
            return null;
        }

        try {
            const s = new window.Shopify.Plyr(i);
            t.addEventListener("pause", (() => {
                s.pause && s.pause();
            }));
            t.addEventListener("play", (() => {
                try {
                    s.play ? s.paused && s.play() : s.addEventListener("onReady", (() => {
                        s.play();
                    }));
                } catch (e) {
                    console.warn(e);
                }
            }));
            t.addEventListener("destroy", (() => {
                try {
                    s.destroy && s.destroy();
                } catch (e) {
                    console.warn(e);
                }
            }));
            return s;
        } catch (err) {
            console.error("Shopify.Plyr init error:", err);
            setTimeout(() => {
                if (t && !t.querySelector(".plyr")) {
                    try {
                        const i2 = t.querySelector("video");
                        if (i2 && window.Shopify && typeof window.Shopify.Plyr === "function") {
                            new window.Shopify.Plyr(i2);
                        }
                    } catch (e2) {
                        console.error(e2);
                    }
                }
            }, 300);
            return null;
        }
    }
    const Na = {
        productSlideshow: "[data-product-slideshow]",
        slideshowMobileStyle: "data-slideshow-mobile-style",
        slideshowDesktopStyle: "data-slideshow-desktop-style",
        productThumbs: "[data-product-thumbs]",
        leftThumbsHolder: "[data-thumbs-holder]",
        thumbImage: "[data-slideshow-thumbnail]",
        mediaSlide: "[data-media-slide]",
        dataMediaId: "data-media-id",
        dataMediaSelect: "data-media-select",
        mediaType: "data-type",
        videoPlayerExternal: '[data-type="external_video"]',
        videoPlayerNative: '[data-type="video"]',
        modelViewer: '[data-type="model"]',
        modelViewerTag: "model-viewer",
        allPlayers: "[data-player]",
        loopVideo: "data-enable-video-looping",
        verticalAlignment: "[data-thumbnails-left]",
        arrowPrev: "[data-thumbs-arrow-prev]",
        arrowNext: "[data-thumbs-arrow-next]",
        aspectRatio: "data-aspect-ratio",
        flickitylockHeight: "flickity-lock-height"
    },
        Ra = "is-activated",
        ja = "show",
        za = "enable-video-draggable",
        Va = "hide";
    let Ua = class {
        init() {
            this.storeEvents(), this.connectSliderMediaEvents(), this.detectVideos(), this.detect3d(), this.scrollThumbs(), document.addEventListener("theme:resize:width", (() => {
                this.scrollThumbs()
            })), Ae.onChange((() => {
                this.connectSliderMediaEvents()
            }))
        }
        connectSliderMediaEvents() {
            Ae.isMobile() ? this.createMobileSlider() : this.createDesktopSlider()
        }
        createMobileSlider() {
            this.hasDesktopSlider && this.flkty && (this.destroySlider(), this.hasDesktopSlider = !1);
            const e = {
                autoPlay: !1,
                prevNextButtons: !1,
                pageDots: !1,
                adaptiveHeight: !0,
                accessibility: !0,
                watchCSS: !1,
                wrapAround: !0,
                rightToLeft: window.isRTL,
                dragThreshold: 80,
                contain: !0,
                fade: !0
            };
            "carousel" == this.mobileStyle && (e.contain = !1, e.dragThreshold = 10, e.fade = !1), "slideshow" == this.mobileStyle && (e.pageDots = !0, e.fade = !1, e.dragThreshold = 10), "none" != this.mobileStyle && (this.createSlider(e), this.hasMobileSlider = !0)
        }
        createDesktopSlider() {
            if (this.hasMobileSlider && this.flkty && (this.destroySlider(), this.hasMobileSlider = !1), "none" == this.desktopStyle) return;
            const e = {
                autoPlay: !1,
                prevNextButtons: !1,
                pageDots: !1,
                adaptiveHeight: !0,
                accessibility: !0,
                watchCSS: !1,
                wrapAround: !0,
                rightToLeft: window.isRTL,
                dragThreshold: 80,
                contain: !0,
                fade: !0
            };
            this.createSlider(e), this.hasDesktopSlider = !0
        }
        createSlider(e) {
            this.flkty = new s(this.slideshow, e), this.flkty.resize(), this.currentSlide = this.slideshow.querySelectorAll(Na.mediaSlide)[0], this.setDraggable(), this.addEventListeners()
        }
        destroySlider() {
            this.removeEventListeners(), this.flkty.destroy()
        }
        storeEvents() {
            this.storeFlktyChange = e => this.doFlktyChange(e), this.storeFlktySettle = e => this.doFlktySettle(e), this.storeImageChange = e => this.doImageChange(e), this.storeArrowPrevClick = e => this.doArrowPrevClick(e), this.storeArrowNextClick = e => this.doArrowNextClick(e), this.storeThumbClick = e => this.doThumbClick(e), this.storeThumbContainerScroll = e => this.doThumbContainerScroll(e)
        }
        addEventListeners() {
            var e, t, i;
            this.flkty.on("change", this.storeFlktyChange), this.flkty.on("settle", this.storeFlktySettle), this.slideshow.addEventListener("theme:image:change", this.storeImageChange), null === (e = this.arrowPrev) || void 0 === e || e.addEventListener("click", this.storeArrowPrevClick), null === (t = this.arrowNext) || void 0 === t || t.addEventListener("click", this.storeArrowNextClick), null === (i = this.thumbs) || void 0 === i || i.addEventListener("scroll", this.storeThumbContainerScroll), this.thumbImages.forEach((e => {
                e.addEventListener("click", this.storeThumbClick)
            }))
        }
        removeEventListeners() {
            var e, t, i;
            this.flkty.on("change", this.storeFlktyChange), this.flkty.on("settle", this.storeFlktySettle), this.slideshow.removeEventListener("theme:image:change", this.storeImageChange), null === (e = this.arrowPrev) || void 0 === e || e.removeEventListener("click", this.storeArrowPrevClick), null === (t = this.arrowNext) || void 0 === t || t.removeEventListener("click", this.storeArrowNextClick), null === (i = this.thumbs) || void 0 === i || i.removeEventListener("scroll", this.storeThumbContainerScroll), this.thumbImages.forEach((e => {
                e.removeEventListener("click", this.storeThumbClick)
            }))
        }
        addMediaEventListeners(e) {
            e && (e.addEventListener("play", (() => {
                (Ae.isMobile() || Ae.isTouch()) && this.updateDraggable(!1)
            })), e.addEventListener("pause", (() => {
                (Ae.isMobile() || Ae.isTouch()) && this.updateDraggable(!0)
            })))
        }
        doFlktyChange(e) {
            var t, i;
            "model" !== this.mediaType && "video" !== this.mediaType && "external_video" !== this.mediaType || this.currentSlide.dispatchEvent(new CustomEvent("pause")), this.currentSlide = this.flkty.cells[e].element, this.slideshow.classList.remove(Na.flickitylockHeight);
            const s = this.currentSlide.getAttribute(Na.dataMediaId),
                r = null === (t = this.thumbWrapper) || void 0 === t ? void 0 : t.querySelector(`[${Na.dataMediaSelect}="${s}"]`);
            // setTimeout(() => {
            this.slideshow.classList.add(Na.flickitylockHeight);
            if (this.thumbWrapper.querySelector(`.${Ra}`)) {
                null === (i = this.thumbWrapper) || void 0 === i || this.thumbWrapper.querySelector(`.${Ra}`).classList.remove(Ra), null == r || r.classList.add(Ra), this.scrollThumbs(), setTimeout((() => {
                    if (window.outerWidth <= 767) {
                        this.thumbWrapper.querySelector(`.${Ra}`).classList.remove(Ra);
                        this.thumbWrapper.querySelectorAll('.media__thumb.mobile').forEach((event) => {
                            event.classList.remove(Ra);
                        });
                    } else {
                        if (this.thumbWrapper.querySelectorAll(`.${Ra}`).length > 1) {
                            var activeImageId = this.thumbWrapper.querySelector(`.${Ra}`).getAttribute('data-media-select');
                            this.thumbWrapper.querySelector(`.media__thumb.desktop[data-media-select='${activeImageId}']`).classList.remove(Ra);
                            this.thumbWrapper.querySelector(`.media__thumb.desktop[data-media-select='${activeImageId}']`).classList.remove("enable-custoization");
                        }
                    }
                    if (r) {
                        const isVideoSelected = (this.currentSlide && (this.currentSlide.getAttribute("data-type") === "video" || this.currentSlide.getAttribute("data-type") === "external_video" || (this.currentSlide.getAttribute("data-type") && this.currentSlide.getAttribute("data-type").includes("video"))));
                        const overlayElem = document.querySelector("[data-thumbnails-left] .custom-id-overlay");

                        if (isVideoSelected) {
                            if (this.thumbWrapper.querySelector(`.media__thumb.desktop`)) {
                                this.thumbWrapper.querySelector(`.media__thumb.desktop`).classList.remove("enable-custoization");
                            }
                            if (this.thumbWrapper.querySelector(`.media__thumb.mobile`)) {
                                this.thumbWrapper.querySelector(`.media__thumb.mobile`).classList.remove("enable-custoization");
                            }
                            if (overlayElem) {
                                overlayElem.style.display = "none";
                            }
                        } else {
                            // desktop
                            if (window.outerWidth > 767) {
                                if (this.thumbWrapper.querySelector(`.media__thumb.desktop`) && this.thumbWrapper.querySelector(`.media__thumb.desktop`).getAttribute('data-media-select') == r.getAttribute("data-media-select")) {
                                    this.thumbWrapper.querySelector(`.media__thumb.desktop`).classList.add("enable-custoization");
                                    if (overlayElem) overlayElem.style.display = "block";
                                } else {
                                    if (this.thumbWrapper.querySelector(`.media__thumb.desktop`)) {
                                        this.thumbWrapper.querySelector(`.media__thumb.desktop`).classList.remove("enable-custoization");
                                    }
                                    if (overlayElem) overlayElem.style.display = "none";
                                }
                            } else {
                                // mobile
                                if (this.thumbWrapper.querySelector(`.media__thumb.mobile`) && this.thumbWrapper.querySelector(`.media__thumb.mobile`).getAttribute('data-media-select') == r.getAttribute("data-media-select")) {
                                    this.thumbWrapper.querySelector(`.media__thumb.mobile`).classList.add("enable-custoization");
                                    if (overlayElem) overlayElem.style.display = "block";
                                } else {
                                    if (this.thumbWrapper.querySelector(`.media__thumb.mobile`)) {
                                        this.thumbWrapper.querySelector(`.media__thumb.mobile`).classList.remove("enable-custoization");
                                    }
                                    if (overlayElem) overlayElem.style.display = "none";
                                }
                            }
                        }
                        r.classList.add(Ra);
                        var imageId = r.getAttribute("data-media-select");
                        if (this.thumbWrapper.querySelector('.media__thumb.mobile[data-media-select="' + imageId + '"]')) {
                            this.thumbWrapper.querySelector('.media__thumb.mobile[data-media-select="' + imageId + '"]').classList.add(Ra);
                        }
                    }
                    this.slideshow.classList.add(Na.flickitylockHeight);
                    ((null == r ? void 0 : r.classList.contains(Va)) || this.currentSlide.classList.contains(Va)) && (this.lastMediaSelect ? this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                        detail: {
                            id: this.lastMediaSelect
                        }
                    })) : window.location.reload())
                }))
            }
            // },3000);
        }
        doFlktySettle(e) {
            this.allSlides = this.flkty.cells, this.currentSlide = this.flkty.cells[e].element, this.setDraggable();
            document.body.classList.contains(Na.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")), this.scrollThumbs()
        }
        doImageChange(e) {
            var t = e.detail.id;
            this.lastMediaSelect = t;
            const i = `[${Na.dataMediaId}="${t}"]`,
                s = this.flkty.cells.findIndex((e => e.element.matches(i)));
            this.flkty.select(s), this.scrollThumbs()
        }
        doThumbContainerScroll() {
            this.scrollThumbs("scroll")
        }
        doArrowPrevClick() {
            this.scrollThumbs("clickPrev")
        }
        doArrowNextClick() {
            this.scrollThumbs("clickNext")
        }
        doThumbClick(e) {
            const t = e.currentTarget.getAttribute(Na.dataMediaSelect);
            this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                detail: {
                    id: t
                }
            }))
        }
        setDraggable() {
            this.currentSlide && (this.mediaType = this.currentSlide.getAttribute(Na.mediaType), "model" === this.mediaType || "video" === this.mediaType || "external_video" === this.mediaType ? Ae.isMobile() && Ae.isTouch() ? this.updateDraggable(!0) : (this.currentSlide.dispatchEvent(new CustomEvent("play")), this.updateDraggable(!1)) : this.updateDraggable(!0))
        }
        updateDraggable(e) {
            this.flkty && (this.flkty.options.draggable = e, this.flkty.updateDraggable(), this.slideshow.classList.toggle(za, e))
        }
        detect3d() {
            const e = this.container.querySelectorAll(Na.modelViewer);
            e && (e.forEach((e => {
                ! function (e, t) {
                    _a[t] = {
                        loaded: !1
                    };
                    const i = e.getAttribute($a),
                        s = e.querySelector(Ma),
                        r = s.getAttribute(Ia);
                    if (null !== e.closest(Ca)) {
                        const i = e.closest(Ca).parentElement.querySelector(Pa);
                        qa[t] = {
                            $element: i,
                            defaultId: r
                        }
                    }
                    Aa[i] = {
                        modelId: r,
                        mediaId: i,
                        sectionId: t,
                        $container: e,
                        $element: s
                    }, window.Shopify.loadFeatures([{
                        name: "shopify-xr",
                        version: "1.0",
                        onLoad: Ha
                    }, {
                        name: "model-viewer-ui",
                        version: "1.0",
                        onLoad: Fa
                    }])
                }(e, this.section.id), e.addEventListener("theme:media:play", (() => {
                    this.updateDraggable(!1)
                })), e.addEventListener("theme:media:pause", (() => {
                    this.updateDraggable(!0)
                }))
            })), document.addEventListener("shopify_xr_launch", function () {
                this.container.querySelectorAll(Na.allPlayers).forEach((e => {
                    e.dispatchEvent(new CustomEvent("pause"))
                }))
            }.bind(this)))
        }
        detectVideos() {
            const e = this.section.container.querySelectorAll(`${Na.videoPlayerExternal}, ${Na.videoPlayerNative}`);
            for (var t of e) {
                const e = t.dataset.player,
                    i = t.dataset.host;
                let s;
                s = "youtube" === i ? io(e) : "vimeo" === i ? oo(e) : Wa(e), !0 === this.loopVideo && s.then((e => i ? Ga(e, i) : (e.loop = !0, e))).catch((e => {
                    console.error(e)
                })), this.addMediaEventListeners(t)
            }
        }
        pauseAllMedia() {
            this.container.querySelector(Na.mediaSlide).dispatchEvent(new CustomEvent("pause"))
        }
        pauseOtherMedia(e) {
            this.container.querySelector(`${Na.mediaSlide}:not([data-player="${e}"])`).dispatchEvent(new CustomEvent("pause"))
        }
        destroy() {
            this.container.querySelectorAll(Na.allPlayers).forEach((e => {
                e.dispatchEvent(new CustomEvent("destroy"))
            }))
        }
        scrollThumbs(e) {
            if (this.thumbs = this.container.querySelector(Na.productThumbs), this.thumbs) {
                if (this.thumb = this.thumbs.querySelector(`.${Ra}`), this.thumbItems = this.container.querySelectorAll(Na.thumbImage), this.lastThumb = this.thumbItems[this.thumbItems.length - 1], !this.thumb) return;
                this.thumbsScrollTop = this.thumbs.scrollTop, this.thumbsScrollLeft = this.thumbs.scrollLeft, this.thumbsWidth = this.thumbs.offsetWidth, this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(Na.aspectRatio), this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight, this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth, this.checkThumbPositions(), this.toggleToActiveThumb(e), this.toggleArrows()
            }
        }
        checkThumbPositions() {
            this.thumbWidth = this.thumb.offsetWidth, this.thumbHeight = this.thumb.offsetHeight, this.thumbPosTop = this.thumb.offsetTop, this.thumbPosLeft = this.thumb.offsetLeft, this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth, this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight, this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2, this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2, this.topCheck = this.thumbsScrollTop > 0, this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos, this.leftCheck = this.thumbsScrollLeft > 0, this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos, this.verticalCheck = this.bottomCheck || this.topCheck, this.horizontalCheck = this.rightCheck || this.leftCheck
        }
        toggleToActiveThumb(e) {
            "scroll" !== e && ("clickPrev" == e && (this.verticalCheck ? (this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight, this.scrollLeftPosition = 0) : (this.scrollTopPosition = 0, this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth)), "clickNext" == e && (this.verticalCheck ? (this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight, this.scrollLeftPosition = 0) : (this.scrollTopPosition = 0, this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth)), this.thumbs.scrollTo({
                top: this.scrollTopPosition,
                left: this.scrollLeftPosition,
                behavior: "smooth"
            }))
        }
        toggleArrows() {
            (this.verticalCheck || this.verticalAlignment && !this.verticalCheck) && (this.arrowPrev.classList.toggle(ja, this.topCheck), this.arrowNext.classList.toggle(ja, this.bottomCheck)), (this.horizontalCheck || !this.verticalAlignment && !this.horizontalCheck) && (this.arrowPrev.classList.toggle(ja, this.leftCheck), this.arrowNext.classList.toggle(ja, this.rightCheck))
        }
        constructor(e) {
            this.section = e, this.container = e.container, this.slideshow = this.container.querySelector(Na.productSlideshow), this.mobileStyle = this.slideshow.getAttribute(Na.slideshowMobileStyle), this.desktopStyle = this.slideshow.getAttribute(Na.slideshowDesktopStyle), this.arrowPrev = this.container.querySelector(Na.arrowPrev), this.arrowNext = this.container.querySelector(Na.arrowNext), this.leftThumbsHolder = this.container.querySelector(Na.leftThumbsHolder), this.thumbWrapper = this.container.querySelector(Na.productThumbs), this.thumbImages = this.container.querySelectorAll(Na.thumbImage), this.loopVideo = "true" === this.container.getAttribute(Na.loopVideo), this.verticalAlignment = Boolean(this.container.querySelector(Na.verticalAlignment)), this.flkty = null, this.lastMediaSelect = null, this.thumbs = this.container.querySelector(Na.productThumbs), this.currentSlide = null, this.mediaType = null, this.hasMobileSlider = !1, this.hasDesktopSlider = !1, this.init()
        }
    };

    function Ga(e, t) {
        return "youtube" === t ? e.addEventListener("onStateChange", (e => {
            0 === e.data && e.target.playVideo()
        })) : "vimeo" === t && e.on("ended", (() => {
            e.play()
        })), e
    }
    const Ja = "data-store-availability-container",
        Qa = "[data-api-content]",
        Ya = "[data-pickup-drawer]",
        Ka = "[data-pickup-drawer-open]",
        Xa = "[data-pickup-drawer-close]",
        Za = "[data-pickup-body]",
        el = "drawer--visible",
        tl = "hide",
        il = "is-pickup-visible";
    let sl = {};
    const rl = {
        onLoad() {
            sl[this.id] = new class {
                fetchPickupAvailability(e) {
                    const t = this.container.querySelector(`[${Ja}]`);
                    if (!t) return;
                    const i = e && e.detail.variant ? e.detail.variant.id : t.getAttribute(Ja);
                    !e || e.detail.variant ? i && fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`).then(this.handleErrors).then((e => e.text())).then((e => {
                        const i = (new DOMParser).parseFromString(e, "text/html").querySelector(Qa).innerHTML;
                        t.innerHTML = i, t.classList.remove(tl), this.drawer = this.container.querySelector(Ya), this.buttonDrawerOpen = this.container.querySelector(Ka), this.buttonDrawerClose = this.container.querySelectorAll(Xa), this.drawerBody = this.container.querySelector(Za), this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", (() => this.openDrawer())), this.buttonDrawerClose.length && this.buttonDrawerClose.forEach((e => {
                            e.addEventListener("click", (() => this.closeDrawer()))
                        }))
                    })).catch((e => {
                        console.error(e)
                    })) : t.classList.add(tl)
                }
                openDrawer() {
                    this.drawer && (document.body.classList.add(il), this.drawer.classList.add(el), this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    })), this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    })))
                }
                closeDrawer() {
                    this.drawer && (document.body.classList.remove(il), this.drawer.classList.remove(el), this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })), this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })))
                }
                handleErrors(e) {
                    return e.ok ? e : e.json().then((function (t) {
                        throw new Z({
                            status: e.statusText,
                            headers: e.headers,
                            json: t
                        })
                    }))
                }
                constructor(e) {
                    this.container = e.container, this.drawer = null, this.buttonDrawerOpen = null, this.buttonDrawerClose = null, this.drawerBody = null, this.fetchPickupAvailability(), this.container.addEventListener("theme:variant:change", (e => this.fetchPickupAvailability(e)))
                }
            }(this)
        }
    },
        nl = "[data-quantity-selector]",
        ol = "[data-increase-quantity]",
        al = "[data-decrease-quantity]",
        ll = "[data-quantity-input]";

    function cl(e) {
        e.querySelectorAll(nl).forEach((e => {
            new class {
                initButtons() {
                    this.increase.addEventListener("click", function (e) {
                        e.preventDefault();
                        let t = parseInt(this.input.value, 10);
                        t = isNaN(t) ? 0 : t, t++, this.input.value = t, this.input.dispatchEvent(new Event("change"))
                    }.bind(this)), this.decrease.addEventListener("click", function (e) {
                        e.preventDefault();
                        let t = parseInt(this.input.value, 10);
                        t = isNaN(t) ? 0 : t, t--, t = Math.max(this.min, t), this.input.value = t, this.input.dispatchEvent(new Event("change"))
                    }.bind(this))
                }
                constructor(e) {
                    this.wrapper = e, this.increase = this.wrapper.querySelector(ol), this.decrease = this.wrapper.querySelector(al), this.input = this.wrapper.querySelector(ll), this.min = parseInt(this.input.getAttribute("min"), 10), this.initButtons()
                }
            }(e)
        }))
    }
    const hl = "[data-product-form]",
        dl = "data-option-position",
        ul = '[name^="options"], [data-popout-option]',
        pl = "data-value",
        ml = "sold-out",
        fl = "unavailable";
    const gl = "[data-section-id]",
        yl = "[data-quickview-modal]",
        vl = "[data-product-form-wrapper]",
        bl = "[data-product-form]",
        wl = "[data-product-slideshow]",
        Sl = "[data-add-to-cart]",
        El = "[data-add-to-cart-text]",
        Ll = "[data-compare-price]",
        kl = "[data-compare-text]",
        Tl = "[data-buttons-wrapper]",
        xl = "[data-product-select]",
        _l = "[data-price-wrapper]",
        Al = "[data-button-price]",
        ql = "[data-product-json]",
        Cl = "[data-product-price]",
        Pl = "[data-product-unit-price]",
        $l = "[data-product-base]",
        Il = "[data-product-unit]",
        Ml = "data-enable-history-state",
        Dl = "data-option-position",
        Ol = "[data-option-value]",
        Hl = "[data-subscription-watch-price]",
        Fl = "[data-subscription-selectors]",
        Bl = "[data-price-off]",
        Wl = "[data-price-off-type]",
        Nl = "[data-price-off-amount]",
        Rl = "[data-toggles-group]",
        jl = "data-group-toggle",
        zl = "[data-plan-description]",
        Vl = "[data-remaining-count]",
        Ul = "data-remaining-max",
        Gl = "[data-remaining-wrapper]",
        Jl = "[data-product-remaining-json]",
        Ql = "[data-product-preorder]",
        Yl = "hide",
        Kl = "variant--soldout",
        Xl = "variant--unavailable",
        Zl = "product__price--sale",
        ec = "count-is-low",
        tc = "count-is-in",
        ic = "count-is-out",
        sc = "count-is-unavailable";
    let rc = class extends HTMLElement {
        connectedCallback() {
            this.outerSection = this.container.closest(gl), this.quickview = this.container.closest(yl), this.outerWrapper = this.quickview ? this.quickview : this.outerSection, this.productFormWrapper = this.container.closest(vl), this.productFormElement = this.container.querySelector(bl), this.productForm = this.container.querySelector(bl), this.slideshow = this.outerWrapper.querySelector(wl), this.enableHistoryState = !(!this.outerSection || !this.outerSection.hasAttribute(Ml)) && "true" === this.outerSection.getAttribute(Ml), this.hasUnitPricing = this.outerWrapper.querySelector(Il), this.subSelectors = this.outerWrapper.querySelector(Fl), this.subPrices = this.outerWrapper.querySelector(Hl), this.priceOffWrap = this.outerWrapper.querySelector(Bl), this.priceOffAmount = this.outerWrapper.querySelector(Nl), this.priceOffType = this.outerWrapper.querySelector(Wl), this.planDecription = this.outerWrapper.querySelector(zl), this.isPreOrder = this.container.querySelector(Ql), this.remainingWrapper = this.outerWrapper.querySelector(Gl);
            const e = this.outerWrapper.querySelector(`[${Ul}]`);
            this.sellout = null, this.remainingWrapper && e && (this.remainingMaxInt = parseInt(e.getAttribute(Ul), 10), this.remainingCount = this.outerWrapper.querySelector(Vl), this.remainingJSONWrapper = this.outerWrapper.querySelector(Jl), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON")), cl(this.outerWrapper);
            let t = null;
            this.productJSON = null;
            const i = this.outerWrapper.querySelector(ql);
            i && (t = i.innerHTML), t && this.productForm ? (this.productJSON = JSON.parse(t), this.sellout = new class {
                init() {
                    this.update()
                }
                update() {
                    this.getCurrentState(), this.optionElements.forEach((e => {
                        const t = e.value || e.getAttribute(pl),
                            i = e.closest(`[${dl}]`).getAttribute(dl),
                            s = parseInt(i, 10) - 1;
                        let r = [...this.selections];
                        r[s] = t;
                        const n = this.productJSON.variants.find((e => {
                            let t = !0;
                            for (let i = 0; i < r.length; i++) e.options[i] !== r[i] && (t = !1);
                            return t
                        }));
                        e.classList.remove(ml, fl), void 0 === n ? e.classList.add(fl) : n && !1 === n.available && e.classList.add(ml)
                    }))
                }
                getCurrentState() {
                    for (var e of (this.formData = new FormData(this.form), this.selections = [], this.formData.entries())) e[0].includes("options[") && this.selections.push(e[1])
                }
                constructor(e, t) {
                    this.container = e, this.productJSON = t, this.form = this.container.querySelector(hl), this.formData = new FormData(this.form), this.optionElements = this.container.querySelectorAll(ul), this.productJSON && this.form && this.init()
                }
            }(this.outerWrapper, this.productJSON), this.linkForm()) : console.warn("Missing product form or product JSON"), this.productJSON && new class {
                updateCookie() {
                    let e = this.cookie.read();
                    const t = e.indexOf(this.handle); - 1 === t ? (e.unshift(this.handle), e = e.splice(0, ue)) : (e.splice(t, 1), e.unshift(this.handle)), this.cookie.write(e)
                }
                constructor(e) {
                    this.handle = e, this.cookie = new he(ke), void 0 !== this.handle && (xe.push(this.handle), this.updateCookie())
                }
            }(this.productJSON.handle)
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new class {
                destroy() {
                    this._listeners.removeAll()
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, (function (e) {
                        return e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2], e
                    }))
                }
                variant() {
                    const e = this.options();
                    return e.length ? Ce(this.product, e) : this.product.variants[0]
                }
                plan(e) {
                    let t = {
                        allocation: null,
                        group: null,
                        detail: null
                    };
                    const i = new FormData(this.form).get("selling_plan");
                    if (e && e.selling_plan_allocations && e.selling_plan_allocations.length > 0) {
                        const t = [...new Set(e.selling_plan_allocations.map((e => e.selling_plan_group_id)))],
                            i = this.element.querySelectorAll("[data-subscription-group]");
                        if (!i.length) return;
                        i.forEach((e => e.style.display = "none")), t.forEach((e => {
                            this.element.querySelector(`[data-selling-plan-group="${e}"]`).style.display = "block"
                        }))
                    }
                    return i && e && (t.allocation = e.selling_plan_allocations.find((function (e) {
                        return e.selling_plan_id.toString() === i.toString()
                    }))), t.allocation && (t.group = this.product.selling_plan_groups.find((function (e) {
                        return e.id.toString() === t.allocation.selling_plan_group_id.toString()
                    }))), t.group && (t.detail = t.group.selling_plans.find((function (e) {
                        return e.id.toString() === i.toString()
                    }))), t && t.allocation && t.detail && t.allocation ? t : null
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, (function (e) {
                        return e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2], e
                    }))
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                }
                getFormState() {
                    const e = this.variant();
                    return {
                        options: this.options(),
                        variant: e,
                        properties: this.properties(),
                        quantity: this.quantity(),
                        plan: this.plan(e)
                    }
                }
                _setIdInputValue(e) {
                    e && e.id ? this.variantElement.value = e.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                }
                _onSubmit(e, t) {
                    t.dataset = this.getFormState(), e.onFormSubmit && e.onFormSubmit(t)
                }
                _onOptionChange(e) {
                    this._setIdInputValue(e.dataset.variant)
                }
                _onFormEvent(e) {
                    return void 0 === e ? Function.prototype : function (t) {
                        t.dataset = this.getFormState(), this._setIdInputValue(t.dataset.variant), e(t)
                    }.bind(this)
                }
                _initInputs(e, t) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(function (e) {
                        return this._listeners.add(e, "change", this._onFormEvent(t)), e
                    }.bind(this))
                }
                _serializeInputValues(e, t) {
                    return e.reduce((function (e, i) {
                        return (i.checked || "radio" !== i.type && "checkbox" !== i.type) && e.push(t({
                            name: i.name,
                            value: i.value
                        })), e
                    }), [])
                }
                _validateProductObject(e) {
                    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
                    if (void 0 === e.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return e
                }
                constructor(e, t, i, s) {
                    this.element = e, this.form = "FORM" == t.tagName ? t : t.querySelector("form"), this.product = this._validateProductObject(i), this.variantElement = this.form.querySelector($e), s = s || {}, this.clickedElement = null, this._listeners = new qe, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)), this.optionInputs = this._initInputs(Me, s.onOptionChange), this.planInputs = this._initInputs(Ie, s.onPlanChange), this.quantityInputs = this._initInputs(De, s.onQuantityChange), this.propertyInputs = this._initInputs(Oe, s.onPropertyChange)
                }
            }(this.outerWrapper, this.productFormElement, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this),
                onQuantityChange: this.onQuantityChange.bind(this)
            }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
        }
        onOptionChange(e) {
            console.log("e", e);

            /* variants hower text logic start */
            const hoverTextData = document.querySelector('#preorder-hover-text-data');

            if (hoverTextData && e.dataset.variant) {
                const productHoverText = hoverTextData.getAttribute('data-product-hover-text') || '';
                const variantHoverTexts = JSON.parse(
                    hoverTextData.getAttribute('data-variant-hover-text') || '{}'
                );

                const selectedVariantId = e.dataset.variant.id;
                const variantHoverText = variantHoverTexts[selectedVariantId] || '';

                // Product metafield has first priority.
                // If product metafield is blank, use selected variant metafield.
                // If both are blank, clear the text.
                const hoverText = productHoverText.trim()
                    ? productHoverText
                    : variantHoverText.trim();

                const hoverTextElement = document.querySelector(
                    '.product__submit__buttons [data-preorder-hover-text]'
                );

                if (hoverTextElement) {
                    hoverTextElement.textContent = hoverText;
                }
            }

            /* variants hower text logic end */
            this.outerWrapper.querySelectorAll("[data-popout-list] li").forEach((sizeRemoveSpan) => {
                if (sizeRemoveSpan.querySelector(".inventory-status")) {
                    sizeRemoveSpan.querySelector(".inventory-status").remove();
                }
            });

            if (document.getElementById('invidcheck') && document.getElementById('invidcheck').getAttribute('data-inv-id')) {

                console.log("MAIN: invidcheck found with data-inv-id");

                if (document.querySelector(".productsold")) {
                    console.log("ACTION: Removed productsold class");
                    document.querySelector(".productsold").classList.remove("productsold");
                }

                if (document.querySelector('.product__submit__buttons [cdata-add-to-cart-text]').getAttribute('data-preorder')) {

                    console.log("MAIN: Preorder metafield detected");

                    if (e.dataset.variant.inventory_policy == 'continue' && e.dataset.variant.inventory_quantity >= 1) {
                        console.log("IF-1: Continue selling + inventory >=1");

                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: IN-STOCK – READY TO SHIP");
                            // document.querySelector("#variant-inventoryy").innerHTML = "IN-STOCK – READY TO SHIP";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: ADD TO CART");
                            document.querySelector('.btn-state-ready span').textContent = window.ATCButton;
                        }

                    } else if (e.dataset.variant.inventory_quantity >= 1) {
                        console.log("IF-2: Inventory >= 1");

                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: IN-STOCK – READY TO SHIP");
                            //  document.querySelector("#variant-inventoryy").innerHTML = "IN-STOCK – READY TO SHIP";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: ADD TO CART");
                            document.querySelector('.btn-state-ready span').textContent = window.ATCButton;
                        }

                    } else if (e.dataset.variant.inventory_policy == 'continue' && e.dataset.variant.inventory_quantity <= 0) {
                        console.log("IF-3: Continue selling + inventory <= 0 (PREORDER CASE)");

                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: PREORDER HOVER TEXT");
                            // document.querySelector("#variant-inventoryy").innerHTML =
                            //   document.querySelector("#variant-inventoryy").getAttribute('data-preorderhover');
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: PREORDER TEXT");
                            document.querySelector('.btn-state-ready span').textContent =
                                document.querySelector('.product__submit__buttons [cdata-add-to-cart-text]').getAttribute('data-preorder');
                        }

                    } else if (e.dataset.variant.inventory_quantity <= 0) {
                        console.log("IF-4: Inventory <= 0 (SOLD OUT)");

                        if (document.querySelector(".product__submit__buttons")) {
                            console.log("ACTION: Added productsold class");
                            document.querySelector(".product__submit__buttons").classList.add("productsold");
                        }
                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: SOLD OUT");
                            //  document.querySelector("#variant-inventoryy").innerHTML = "SOLD OUT";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: SOLD OUT");
                            document.querySelector('.btn-state-ready span').textContent = 'SOLD OUT';
                        }

                    } else {
                        console.log("IF-5: DEFAULT PREORDER FALLBACK");

                        if (document.querySelector(".productsold")) {
                            console.log("ACTION: Removed productsold class");
                            document.querySelector(".productsold").classList.remove("productsold");
                        }
                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: MADE TO ORDER");
                            //  document.querySelector("#variant-inventoryy").innerHTML = "MADE TO ORDER - FINAL SALE";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: ADD TO CART");
                            document.querySelector('.btn-state-ready span').textContent = window.ATCButton;
                        }
                    }

                } else {
                    console.log("MAIN: Preorder metafield NOT detected (NORMAL MODE)");
                    if (e.dataset.variant.inventory_policy == 'continue' && e.dataset.variant.inventory_quantity > 0) {
                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: IN-STOCK – READY TO SHIP");
                            // document.querySelector("#variant-inventoryy").innerHTML = "IN-STOCK – READY TO SHIP";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: ADD TO CART");
                            document.querySelector('.btn-state-ready span').textContent = window.ATCButton;
                        }
                    } else if ((e.dataset.variant.inventory_policy == 'continue' && e.dataset.variant.inventory_quantity <= 0) || e.dataset.variant.inventory_management == null) {
                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: IN-STOCK – READY TO SHIP");
                            // document.querySelector("#variant-inventoryy").innerHTML = "MADE TO ORDER - FINAL SALE";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: ADD TO CART");
                            document.querySelector('.btn-state-ready span').textContent = window.ATCButton;
                        }
                    }
                    else if (e.dataset.variant.inventory_quantity >= 1) {
                        console.log("IF-2: Inventory >= 1");

                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: IN-STOCK – READY TO SHIP");
                            //  document.querySelector("#variant-inventoryy").innerHTML = "IN-STOCK – READY TO SHIP";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: ADD TO CART");
                            document.querySelector('.btn-state-ready span').textContent = window.ATCButton;
                        }

                    }
                    else if (e.dataset.variant.inventory_quantity <= 0) {
                        console.log("IF-4: Inventory <= 0 (SOLD OUT)");

                        if (document.querySelector(".product__submit__buttons")) {
                            console.log("ACTION: Added productsold class");
                            document.querySelector(".product__submit__buttons").classList.add("productsold");
                        }
                        if (document.querySelector("#variant-inventoryy")) {
                            console.log("SET: SOLD OUT");
                            // document.querySelector("#variant-inventoryy").innerHTML = "SOLD OUT";
                        }
                        if (document.querySelector('.btn-state-ready span')) {
                            console.log("BUTTON: SOLD OUT");
                            document.querySelector('.btn-state-ready span').textContent = 'SOLD OUT';
                        }
                    }

                }

            } else {

                console.log("MAIN: No invidcheck found (FALLBACK MODE)");

                if (document.querySelector(".productsold")) {
                    console.log("ACTION: Removed productsold class");
                    document.querySelector(".productsold").classList.remove("productsold");
                }

                if (e.dataset.variant.inventory_quantity > 0) {
                    console.log("FALLBACK: Inventory > 0 → IN STOCK");
                    if (document.querySelector("#variant-inventoryy")) {
                        // document.querySelector("#variant-inventoryy").innerHTML = "IN STOCK - READY TO SHIP";
                    }
                } else {
                    console.log("FALLBACK: Inventory <= 0 → MADE TO ORDER");
                    if (document.querySelector("#variant-inventoryy")) {
                        // document.querySelector("#variant-inventoryy").innerHTML = "MADE TO ORDER - FINAL SALE";
                    }
                }
            }




            var variantOption1 = this.productJSON.variants.filter(color => color.option1 === e.dataset.variant.option1);
            this.outerWrapper.querySelectorAll("[data-popout-list] li").forEach((colors, index) => {
                var colorName = colors.querySelector("span").innerHTML;

                /* if(variantOption1[index] && colorName.trim() == variantOption1[index].option2){
                   var createSpan = document.createElement("span");
                   createSpan.classList.add("inventory-status");
                   if(variantOption1[index].inventory_quantity > 0){
                     createSpan.textContent = "IN STOCK";
                   }else{
                     createSpan.textContent = "MADE TO ORDER";
                   }
                   if(!colors.querySelector(".inventory-status")){
                     colors.querySelector("a").appendChild(createSpan);
                   }
                 }*/
            });
            this.pushState(e.dataset);
            // Variant button text logic start
            const buttonTextElement = this.outerWrapper.querySelector(
                '[cdata-add-to-cart-text]'
            );

            if (buttonTextElement && e.dataset.variant) {
                const productButtonText =
                    buttonTextElement.getAttribute('data-product-button-text') || '';

                const variantButtonTexts = JSON.parse(
                    buttonTextElement.getAttribute('data-variant-button-text') || '{}'
                );

                const selectedVariantId = String(e.dataset.variant.id);

                const variantButtonText =
                    variantButtonTexts[selectedVariantId] || '';

                if (productButtonText.trim() !== '') {
                    // 1. Product metafield
                    buttonTextElement.textContent = productButtonText;

                } else if (variantButtonText.trim() !== '') {
                    // 2. Selected variant metafield
                    buttonTextElement.textContent = variantButtonText;

                } else {
                    // 3. Variant metafield blank → default button text
                    buttonTextElement.textContent = window.ATCButton;
                }
            }
            // Variant button text logic end
        }
        onPlanChange(e) {
            this.subPrices && this.pushState(e.dataset)
        }
        onQuantityChange(e) {
            const t = e.dataset;
            this.productState = this.setProductState(t), this.updateButtonPrices(t)
        }
        pushState(e, t = !1) {
            if (!document.querySelector("product-form form .line-item-property__field #custom-name")) {
                var desktopDetections = ".desktop";
                if (window.matchMedia("(max-width: 767px)").matches) {
                    var desktopDetections = ".mobile";
                }
                e.options.forEach((option) => {
                    // if(option.name == "Color" || option.name == "color" || option.name == 'Letter'){
                    if (option.name == "Enamel Color" || option.name == "enamel color" || option.name == "Stone Color" || option.name == "stone color" || option.name == "Gold Color" || option.name == "gold color" || option.name == "Color" || option.name == "color" || option.name == 'Zodiac' || option.name == "Charm" || option.name == "charm" || (option.name == 'Letter' && productHandle == "new-mrs-ring") || (productID == "9087136727253" && option.name == "Size")) {
                        if (flkty) {
                            flkty.destroy();
                        }
                        document.querySelector("[data-product-thumbs]").innerHTML = "";
                        setTimeout(() => {
                            if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                document.querySelector("[data-product-slideshow] div.flickity-slider").innerHTML = "";
                            } else {
                                setTimeout(() => {
                                    if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                        document.querySelector("[data-product-slideshow] div.flickity-slider").innerHTML = "";
                                    } else {
                                        setTimeout(() => {
                                            if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                document.querySelector("[data-product-slideshow] div.flickity-slider").innerHTML = "";
                                            } else {
                                                setTimeout(() => {
                                                    if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                        document.querySelector("[data-product-slideshow] div.flickity-slider").innerHTML = "";
                                                    } else {
                                                        setTimeout(() => {
                                                            if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                                document.querySelector("[data-product-slideshow] div.flickity-slider").innerHTML = "";
                                                            }
                                                        }, 1000);
                                                    }
                                                }, 1000);
                                            }
                                        }, 1000);
                                    }
                                }, 1000);
                            }
                        }, 10);
                        setTimeout(() => {
                            if (document.querySelector("[data-product-slideshow]") && !document.querySelector("[data-product-slideshow]").classList.contains("flickity-lock-height")) {
                                document.querySelector("[data-product-slideshow]").classList.add("flickity-lock-height");
                            } else {
                                setTimeout(() => {
                                    document.querySelector("[data-product-slideshow]").classList.add("flickity-lock-height");
                                }, 1000);
                            }
                        }, 10);
                        var indexImages = 0;

                        // Remove duplicates
                        const uniqueOptions = [...new Set(allOptions)];

                        var indexImages = 0;

                        productImages.forEach((events, index) => {

                            console.log(`Media ${index + 1}:`, events);

                            console.log({
                                id: events.id,
                                media_type: events.media_type,
                                alt: events.alt,
                                position: events.position,
                                src: events.src,
                                preview_image: events.preview_image,
                                sources: events.sources
                            });

                            const isVideo = events.media_type === "video" || events.media_type === "external_video" || (events.media_type && events.media_type.includes("video"));
                            const thumbnailSrc = (events.preview_image && events.preview_image.src) ? events.preview_image.src : (events.src || "");
                            const mediaSrc = events.src || thumbnailSrc;

                            const optionValueNormalized =
                                option.name == "Enamel Color" || option.name == "enamel color" || option.name == "Stone Color" || option.name == "stone color" || option.name == "Gold Color" || option.name == "gold color" || option.name == "Color" || option.name == "color"
                                    ? option.value.toLowerCase().replace(/\//g, '').replace(/\s+/g, '')
                                    : option.value.toLowerCase().replace(/\s+/g, '');

                            const hasSubstringConflict = uniqueOptions.some(
                                opt => opt !== optionValueNormalized && opt.includes(optionValueNormalized)
                            );

                            let matches = false;

                            if (isVideo) {
                                const rawAlt = (events.alt || "").split('#')[0].trim().toLowerCase();

                                if (rawAlt === "additional" || rawAlt.includes("additional")) {
                                    matches = true;
                                } else {
                                    const altNormalized =
                                        option.name == "Enamel Color" || option.name == "enamel color" || option.name == "Stone Color" || option.name == "stone color" || option.name == "Gold Color" || option.name == "gold color" || option.name == "Color" || option.name == "color"
                                            ? rawAlt.replace(/\//g, '').replace(/\s+/g, '')
                                            : rawAlt.replace(/\s+/g, '');

                                    const altParts = rawAlt.split(/[-_\s]+/);
                                    const colorFromAlt = altParts.find(part => uniqueOptions.includes(part.replace(/\//g, ''))) || "";

                                    if (productHandle == "new-mrs-ring" && option.name == "Letter") {
                                        matches = altParts.some(
                                            part => part === `mrs${option.value.toLowerCase().trim()}`
                                        );
                                    } else {
                                        matches = hasSubstringConflict
                                            ? colorFromAlt === optionValueNormalized
                                            : (
                                                option.name == "Enamel Color" || option.name == "enamel color" || option.name == "Stone Color" || option.name == "stone color" || option.name == "Gold Color" || option.name == "gold color" || option.name == "Color" || option.name == "color"
                                                    ? altNormalized.includes(optionValueNormalized)
                                                    : rawAlt.includes(option.value.toLowerCase().split(' ').join(''))
                                            );
                                    }
                                }
                            } else {
                                const filename =
                                    option.name == "Enamel Color" || option.name == "enamel color" || option.name == "Stone Color" || option.name == "stone color" || option.name == "Gold Color" || option.name == "gold color" || option.name == "Color" || option.name == "color"
                                        ? mediaSrc.split('/').pop().split('.')[0].toLowerCase().replace(/\//g, '').replace(/\s+/g, '')
                                        : mediaSrc.split('/').pop().split('.')[0].toLowerCase().replace(/\s+/g, '');

                                // Split filename by both '-' and '_'
                                const filenameParts = filename.split(/[-_]/);

                                // Check if any part matches the option
                                const colorFromImage = filenameParts.find(part => uniqueOptions.includes(part)) || "";

                                console.log("colorFromImage", colorFromImage);
                                console.log("optionValueNormalized", optionValueNormalized);

                                if (productHandle == "new-mrs-ring" && option.name == "Letter") {

                                    const filenameRaw = mediaSrc
                                        .split('/')
                                        .pop()
                                        .split('.')[0]
                                        .toLowerCase();

                                    const filenamePartsRaw = filenameRaw.split(/[-_]/);

                                    matches = filenamePartsRaw.some(
                                        part => part === `mrs${option.value.toLowerCase().trim()}`
                                    );

                                } else {

                                    matches = hasSubstringConflict
                                        ? colorFromImage === optionValueNormalized
                                        : (
                                            option.name == "Enamel Color" || option.name == "enamel color" || option.name == "Stone Color" || option.name == "stone color" || option.name == "Gold Color" || option.name == "gold color" || option.name == "Color" || option.name == "color"
                                                ? filename.includes(optionValueNormalized)
                                                : mediaSrc.includes(option.value.split(' ').join(''))
                                        );

                                }
                            }

                            console.log("matches ", matches);

                            const isAdditional = events.alt === "additional" || (events.alt && events.alt.toLowerCase().includes("additional"));

                            if (isAdditional || matches) {
                                // Desktop Image Div
                                var imageParentDiv = document.createElement("div");
                                if (indexImages <= 0 && indexImages != 1) {
                                    imageParentDiv.classList.add("media__thumb", "desktop", "is-activated");
                                } else {
                                    imageParentDiv.classList.add("media__thumb", "desktop");
                                    imageParentDiv.classList.remove('is-activated');
                                    if (imageParentDiv.classList.contains('is-activated')) {
                                        imageParentDiv.classList.remove('is-activated');
                                    }
                                }
                                imageParentDiv.setAttribute("onclick", "selectedImages(this);");
                                imageParentDiv.setAttribute("data-slideshow-thumbnail", "");
                                imageParentDiv.setAttribute("data-aspect-ratio", "0.6666666666666666");
                                imageParentDiv.setAttribute("data-media-select", events.id);
                                //   imageParentDiv.setAttribute("aria-label",option.value+" "+events.media_type+" "+parseInt(indexImages+1));
                                imageParentDiv.setAttribute("data-image-filter", "");

                                // Mobile Image Div
                                var imageParentDivMobile = document.createElement("div");
                                if (indexImages <= 0) {
                                    imageParentDivMobile.classList.add("media__thumb", "mobile", "is-activated");
                                } else {
                                    imageParentDivMobile.classList.add("media__thumb", "mobile");
                                    if (imageParentDivMobile.classList.contains('is-activated')) {
                                        imageParentDivMobile.classList.remove('is-activated');
                                    }
                                }
                                imageParentDivMobile.setAttribute("data-slideshow-thumbnail", "");
                                imageParentDivMobile.setAttribute("data-aspect-ratio", "0.6666666666666666");
                                imageParentDivMobile.setAttribute("onclick", "MobileSelectedImage(this);");
                                imageParentDivMobile.setAttribute("data-media-select", events.id);
                                imageParentDivMobile.setAttribute("data-image-filter", "");
                                //   imageParentDivMobile.setAttribute("aria-label",option.value+" "+events.media_type+" "+parseInt(indexImages+1));

                                // Desktop Image
                                var imageDiv = document.createElement("img");
                                imageDiv.classList.add("loading-shimmer");
                                imageDiv.setAttribute("src", thumbnailSrc);
                                var image_alt = events.alt;
                                if (events.alt == null || events.alt == "") {
                                    image_alt = (isVideo ? "video " : "image ") + parseInt(indexImages + 1);
                                }
                                imageDiv.setAttribute("alt", image_alt);
                                imageParentDiv.appendChild(imageDiv);

                                if (isVideo) {
                                    var videoIconDesktop = document.createElement("div");
                                    videoIconDesktop.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>';
                                    imageParentDiv.appendChild(videoIconDesktop.firstElementChild);
                                }

                                // Mobile Image
                                var imageDivMobile = document.createElement("button");
                                imageDivMobile.classList.add("dot");
                                imageDivMobile.setAttribute("type", "button");
                                imageDivMobile.setAttribute("data-index", parseInt(indexImages + 1));
                                imageParentDivMobile.appendChild(imageDivMobile);

                                if (isVideo) {
                                    var videoIconMobile = document.createElement("div");
                                    videoIconMobile.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>';
                                    imageParentDivMobile.appendChild(videoIconMobile.firstElementChild);
                                }

                                var imageDisplayDiv = document.createElement("div");
                                if (indexImages <= 0) {
                                    imageDisplayDiv.classList.add("product__media", "flickity-cell", "is-selected");
                                } else {
                                    imageDisplayDiv.classList.add("product__media", "flickity-cell");
                                    imageDisplayDiv.classList.remove('is-activated');
                                    if (imageDisplayDiv.classList.contains('is-activated')) {
                                        imageDisplayDiv.classList.remove('is-activated');
                                    }
                                }
                                imageDisplayDiv.setAttribute("role", "group");
                                imageDisplayDiv.setAttribute("data-media-slide", "");
                                imageDisplayDiv.setAttribute("data-media-id", events.id);
                                imageDisplayDiv.setAttribute("data-media-src-placeholder", thumbnailSrc);
                                imageDisplayDiv.setAttribute("data-type", events.media_type);
                                //   imageDisplayDiv.setAttribute("aria-label",option.value+" "+events.media_type);
                                imageDisplayDiv.setAttribute("data-image-filter", "");
                                var aspectRatio = events.aspect_ratio || (events.preview_image && events.preview_image.aspect_ratio) || 0.6666666666666666;
                                imageDisplayDiv.setAttribute("data-aspect-ratio", aspectRatio);
                                imageDisplayDiv.setAttribute("style", "transform: translateX(-50%); opacity: 1;");
                                var image_alt = events.alt;
                                if (events.alt == null || events.alt == "") {
                                    image_alt = (isVideo ? "video " : "image ") + parseInt(indexImages + 1);
                                }

                                if (isVideo) {
                                    let sectionId = "";
                                    const sectionElem = document.querySelector("[data-section-id]");
                                    if (sectionElem) {
                                        sectionId = sectionElem.getAttribute("data-section-id");
                                    }
                                    let playerAttr = sectionId ? (sectionId + "-" + events.id) : events.id;
                                    imageDisplayDiv.setAttribute("data-player", playerAttr);

                                    var videoSourcesHtml = "";
                                    if (events.sources && events.sources.length) {
                                        events.sources.forEach(function (srcObj) {
                                            if (srcObj.url) {
                                                videoSourcesHtml += '<source src="' + srcObj.url + '" type="' + (srcObj.mime_type || 'video/mp4') + '">';
                                            }
                                        });
                                    }
                                    var paddingTop = (1 / (events.aspect_ratio || (events.preview_image && events.preview_image.aspect_ratio) || 1)) * 100;
                                    imageDisplayDiv.innerHTML = '<div class="media__contain" style="padding-top: ' + paddingTop.toFixed(1) + '%;"><video playsinline="playsinline" class="media-video" preload="metadata" aria-label="' + image_alt + '" poster="' + thumbnailSrc + '">' + videoSourcesHtml + '<img alt="' + image_alt + '" src="' + thumbnailSrc + '"></video></div>';
                                } else {
                                    imageDisplayDiv.innerHTML = '<div><div class="lazy-image mobile-zoom-wrapper"><div class="relative block w-full h-full overflow-hidden" style="--wh-ratio: ;"><img src="' + thumbnailSrc + '" alt="' + image_alt + '" width="1200" height="1800" loading="lazy" class="block overflow-hidden w-full h-full object-cover transition-opacity duration-300 ease-linear" sizes="(min-width: 1100px) 70vw, (min-width: 768px) 50vw, calc(85vw - 20px)" fetchpriority="high" style="object-position: center center; "></div><div class="media__buttons__holder"><button class="media__button media__button--zoom"  onclick="zoomImages(this);"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="icon-theme icon-theme-stroke icon-core-magnify" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M18.316 9.825c0 3.368-2.05 6.404-5.194 7.692a8.47 8.47 0 0 1-9.164-1.81A8.265 8.265 0 0 1 2.144 6.63C3.45 3.52 6.519 1.495 9.921 1.5c4.638.007 8.395 3.732 8.395 8.325ZM22.5 22.5l-6.558-6.87L22.5 22.5Z"></path></svg><span class="visually-hidden">Zoom</span></button></div></div></div></div></div>';
                                }
                                setTimeout(() => {
                                    if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                        console.log("[Flickity] try....");
                                        document.querySelector("[data-product-slideshow] div.flickity-slider").appendChild(imageDisplayDiv);
                                    } else {
                                        setTimeout(() => {
                                            if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                console.log("[Flickity] try....");
                                                document.querySelector("[data-product-slideshow] div.flickity-slider").appendChild(imageDisplayDiv);
                                            } else {
                                                setTimeout(() => {
                                                    if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                        console.log("[Flickity] try....");
                                                        document.querySelector("[data-product-slideshow] div.flickity-slider").appendChild(imageDisplayDiv);
                                                    } else {
                                                        setTimeout(() => {
                                                            if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                                console.log("[Flickity] try....");
                                                                document.querySelector("[data-product-slideshow] div.flickity-slider").appendChild(imageDisplayDiv);
                                                            } else {
                                                                setTimeout(() => {
                                                                    if (document.querySelector("[data-product-slideshow] div.flickity-slider")) {
                                                                        console.log("[Flickity] try....");
                                                                        document.querySelector("[data-product-slideshow] div.flickity-slider").appendChild(imageDisplayDiv);
                                                                    }
                                                                }, 1000);
                                                            }
                                                        }, 1000);
                                                    }
                                                }, 1000);
                                            }
                                        }, 1000);
                                    }
                                }, 10);
                                document.querySelector("[data-product-thumbs]").appendChild(imageParentDiv);
                                document.querySelector("[data-product-thumbs]").appendChild(imageParentDivMobile);
                                indexImages = parseInt(indexImages + 1);
                            }
                        });
                        document.querySelector("[data-product-thumbs]").removeAttribute('style');
                        const initVideoPlayers = () => {
                            document.querySelectorAll("[data-product-slideshow] [data-type='video']").forEach((videoSlide) => {
                                const pId = videoSlide.getAttribute("data-player");
                                if (pId && typeof Wa === "function" && !videoSlide.querySelector(".plyr")) {
                                    Wa(pId);
                                }
                            });
                        };
                        initVideoPlayers();
                        setTimeout(() => {
                            document.querySelectorAll("[data-product-thumbs] .media__thumb.desktop").forEach((event) => {
                                if (event.classList.contains("is-activated")) {
                                    event.classList.remove("is-activated");
                                }
                            });
                            if (!document.querySelector("[data-product-thumbs] .media__thumb.desktop").classList.contains("is-activated")) {
                                document.querySelector("[data-product-thumbs] .media__thumb.desktop").classList.add("is-activated");
                            }
                            if (!document.querySelector("[data-product-thumbs] .media__thumb.mobile").classList.contains("is-activated")) {
                                document.querySelector("[data-product-thumbs] .media__thumb.mobile").classList.add("is-activated");
                            }
                            initVideoPlayers();
                            if (window.innerWidth >= 768) {
                                if (flkty) {
                                    flkty.destroy();
                                }
                            } else {
                                if (flkty) {
                                    setTimeout(initFlickity, 1000);
                                } else {
                                    setTimeout(initFlickity, 1000);
                                }
                            }
                        }, 100);
                        setTimeout(initVideoPlayers, 500);

                    }
                });
            }
            if (productHandle == "new-mrs-ring") {
                function selectThumbnailByValue(value) {
                    const thumbnails = document.querySelectorAll(".media__thumb img");
                    const selectedValue = value.toLowerCase().trim();

                    let found = false;

                    thumbnails.forEach(function (thumbnail) {
                        const altText = (thumbnail.getAttribute("alt") || "").toLowerCase().trim();
                        if (altText.includes(selectedValue)) {
                            thumbnail.parentElement.click();
                            found = true;
                        }
                    });

                    return found;
                }

                function buildCombinedValue() {
                    const gold = document.querySelector("#GoldColor")?.value || "";
                    const stone = document.querySelector("#StoneColor")?.value || "";
                    return `${gold} / ${stone}`;
                }

                function getGoldValue() {
                    return document.querySelector("#GoldColor")?.value || "";
                }

                function handleThumbnailSelection() {
                    setTimeout(() => {
                        const combined = buildCombinedValue();
                        const found = selectThumbnailByValue(combined);

                        if (!found) {
                            const goldOnly = getGoldValue();
                            selectThumbnailByValue(goldOnly);
                        }
                    }, 100);
                }

                // Initial load
                handleThumbnailSelection();

                // Attach change event
                document.querySelectorAll(".mrs-ring select").forEach(select => {
                    select.addEventListener("change", handleThumbnailSelection);
                });

            }
            this.productState = this.setProductState(e), this.updateProductImage(e), this.updateAddToCartState(e), this.updateProductPrices(e), this.updateSaleText(e), this.updateSubscriptionText(e), this.updateLegend(e), this.updateRemaining(e), this.fireHookEvent(e), this.sellout && this.sellout.update(e), this.enableHistoryState && !t && this.updateHistoryState(e)
        }
        updateAddToCartState(e) {
            const t = e.variant;
            let i = theme.strings.addToCart;
            const s = this.outerWrapper.querySelectorAll(_l),
                r = this.outerWrapper.querySelector(Tl),
                n = null == r ? void 0 : r.querySelectorAll(Sl),
                o = null == r ? void 0 : r.querySelectorAll(El);
            if (this.isPreOrder && (i = theme.strings.preOrder), s.length && t && s.forEach((e => {
                e.classList.remove(Yl)
            })), (null == n ? void 0 : n.length) && n.forEach((e => {
                t && t.available ? e.disabled = !1 : e.disabled = !0
            })), (null == o ? void 0 : o.length) && o.forEach((e => {
                t ? t.available ? e.innerHTML = i : e.innerHTML = theme.strings.soldOut : e.innerHTML = theme.strings.unavailable
            })), r && t) {
                const e = r.querySelector(xl);
                e && (e.value = t.id)
            }
            r && this.productFormWrapper && (t ? t.available ? this.productFormWrapper.classList.remove(Kl, Xl) : (this.productFormWrapper.classList.add(Kl), this.productFormWrapper.classList.remove(Xl)) : (this.productFormWrapper.classList.add(Xl), this.productFormWrapper.classList.remove(Kl)))
        }
        updateLegend(e) {
            const t = e.variant;
            if (t) {
                this.container.parentNode.querySelectorAll(Ol).forEach((e => {
                    const i = e.closest(`[${Dl}]`);
                    if (i) {
                        const s = i.getAttribute(Dl),
                            r = parseInt(s, 10) - 1;
                        this.newValue = t.options[r], e.innerHTML = this.newValue
                    }
                }))
            }
        }
        updateHistoryState(e) {
            const t = e.variant,
                i = e.plan,
                s = window.location.href;
            if (t && s.includes("/product")) {
                const e = new window.URL(s),
                    r = e.searchParams;
                r.set("variant", t.id), i && i.detail && i.detail.id && this.productState.hasPlan ? r.set("selling_plan", i.detail.id) : r.delete("selling_plan"), e.search = r.toString();
                const n = e.toString();
                window.history.replaceState({
                    path: n
                }, "", n)
            }
        }
        updateRemaining(e) {
            const t = e.variant;
            if (t && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                const e = this.remainingJSON[t.id];
                e && e <= this.remainingMaxInt && e > 0 ? (this.remainingWrapper.classList.remove(tc, ic, sc), this.remainingWrapper.classList.add(ec), this.remainingCount.innerHTML = e) : this.productState.soldOut ? (this.remainingWrapper.classList.remove(ec, tc, sc), this.remainingWrapper.classList.add(ic)) : this.productState.available && (this.remainingWrapper.classList.remove(ec, ic, sc), this.remainingWrapper.classList.add(tc))
            } else this.remainingWrapper && (this.remainingWrapper.classList.remove(tc, ic, ec), this.remainingWrapper.classList.add(sc))
        }
        getBaseUnit(e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            this.outerWrapper.querySelectorAll(Rl).forEach((e => {
                e.addEventListener("change", function (e) {
                    const t = e.target.value.toString(),
                        i = this.outerWrapper.querySelector(`[${jl}="${t}"]`),
                        s = this.outerWrapper.querySelectorAll(`[${jl}]`);
                    if (i) {
                        i.classList.remove(Yl);
                        const e = i.querySelector('[name="selling_plan"]');
                        e.checked = !0, e.dispatchEvent(new Event("change"))
                    }
                    s.forEach((e => {
                        if (e !== i) {
                            e.classList.add(Yl);
                            e.querySelectorAll('[name="selling_plan"]').forEach((e => {
                                e.checked = !1, e.dispatchEvent(new Event("change"))
                            }))
                        }
                    }))
                }.bind(this))
            }))
        }
        updateSaleText(e) {
            this.productState.planSale ? this.updateSaleTextSubscription(e) : this.productState.onSale ? this.updateSaleTextStandard(e) : this.priceOffWrap && this.priceOffWrap.classList.add(Yl)
        }
        updateSaleTextStandard(e) {
            if (!this.priceOffType) return;
            this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
            const t = e.variant;
            if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                const e = (t.compare_at_price - t.price) / t.compare_at_price,
                    i = Math.floor(100 * e);
                this.priceOffAmount.innerHTML = `${i}%`
            } else {
                const e = t.compare_at_price - t.price;
                this.priceOffAmount.innerHTML = this.formattingMoney(e)
            }
            this.priceOffWrap.classList.remove(Yl)
        }
        updateSaleTextSubscription(e) {
            this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
            const t = e.variant,
                i = e.plan.detail.price_adjustments[0],
                s = i.value;
            i && "percentage" === i.value_type ? this.priceOffAmount.innerHTML = `${s}%` : i && "price" === i.value_type ? this.priceOffAmount.innerHTML = this.formattingMoney(t.price - i.value) : this.priceOffAmount.innerHTML = this.formattingMoney(s), this.priceOffWrap.classList.remove(Yl)
        }
        updateSubscriptionText(e) {
            e.plan && this.planDecription && null !== e.plan.detail.description ? (this.planDecription.innerHTML = e.plan.detail.description, this.planDecription.classList.remove(Yl)) : this.planDecription && this.planDecription.classList.add(Yl)
        }
        getPrices(e) {
            const t = e.variant,
                i = e.plan;
            let s = "",
                r = "";
            return this.productState.available && (s = t.compare_at_price, r = t.price), this.productState.hasPlan && (r = i.allocation.price), this.productState.planSale && (s = i.allocation.compare_at_price, r = i.allocation.price), {
                price: r,
                comparePrice: s
            }
        }
        updateButtonPrices(e) {
            const t = this.outerWrapper.querySelectorAll(Al),
                {
                    price: i
                } = this.getPrices(e);
            t.length && t.forEach((t => {
                const s = e.quantity * i;
                t.innerHTML = this.formattingMoney(s)
            }))
        }
        updateProductPrices(e) {
            const t = e.variant,
                i = this.outerWrapper.querySelectorAll(_l),
                s = this.outerWrapper.querySelectorAll(Al),
                {
                    price: r,
                    comparePrice: n
                } = this.getPrices(e);
            console.log(t);
            i.forEach((e => {
                const i = e.querySelector(Ll),
                    s = e.querySelector(Cl),
                    o = e.querySelector(kl);
                console.log(this.formattingMoney(t.compare_at_price));
                if (t.compare_at_price <= 0) {
                    s ? s.classList.remove(Zl) : "";
                    e.querySelector(_l + " .compare-price") ? e.querySelector(_l + " .compare-price").style.display = "none" : "";
                    if (e.querySelector(_l + " .compare-price s")) {
                        e.querySelector(_l + " .compare-price s").innerHTML = this.formattingMoney(t.compare_at_price);
                    }
                } else {
                    s ? s.classList.add(Zl) : "";
                    e.querySelector(_l + " .compare-price") ? e.querySelector(_l + " .compare-price").removeAttribute("style") : "";
                    if (e.querySelector(_l + " .compare-price s")) {
                        e.querySelector(_l + " .compare-price s").innerHTML = this.formattingMoney(t.compare_at_price);
                    }
                }
                i && (this.productState.onSale || this.productState.planSale ? (i.classList.remove(Yl), o.classList.remove(Yl), s.classList.add(Zl)) : (i.classList.add(Yl), o.classList.add(Yl), s.classList.remove(Zl)), i.innerHTML = this.formattingMoney(n)), s && (s.innerHTML = t ? this.formattingMoney(r) : "&nbsp;")

            })), s.length && s.forEach((t => {
                const i = e.quantity * r;
                t.innerHTML = this.formattingMoney(i)
            })), this.hasUnitPricing && this.updateProductUnits(e)
        }
        updateProductUnits(e) {
            const t = e.variant,
                i = e.plan;
            let s = null;
            if (t && t.unit_price && (s = t.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s) {
                const e = this.getBaseUnit(t);
                this.outerWrapper.querySelector(Pl).innerHTML = this.formattingMoney(s), this.outerWrapper.querySelector($l).innerHTML = e, X(this.outerWrapper.querySelector(Il))
            } else Xr(this.outerWrapper.querySelector(Il))
        }
        fireHookEvent(e) {
            const t = e.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: t
                },
                bubbles: !0
            }))
        }
        setProductState(e) {
            const t = e.variant,
                i = e.plan,
                s = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            var colorVariant = this.outerWrapper.querySelector('[data-select-label="Color"]') ? this.outerWrapper.querySelector('[data-select-label="Color"]') : this.outerWrapper.querySelector('[data-select-label="color"]');
            if (colorVariant) {
                if (colorVariant.getAttribute("data-option-position") == 1) {
                    var uniqueColors = new Set();
                    this.outerWrapper.querySelectorAll('[data-select-label="Color"] radio-swatch input[type="radio"]').forEach((color) => {
                        if (!uniqueColors.has(color.value)) {
                            uniqueColors.add(color.value);
                            var allColors = this.productJSON.variants.filter(options => options.option1 === color.value);
                            var createSpan = document.createElement("span");
                            if (allColors.length > 0 && allColors[0].inventory_quantity > 0) {
                                createSpan.classList.add("inventory-status");
                                createSpan.textContent = "IN STOCK";
                                if (!color.parentElement.querySelector(".inventory-status")) {
                                    color.parentElement.appendChild(createSpan);
                                }
                            }
                        }
                    });
                } else {
                    var uniqueColors = new Set();
                    this.outerWrapper.querySelectorAll('[data-select-label="Color"] radio-swatch input[type="radio"]').forEach((color) => {
                        if (!uniqueColors.has(color.value)) {
                            uniqueColors.add(color.value);
                            var allColors = this.productJSON.variants.filter(options => options.option1 === color.value);
                            var createSpan = document.createElement("span");
                            if (allColors.length > 0 && allColors[0].inventory_quantity > 0) {
                                createSpan.classList.add("inventory-status");
                                createSpan.textContent = "IN STOCK";
                                if (!color.parentElement.querySelector(".inventory-status")) {
                                    color.parentElement.appendChild(createSpan);
                                }
                            }
                        }
                    });
                }
                var sizeVariant = document.querySelector("[data-popout-list]");
                if (sizeVariant) {
                    this.outerWrapper.querySelectorAll('[data-select-label="Color"] radio-swatch input[type="radio"]').forEach((color) => {
                        if (color.checked) {
                            this.productJSON.variants.filter(options => options.option1 === color.value).forEach((size) => {
                                if (document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']")) {
                                    if (document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']") && !document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "'] .inventory-status")) {
                                        var createSpan = document.createElement("span");
                                        if (size.inventory_quantity > 0) {
                                            createSpan.classList.add("inventory-status");
                                            createSpan.textContent = "IN STOCK";
                                            if (!document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").parentElement.querySelector(".inventory-status")) {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").appendChild(createSpan);
                                            } else {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "'] .inventory-status").innerHTML = "IN STOCK";
                                            }
                                        } else {
                                            var createSpan = document.createElement("span");
                                            createSpan.classList.add("inventory-status");
                                            createSpan.textContent = "MADE TO ORDER";
                                            if (!document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").parentElement.querySelector(".inventory-status")) {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").appendChild(createSpan);
                                            } else {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "'] .inventory-status").innerHTML = "MADE TO ORDER";
                                            }
                                        }
                                    } else {
                                        var createSpan = document.createElement("span");
                                        if (size.inventory_quantity > 0) {
                                            createSpan.classList.add("inventory-status");
                                            createSpan.textContent = "IN STOCK";
                                            if (!document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").parentElement.querySelector(".inventory-status")) {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").appendChild(createSpan);
                                            } else {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "'] .inventory-status").innerHTML = "IN STOCK";
                                            }
                                        } else {
                                            var createSpan = document.createElement("span");
                                            createSpan.classList.add("inventory-status");
                                            createSpan.textContent = "MADE TO ORDER";
                                            if (!document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").parentElement.querySelector(".inventory-status")) {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "']").appendChild(createSpan);
                                            } else {
                                                document.querySelector("[data-popout-list] li a[data-value='" + size.option2 + "'] .inventory-status").innerHTML = "MADE TO ORDER";
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            }
            // var sizeVariant = this.outerWrapper.querySelector('[data-select-label="Size"]') ? this.outerWrapper.querySelector('[data-select-label="Size"]') : this.outerWrapper.querySelector('[data-select-label="size"]');
            if (document.querySelectorAll("[data-popout-list]")) {
                document.querySelectorAll("[data-popout-list] li a span").forEach((size) => {
                    this.productJSON.variants.filter(options => options.option1 === size.innerHTML.trim()).forEach((size1) => {
                        var createSpan = document.createElement("span");
                        createSpan.classList.add("inventory-status");
                        if (size1.inventory_quantity > 0) {
                            createSpan.textContent = "IN STOCK";
                        } else {
                            createSpan.textContent = "MADE TO ORDER";
                        }
                        if (!size.parentElement.querySelector(".inventory-status")) {
                            size.parentElement.appendChild(createSpan);
                        }
                    });
                });
            }
            return !t || t.requires_selling_plan && !i ? s.available = !1 : (t.available || (s.soldOut = !0), t.compare_at_price > t.price && (s.onSale = !0), t.unit_price && (s.showUnitPrice = !0), this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0), i && this.subPrices && (s.hasPlan = !0, i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), i.allocation.compare_at_price > i.allocation.price && (s.planSale = !0))), s
        }
        updateProductImage(e) {
            const t = e.variant;
            t && this.slideshow && t.featured_media && t.featured_media.id && (this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                detail: {
                    id: t.featured_media.id
                }
            })), this.scrollImageViewport(t))
        }
        scrollImageViewport(e) {
            if ((Ae.isDesktop() || Ae.isTablet()) && this.slideshow.hasAttribute("data-vertical-images")) {
                const t = this.slideshow.querySelector(`[data-media-id="${e.featured_media.id}"]`).getBoundingClientRect(),
                    i = t.top,
                    s = t.bottom;
                if (i < 0 || s > window.innerHeight) {
                    let e = i + window.scrollY;
                    i < 0 ? e = i + window.scrollY : s > window.innerHeight && (e = i + window.scrollY - (window.innerHeight - t.height)), window.scrollTo({
                        top: e,
                        left: 0,
                        behavior: "smooth"
                    })
                }
            }
        }
        formattingMoney(e) {
            return theme.settings.currency_code_enable ? a.formatMoney(e, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(e, theme.moneyFormat)
        }
        constructor() {
            super(), this.container = this
        }
    },
        nc = class extends HTMLElement {
            connectedCallback() {
                fetch(this.dataset.url).then((e => e.text())).then((e => {
                    const t = document.createElement("div");
                    t.innerHTML = e;
                    const i = t.querySelector("[data-api-content]");
                    i && (this.innerHTML = i.innerHTML);
                    const s = this.closest("[data-product-complimentary-loaded]");
                    s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded")
                })).catch((e => {
                    console.error(e)
                }))
            }
            constructor() {
                super()
            }
        };
    const oc = "[data-product-slideshow]",
        ac = "[data-product-image]",
        lc = "[data-zoom-button]",
        cc = "[data-zoom-wrapper]",
        hc = "data-media-id";
    const dc = "body",
        uc = "[data-related-section]",
        pc = "[data-tabs-holder]",
        mc = "data-tab",
        fc = "data-tab-index",
        gc = "data-block-id",
        yc = ".tabs > button",
        vc = ".tab-link",
        bc = ".tab-link__recent",
        wc = ".tab-content",
        Sc = "[data-scrollbar]",
        Ec = "a:first-child, input:first-child",
        Lc = "current",
        kc = "hide",
        Tc = "alt",
        xc = "is-focused",
        _c = {};
    const Ac = {
        onLoad() {
            _c[this.id] = [];
            this.container.querySelectorAll(pc).forEach((e => {
                _c[this.id].push(new class {
                    init() {
                        const e = this.container,
                            t = e.querySelectorAll(yc),
                            i = e.querySelector(`${vc}-0`),
                            s = e.querySelector(`${wc}-0`);
                        s && s.classList.add(Lc), i && i.classList.add(Lc), this.checkVisibleTabLinks(), this.container.addEventListener("theme:tabs:check", (() => this.checkRecentTab())), this.container.addEventListener("theme:tabs:hide", (() => this.hideRelatedTab())), t.length && t.forEach((t => {
                            const i = parseInt(t.getAttribute(mc)),
                                s = e.querySelector(`${wc}-${i}`);
                            t.addEventListener("click", (() => {
                                this.tabChange(t, s)
                            })), t.addEventListener("keyup", (e => {
                                "Space" !== e.code && "Enter" !== e.code || !this.body.classList.contains(xc) || (this.tabChange(t, s), s.querySelector("a, input") && (this.accessibility.lastFocused = t, this.accessibility.a11y.trapFocus(s, {
                                    elementToFocus: s.querySelector(Ec)
                                })))
                            }))
                        }))
                    }
                    tabChange(e, t) {
                        this.container.querySelector(`${yc}.${Lc}`).classList.remove(Lc), this.container.querySelector(`${wc}.${Lc}`).classList.remove(Lc), e.classList.add(Lc), t.classList.add(Lc), e.classList.contains(kc) && t.classList.add(kc), this.checkVisibleTabLinks(), this.container.dispatchEvent(new CustomEvent("theme:tab:change"))
                    }
                    initNativeScrollbar() {
                        this.scrollbarHolder.length && this.scrollbarHolder.forEach((e => {
                            new ne(e)
                        }))
                    }
                    checkVisibleTabLinks() {
                        const e = this.container.querySelectorAll(yc),
                            t = this.container.querySelectorAll(`${vc}.${kc}`);
                        e.length - t.length < 2 ? this.container.classList.add(Tc) : this.container.classList.remove(Tc)
                    }
                    checkRecentTab() {
                        const e = this.container.querySelector(bc);
                        if (e) {
                            e.classList.remove(kc);
                            const t = parseInt(e.getAttribute(mc)),
                                i = this.container.querySelector(`${wc}[${fc}="${t}"]`);
                            i && i.classList.remove(kc), this.checkVisibleTabLinks(), this.initNativeScrollbar()
                        }
                    }
                    hideRelatedTab() {
                        const e = this.container.querySelector(uc);
                        if (!e) return;
                        const t = e.closest(`${wc}.${Lc}`);
                        if (!t) return;
                        const i = parseInt(t.getAttribute(fc)),
                            s = this.container.querySelectorAll(yc);
                        if (s.length > i) {
                            const e = s[i].nextElementSibling;
                            e && (s[i].classList.add(kc), e.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                        }
                    }
                    onBlockSelect(e) {
                        const t = this.container.querySelector(`${vc}[${gc}="${e.detail.blockId}"]`);
                        t && (t.dispatchEvent(new Event("click")), t.parentNode.scrollTo({
                            top: 0,
                            left: t.offsetLeft - t.clientWidth,
                            behavior: "smooth"
                        }))
                    }
                    constructor(e) {
                        this.container = e, this.body = document.querySelector(dc), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll(Sc), this.init(), this.initNativeScrollbar())
                    }
                }(e))
            }))
        },
        onBlockSelect(e) {
            _c[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }))
        }
    },
        qc = "[data-share-url]",
        Cc = "data-section-type",
        Pc = "[data-share-details]",
        $c = "[data-share-summary]",
        Ic = "[data-share-copy]",
        Mc = "[data-share-button]",
        Dc = "[data-close-button]",
        Oc = "[data-success-message]",
        Hc = "[data-share-holder]",
        Fc = "is-hidden";
    let Bc = class extends HTMLElement {
        init() {
            navigator.share ? (this.mainDetailsToggle.classList.add(Fc), this.shareButton.classList.remove(Fc), this.shareButton.addEventListener("click", (() => {
                navigator.share({
                    url: this.urlToShare,
                    title: document.title
                })
            }))) : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)), this.mainDetailsToggle.addEventListener("focusout", (() => {
                setTimeout((() => {
                    this.contains(document.activeElement) || this.close()
                }))
            })), this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)), this.closeButton.addEventListener("click", this.close.bind(this)), this.container.addEventListener("keyup", this.keyboardEvents.bind(this)))
        }
        updateShareLink() {
            "product" == this.container.getAttribute(Cc) && this.container.addEventListener("theme:variant:change", (e => {
                e.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`, this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`))
            }))
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(Fc), this.successMessage.textContent = "", this.closeButton.classList.add(Fc), this.shareCopy.focus())
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then((() => {
                this.successMessage.classList.remove(Fc), this.successMessage.textContent = theme.strings.successMessage, this.closeButton.classList.remove(Fc), this.closeButton.focus()
            }))
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1)
        }
        keyboardEvents(e) {
            "Escape" === e.code && (this.mainDetailsToggle.focus(), this.close())
        }
        constructor() {
            super(), this.container = this.closest(`[${Cc}]`), this.mainDetailsToggle = this.querySelector(Pc), this.shareButton = this.querySelector(Mc), this.shareCopy = this.querySelector(Ic), this.shareSummary = this.querySelector($c), this.closeButton = this.querySelector(Dc), this.successMessage = this.querySelector(Oc), this.shareHolder = this.querySelector(Hc), this.urlInput = this.querySelector(qc), this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href, this.init(), this.updateShareLink()
        }
    };
    const Wc = "data-image-filter",
        Nc = "[data-product-slideshow]",
        Rc = "[data-product-thumbs]",
        jc = "[data-slideshow-thumbnail]",
        zc = "[data-media-slide]",
        Vc = "hide",
        Uc = "flickity-enabled";
    const Gc = "[data-size-button]",
        Jc = "[data-media-slide]",
        Qc = "is-expanded";
    let Yc = class {
        init() {
            this.sizeButtons.forEach((e => {
                e.addEventListener("click", (() => {
                    e.classList.toggle(Qc), e.closest(Jc).classList.toggle(Qc)
                }))
            }))
        }
        constructor(e) {
            this.container = e, this.sizeButtons = this.container.querySelectorAll(Gc), this.sizeButtons.length > 0 && this.init()
        }
    };
    const Kc = "[data-product-json]",
        Xc = "[data-zoom-button]",
        Zc = "[data-truncated-holder]",
        eh = "[data-truncated-button]",
        th = "data-truncated-content",
        ih = "is-expanded",
        sh = "is-visible",
        rh = [];
    const nh = {
        onLoad() {
            rh[this.id] = new class {
                init() {
                    var e, t;
                    this.zoomEnabled = null !== this.container.querySelector(Xc), this.zoomEnabled && (e = this.container, t = this.product, Fe({
                        url: window.theme.assets.photoswipe
                    }).then((() => {
                        const i = window.themePhotoswipe.PhotoSwipe.default,
                            s = window.themePhotoswipe.PhotoSwipeUI.default;
                        e.querySelectorAll(lc).forEach((r => {
                            r.addEventListener("click", (r => {
                                const n = e.querySelector(cc),
                                    o = r.target.closest(`[${hc}]`).getAttribute(hc).toString(),
                                    a = [];
                                for (let e = 0; e < t.media.length; e++) "image" === t.media[e].media_type && (a[a.length] = {
                                    src: t.media[e].src,
                                    w: t.media[e].width,
                                    h: t.media[e].height,
                                    id: t.media[e].id
                                });
                                const l = {
                                    index: a.findIndex((e => e.id.toString() === o)),
                                    showHideOpacity: !0,
                                    showAnimationDuration: 150,
                                    hideAnimationDuration: 250,
                                    bgOpacity: 1,
                                    spacing: 0,
                                    allowPanToNext: !1,
                                    maxSpreadZoom: 3,
                                    history: !1,
                                    loop: !0,
                                    pinchToClose: !1,
                                    modal: !1,
                                    closeOnScroll: !1,
                                    closeOnVerticalDrag: !0,
                                    getDoubleTapZoom: function (e, t) {
                                        return e ? 1.67 : t.initialZoomLevel < .7 ? 1 : 1.3
                                    },
                                    getThumbBoundsFn: function () {
                                        let t = e.querySelector(oc);
                                        t || (t = e.querySelector(ac));
                                        const i = window.pageYOffset || document.documentElement.scrollTop,
                                            s = t.getBoundingClientRect();
                                        return {
                                            x: s.left,
                                            y: s.top + i,
                                            w: s.width
                                        }
                                    }
                                };
                                n.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                }));
                                const c = new i(n, s, a, l);
                                c.init(), c.listen("close", (function () {
                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                        bubbles: !0
                                    }))
                                }))
                            }))
                        }))
                    })).catch((e => console.error(e)))), this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate)), new Yc(this.container)
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(sh)) return;
                    const e = this.truncateElement.querySelectorAll("style");
                    e.length && e.forEach((e => {
                        this.truncateElementHolder.prepend(e)
                    }));
                    const t = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(th),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(t);
                    const r = this.truncateElement.nextElementSibling;
                    r.classList.add(i), r.removeAttribute(th), X(r), ((e = "", t = 1, i = {}) => {
                        const s = {
                            replaceStr: "...",
                            debounceDelay: 250,
                            delimiter: " ",
                            ...i
                        },
                            r = e && (e instanceof NodeList ? e : 1 === e.nodeType ? [e] : document.querySelectorAll(e));
                        for (let e = 0; e < r.length; e++) {
                            const i = r[e],
                                n = /<!--[\s\S]*?-->/g,
                                o = i.innerHTML.replace(n, "").split(s.delimiter);
                            i.innerHTML = "";
                            const a = window.getComputedStyle(i);
                            o.reduce(xa, {
                                el: i,
                                buffer: i.innerHTML,
                                elStyle: a,
                                elHeight: 0,
                                rowsLimit: t,
                                rowsWrapped: 0,
                                options: s
                            })
                        }
                    })(r, 5, {
                        replaceStr: "",
                        delimiter: " "
                    }), Xr(r), this.truncateElement.innerHTML !== r.innerHTML ? this.truncateElementHolder.classList.add(ih) : (r.remove(), this.truncateElementHolder.classList.remove(ih)), this.toggleTruncatedContent(this.truncateElementHolder)
                }
                toggleTruncatedContent(e) {
                    const t = e.querySelector(eh);
                    t && t.addEventListener("click", (t => {
                        t.preventDefault(), e.classList.remove(ih), e.classList.add(sh)
                    }))
                }
                onBlockSelect(e) {
                    const t = this.container.querySelector(`[data-block-id="${e.detail.blockId}"]`);
                    t && t.dispatchEvent(new Event("click"))
                }
                onBlockDeselect(e) {
                    const t = this.container.querySelector(`[data-block-id="${e.detail.blockId}"]`);
                    t && t.dispatchEvent(new Event("click"))
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate)
                }
                constructor(e) {
                    this.section = e, this.id = e.id, this.container = e.container, this.settings = e.settings, Si(this.id), this.media = new Ua(e), new class {
                        listen() {
                            this.container.addEventListener("theme:variant:change", (e => {
                                e.detail.variant && (this.variantImage = e.detail.variant.featured_image, this.filterImages())
                            }))
                        }
                        filterImages() {
                            null !== this.variantImage && null !== this.variantImage.alt ? (this.variantImageAlt = this.variantImage.alt.split("#")[1], this.showImages()) : this.resetImages(), this.refreshSliders()
                        }
                        resetImages() {
                            this.thumbs.forEach((e => e.classList.remove(Vc))), this.slides.forEach((e => e.classList.remove(Vc)))
                        }
                        showImages() {
                            this.thumbs.forEach((e => {
                                "" === e.getAttribute(Wc) || e.getAttribute(Wc) === this.variantImageAlt ? e.classList.remove(Vc) : e.classList.add(Vc)
                            })), this.slides.forEach((e => {
                                "" === e.getAttribute(Wc) || e.getAttribute(Wc) === this.variantImageAlt ? e.classList.remove(Vc) : e.classList.add(Vc)
                            }))
                        }
                        refreshSliders() {
                            if (null !== this.slider && this.slider.classList.contains(Uc)) {
                                const e = t.data(this.slider);
                                void 0 !== e && e.reloadCells()
                            }
                            if (null !== this.thumbSlider && this.thumbSlider.classList.contains(Uc)) {
                                const e = c.data(this.thumbSlider);
                                void 0 !== e && e.reloadCells()
                            }
                        }
                        constructor(e) {
                            this.section = e, this.container = e.container, this.slider = this.container.querySelector(Nc), this.thumbSlider = this.container.querySelector(Rc), this.thumbs = this.container.querySelectorAll(jc), this.slides = this.container.querySelectorAll(zc), this.variantImage = null, this.listen()
                        }
                    }(e);
                    const i = this.container.querySelector(Kc);
                    i && "" !== i.innerHTML ? (this.product = JSON.parse(i.innerHTML), this.truncateElementHolder = this.container.querySelector(Zc), this.truncateElement = this.container.querySelector(`[${th}]`), this.resizeEventTruncate = () => this.truncateText(), this.init()) : console.error("Missing product JSON")
                }
            }(this)
        },
        onUnload() {
            "function" == typeof rh[this.id].unload && rh[this.id].unload()
        },
        onBlockSelect(e) {
            "function" == typeof rh[this.id].onBlockSelect && rh[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            "function" == typeof rh[this.id].onBlockDeselect && rh[this.id].onBlockDeselect(e)
        }
    };
    oi("product", [nh, rl, Kr, Ac, ze]), customElements.get("product-form") || customElements.define("product-form", rc), customElements.get("product-complimentary") || customElements.define("product-complimentary", nc), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("popout-select") || customElements.define("popout-select", Br), customElements.get("share-button") || customElements.define("share-button", Bc);
    const oh = "data-toggle-grid",
        ah = "data-grid-large",
        lh = "data-grid-small",
        ch = "is-active",
        hh = window.theme.sizes.small;
    var dh = {};
    const uh = {
        onLoad() {
            dh[this.id] = [];
            this.container.querySelectorAll(`[${oh}]`).forEach((e => {
                dh[this.id].push(new class {
                    init() {
                        this.toggle.addEventListener("click", this.toggleFunction), document.addEventListener("theme:resize:width", this.toggleFunction), this.toggleEvent(!1)
                    }
                    unload() {
                        this.toggle.removeEventListener("click", this.toggleFunction), document.removeEventListener("theme:resize:width", this.toggleFunction)
                    }
                    toggleEvent(e = !0) {
                        const t = e && "click" === e.type,
                            i = window.innerWidth >= hh ? ah : lh,
                            s = this.container.querySelector(`[${i}]`),
                            r = s.getAttribute(i),
                            n = this.toggle.parentElement.querySelector(`[${oh}].${ch}`);
                        let o = this.toggle.parentElement.querySelector(`[${oh}="${r}"]`);
                        t && (o = this.toggle, s.setAttribute(i, this.value)), n && n.classList.remove(ch), o && o.classList.add(ch)
                    }
                    constructor(e, t) {
                        this.container = t || document, this.toggle = e, this.value = this.toggle.getAttribute(oh), this.toggleFunction = e => this.toggleEvent(e), this.init()
                    }
                }(e, this.container))
            }))
        },
        onUnload: function () {
            dh[this.id].forEach((e => {
                "function" == typeof e.unload && e.unload()
            }))
        }
    },
        ph = "data-sort-enabled",
        mh = "[data-sort-link]",
        fh = "[data-sort-button-text]",
        gh = "data-value",
        yh = "popout-list__item--current";
    var vh = "data-swatch";
    oi("collection", [{
        onLoad() {
            this.collection = new class {
                init() {
                    new class {
                        init() {
                            this.sortLinks.forEach((e => {
                                e.addEventListener("click", (e => {
                                    e.preventDefault(), this.sortingResults(e)
                                }))
                            }))
                        }
                        sortingResults(e) {
                            const t = e.currentTarget,
                                i = t.getAttribute(gh),
                                s = t.innerText;
                            this.sortButtonText.innerText = s, this.sortButtonText.parentNode.dispatchEvent(new Event("click")), this.sort.querySelector(`.${yh}`).classList.remove(yh), t.parentNode.classList.add(yh), this.sort.setAttribute(ph, i), this.container.dispatchEvent(new CustomEvent("theme:form:filter", {
                                bubbles: !0,
                                detail: {
                                    params: i
                                }
                            }))
                        }
                        constructor(e) {
                            this.container = e.container, this.sort = this.container.querySelector(`[${ph}]`), this.sortLinks = this.container.querySelectorAll(mh), this.sortButtonText = this.container.querySelector(fh), this.sort && this.init()
                        }
                    }(this.section)
                }
                constructor(e) {
                    this.section = e, this.container = this.section.container, this.swatches = this.container.querySelectorAll(`[${vh}]`), this.init()
                }
            }(this)
        }
    }, ma, wa, uh, ot, Kr, le]), customElements.get("popout-select") || customElements.define("popout-select", Br), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr), oi("collection-row", [ot, le, pt]), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr), oi("collection-tabs", [Ac, _o, ot]), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr);
    var bh = {};

    function wh(e) {
        return bh[e]
    }
    bh.basic = [], bh.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "on"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], bh.light_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }, {
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], bh.white_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#444444"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], bh.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], bh.dark_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], bh.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], window.theme.allMaps = window.theme.allMaps || {};
    let Sh = window.theme.allMaps;
    const Eh = "[data-map-container]",
        Lh = "data-style",
        kh = "data-api-key",
        Th = "data-zoom",
        xh = "data-address",
        _h = "data-latlong-correction",
        Ah = "data-lat",
        qh = "data-long";
    const Ch = {
        onLoad() {
            Sh[this.id] = new class {
                initMaps() {
                    Fe({
                        url: `https://maps.googleapis.com/maps/api/js?key=${this.key}`
                    }).then((() => {
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new window.google.maps.LatLng(this.lat, this.long) : (e = this.address, new Promise(((t, i) => {
                            (new window.google.maps.Geocoder).geocode({
                                address: e
                            }, (function (e, s) {
                                if ("OK" == s) {
                                    var r = {
                                        lat: e[0].geometry.location.lat(),
                                        lng: e[0].geometry.location.lng()
                                    };
                                    t(r)
                                } else i(s)
                            }))
                        })));
                        var e
                    })).then((e => {
                        var t = {
                            zoom: parseInt(this.zoomString, 10),
                            styles: wh(this.styleString),
                            center: e,
                            draggable: !0,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            zoomControl: !1,
                            disableDefaultUI: !0
                        };
                        const i = function (e, t) {
                            var i = new window.google.maps.Map(e, t),
                                s = i.getCenter();
                            return new window.google.maps.Marker({
                                map: i,
                                position: s
                            }), window.google.maps.event.addDomListener(window, "resize", (function () {
                                window.google.maps.event.trigger(i, "resize"), i.setCenter(s)
                            })), i
                        }(this.mapWrap, t);
                        return i
                    })).then((e => {
                        this.map = e, Sh[this.id] = e
                    })).catch((e => {
                        console.log("Failed to load Google Map"), console.log(e)
                    }))
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize")
                }
                constructor(e) {
                    this.container = e.container, this.mapWrap = this.container.querySelector(Eh), this.styleString = this.container.getAttribute(Lh) || "", this.key = this.container.getAttribute(kh), this.zoomString = this.container.getAttribute(Th) || 14, this.address = this.container.getAttribute(xh), this.enableCorrection = this.container.getAttribute(_h), this.lat = this.container.getAttribute(Ah), this.long = this.container.getAttribute(qh), this.key && this.initMaps()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof Sh[this.id].unload && Sh[this.id].unload()
        }
    };
    oi("section-map", Ch), oi("section-columns", [mo, pt]);
    const Ph = "[data-related-section]",
        $h = "[data-grid-item]",
        Ih = "[data-carousel]",
        Mh = "data-limit",
        Dh = "data-minimum",
        Oh = "data-layout-desktop",
        Hh = "data-layout-tablet",
        Fh = "data-layout-mobile",
        Bh = "[data-recent-wrapper]",
        Wh = "[data-recently-viewed-wrapper]",
        Nh = "data-product-id";
    oi("related", [{
        onLoad() {
            this.section = new class {
                init() {
                    const e = this.container.querySelector(Ph);
                    if (!e) return;
                    const t = e.getAttribute(Nh),
                        i = e.getAttribute(Mh),
                        s = e.getAttribute(Oh),
                        r = e.getAttribute(Hh),
                        n = e.getAttribute(Fh),
                        o = `${window.theme.routes.product_recommendations_url || "/recommendations/products/"}?section_id=related&limit=${i}&product_id=${t}`;
                    l.get(o).then((t => {
                        const i = document.createElement("div");
                        i.innerHTML = t.data;
                        const o = i.querySelector(Ph);
                        if (o.querySelector($h)) {
                            const t = o.innerHTML;
                            e.innerHTML = t, e.querySelector(Ih).style.setProperty("--grid-large-items", s), e.querySelector(Ih).style.setProperty("--grid-medium-items", r), e.querySelector(Ih).style.setProperty("--grid-small-items", n), e.dispatchEvent(new CustomEvent("theme:related-products:added", {
                                bubbles: !0
                            }))
                        } else e.dispatchEvent(new CustomEvent("theme:tabs:hide", {
                            bubbles: !0
                        }))
                    })).catch((function (e) {
                        console.warn(e)
                    }))
                }
                recent() {
                    const e = this.container.querySelector(Bh),
                        t = this.container.querySelector(Wh),
                        i = this.container.querySelectorAll($h),
                        s = e.hasAttribute(Dh) ? parseInt(e.getAttribute(Dh)) : 4,
                        r = !t && i.length > 0,
                        n = t && i.length >= s;
                    (r || n) && e.dispatchEvent(new CustomEvent("theme:tabs:check", {
                        bubbles: !0
                    }))
                }
                constructor(e) {
                    this.section = e, this.container = e.container, this.init(), this.container.addEventListener("theme:recent-products:added", (() => {
                        this.recent()
                    }))
                }
            }(this)
        }
    }, Ac, _e]), customElements.get("radio-swatch") || customElements.define("radio-swatch", rt), customElements.get("product-grid-item") || customElements.define("product-grid-item", ar), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", Er), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", Tr);
    const Rh = "[data-cart-note]";
    class jh {
        initInputs() {
            this.inputs.forEach((e => {
                e.addEventListener("input", T(function (e) {
                    const t = e.target.value.toString() || "";
                    this.saveNotes(t)
                }.bind(this), 300))
            }))
        }
        saveNotes(e) {
            window.fetch(`${window.theme.routes.cart}/update.js`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    note: e
                })
            }).catch((e => {
                console.error(e)
            }))
        }
        constructor(e) {
            this.inputs = e.querySelectorAll(Rh), this.initInputs()
        }
    }
    const zh = (e, t = [], i = !1) => {
        const s = Object.keys(e).map((s => {
            let r = e[s];
            if ("[object Object]" === Object.prototype.toString.call(r) || Array.isArray(r)) return Array.isArray(e) ? t.push("") : t.push(s), zh(r, t, Array.isArray(r));
            {
                let e = s;
                if (t.length > 0) {
                    e = (i ? t : [...t, s]).reduce(((e, t) => "" === e ? t : `${e}[${t}]`), "")
                }
                return i ? `${e}[]=${r}` : `${e}=${r}`
            }
        })).join("&");
        return t.pop(), s
    },
        Vh = "html",
        Uh = "[data-submit-shipping]",
        Gh = "[data-shipping-estimate-form]",
        Jh = "[data-response-template]",
        Qh = "#estimate_address_country",
        Yh = "#estimate_address_province",
        Kh = "#estimate_address_zip",
        Xh = "[data-response-wrapper]",
        Zh = "lang",
        ed = "data-default",
        td = "shipping--success",
        id = "errors",
        sd = "disabled";
    class rd {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(sd)
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(sd)
        }
        render(e) {
            if (this.template && this.ratesWrapper) {
                const t = u.render(this.template, e);
                this.ratesWrapper.innerHTML = t
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display")
        }
        estimate(e) {
            const t = encodeURI(zh({
                shipping_address: e
            })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
                s = this;
            l.get(i).then((function (e) {
                const t = s.sanitize(e);
                s.render(t), s.enableButtons(), s.ratesWrapper.style.removeProperty("display")
            })).catch((function (e) {
                const t = s.sanitizeErrors(e);
                s.render(t)
            }))
        }
        sanitize(e) {
            const t = {};
            if (t.class = td, t.items = [], e.data.shipping_rates && e.data.shipping_rates.length > 0) {
                e.data.shipping_rates.forEach((e => {
                    let i = {};
                    i.title = e.presentment_name, i.value = a.formatMoney(e.price, theme.moneyFormat), t.items.push(i)
                }))
            } else t.items[0] = {
                value: theme.strings.noShippingAvailable
            };
            return t
        }
        sanitizeErrors(e) {
            const t = {};
            if (t.class = id, t.items = [], "object" == typeof e.data)
                for (const [i, s] of Object.entries(e.data)) {
                    let e = {};
                    e.title = i.toString(), e.value = s.toString(), t.items.push(e)
                } else t.items[0] = {
                    value: theme.strings.noShippingAvailable
                };
            return t
        }
        init() {
            const e = document.querySelector(Vh);
            let t = "en";
            e.hasAttribute(Zh) && "" !== e.getAttribute(Zh) && (t = e.getAttribute(Zh)), this.form && h.AddressForm(this.form, t, {
                shippingCountriesOnly: !0
            }), this.country && this.country.hasAttribute(ed) && this.province && this.province.hasAttribute(ed) && this.country.addEventListener("change", (function () {
                this.country.removeAttribute(ed), this.province.removeAttribute(ed)
            })), this.button && this.button.addEventListener("click", function (e) {
                for (e.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild;) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                this.ratesWrapper.style.display = "none";
                const t = {};
                let i = this.country.value,
                    s = this.province.value;
                const r = this.country.getAttribute(ed);
                "" === i && r && "" !== r && (i = r);
                const n = this.province.getAttribute(ed);
                "" === s && n && "" !== n && (s = n), t.zip = this.zip.value || "", t.country = i || "", t.province = s || "", this.estimate(t)
            }.bind(this))
        }
        constructor(e) {
            this.button = e.container.querySelector(Uh), this.template = e.container.querySelector(Jh).innerHTML, this.ratesWrapper = e.container.querySelector(Xh), this.form = e.container.querySelector(Gh), this.country = e.container.querySelector(Qh), this.province = e.container.querySelector(Yh), this.zip = e.container.querySelector(Kh), this.init()
        }
    }
    const nd = "[data-cart-message]",
        od = "data-cart-message",
        ad = "[data-left-to-spend]",
        ld = "[data-cart-progress]",
        cd = "data-limit",
        hd = "data-percent",
        dd = "is-success";
    let ud = class {
        init() {
            this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(cd)) * this.rate, this.shippingAmount = 0, this.circumference = 28 * Math.PI, this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(), this.listen()
        }
        listen() {
            document.addEventListener("theme:cart:change", function (e) {
                this.cart = e.detail.cart, this.render()
            }.bind(this))
        }
        render() {
            const e = this.cart.total_price;
            this.freeShippingMessageHandle(e), this.cart && this.cart.total_price && this.cartMessage.length > 0 && (this.shippingAmount = e, this.updateProgress())
        }
        freeShippingMessageHandle(e) {
            this.cartMessage.length > 0 && this.container.querySelectorAll(nd).forEach((t => {
                const i = t.hasAttribute(od) && "true" === t.getAttribute(od) && e >= this.cartFreeLimitShipping && 0 !== e;
                t.classList.toggle(dd, i)
            }))
        }
        cartBarProgress(e = null) {
            this.container.querySelectorAll(ld).forEach((t => {
                this.setProgress(t, null === e ? t.getAttribute(hd) : e)
            }))
        }
        setProgress(e, t) {
            const i = this.circumference - t / 100 * this.circumference / 2;
            e.style.strokeDashoffset = i
        }
        updateProgress() {
            const e = this.shippingAmount / this.cartFreeLimitShipping * 100;
            this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(e > 100 ? 100 : e)
        }
        exchangeRateConversions(e, t) {
            const i = theme.settings.currency_code_enable ? a.formatMoney(e - t, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(e - t, theme.moneyFormat);
            this.container.querySelectorAll(ad).forEach((e => {
                e.innerHTML = i.replace(".00", "")
            }))
        }
        constructor(e) {
            this.container = e, this.cartMessage = this.container.querySelectorAll(nd), this.rate = window.Shopify.currency.rate, this.cartMessage.length > 0 && this.init()
        }
    };
    const pd = '[data-drawer="drawer-cart"]',
        md = "[data-shipping-estimate-form]",
        fd = "[data-cart-loading]",
        gd = "[data-cart-form]",
        yd = "[data-cart-empty]",
        vd = "[data-cart-progress]",
        bd = "[data-line-items]",
        wd = "[data-cart-subtotal]",
        Sd = "[data-cart-bottom]",
        Ed = "[data-form-errors]",
        Ld = "[data-cart-item]",
        kd = "[data-cart-final]",
        Td = "data-update-cart",
        xd = "data-remove-key",
        _d = "[data-cart-page-upsell-wrapper]",
        Ad = '[data-section-type="cart"]',
        qd = "[data-cart-bar]",
        Cd = "[data-cart-message]",
        Pd = "[data-item-loadbar]",
        $d = "[data-cart-message-container]",
        Id = "[data-api-content]",
        Md = "cart--hidden",
        Dd = "cart--loading";
    let Od = class {
        listen() {
            document.addEventListener("theme:cart:change", function (e) {
                this.cart = e.detail.cart, this.stale = !0
            }.bind(this)), document.addEventListener("theme:cart:init", function () {
                this.init()
            }.bind(this)), document.addEventListener("theme:cart:reload", function () {
                this.stale = !0, this.cart ? this.loadHTML() : this.init().then((() => this.loadHTML()))
            }.bind(this)), this.drawer && (this.drawer.addEventListener("theme:drawer:open", function () {
                this.cart ? this.loadHTML() : this.init().then((() => this.loadHTML())), window.theme.state.cartOpen = !0
            }.bind(this)), this.drawer.addEventListener("theme:drawer:close", (function () {
                window.theme.state.cartOpen = !1
            }))), new jh(this.container), new ud(this.container)
        }
        init() {
            return window.fetch(`${window.theme.routes.cart}.js`).then(this.handleErrors).then((e => e.json())).then((e => (this.cart = e, this.fireChange(e), e))).catch((e => {
                console.error(e)
            }))
        }
        loadHTML(e = !1) {
            this.stale && (this.cart && this.cart.item_count > 0 ? this.loadForm(e) : (this.showEmpty(), this.cartMessages.forEach((e => {
                new ud(e)
            })))), this.stale = !1
        }
        initInputs() {
            this.inputs = this.container.querySelectorAll(`[${Td}]`), this.inputs.forEach((e => {
                const t = e.getAttribute(Td);
                e.addEventListener("change", function (e) {
                    const i = parseInt(e.target.value, 10);
                    this.latestClick = e.target.closest(Ld), this.lockState(), this.updateCart(t, i)
                }.bind(this))
            }))
        }
        initRemove() {
            this.removers = this.container.querySelectorAll(`[${xd}]`), this.removers.forEach((e => {
                const t = e.getAttribute(xd);
                e.addEventListener("click", function (e) {
                    e.preventDefault(), this.latestClick = e.target.closest(Ld), this.lockState(), this.updateCart(t, 0)
                }.bind(this))
            }))
        }
        lockState() {
            this.latestClick.querySelector(Pd).style.display = "block", this.loader.classList.add(Dd)
        }
        updateCart(e, t) {
            window.fetch(`${window.theme.routes.cart}/change.js`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: e,
                    quantity: t
                })
            }).then(this.handleErrors).then((e => e.json())).then((e => {
                this.cart = e, Nr(this.errors), this.fireChange(e), this.stale = !0, this.loadHTML()
            })).catch((e => {
                if (!(e instanceof Z)) {
                    let t = `<p>${e.message || defaultMessage}</p>`;
                    throw this.showError(t), e
                } {
                    var t, i;
                    let s = window.theme.strings.stockout || "Could not update cart, please reload",
                        r = (null === (t = e.json) || void 0 === t ? void 0 : t.message) || e.message || s,
                        n = (null === (i = e.json) || void 0 === i ? void 0 : i.description) || "",
                        o = r === n ? `<p>${r}</p>` : `<p>${r}</p> <p>${n}</p>`;
                    this.showError(o), this.loadForm()
                }
            }))
        }
        fireChange(e) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", {
                detail: {
                    cart: e
                },
                bubbles: !0
            }))
        }
        updateTotal() {
            if (this.cart && null != this.cart.total_price) {
                const e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = e + ` ${theme.currencyCode}`
            }
            this.subtotal && this.cart && window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`).then(this.handleErrors).then((e => e.text())).then((e => {
                const t = document.createElement("div");
                t.innerHTML = e, this.subtotal.innerHTML = t.querySelector(Id).innerHTML
            }))
        }
        showError(e) {
            Nr(this.errors), this.errors.innerHTML = e, window.setTimeout((() => {
                Wr(this.errors)
            }), 600)
        }
        loadForm(e = !1) {
            if (e) return this.showForm(), this.initQuantity(), this.initQuickview(), void this.updateTotal();
            window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`).then(this.handleErrors).then((e => e.text())).then((e => {
                const t = document.createElement("div");
                t.innerHTML = e, this.items.innerHTML = t.querySelector(Id).innerHTML, this.showForm(), this.initQuantity(), this.initQuickview(), this.updateTotal()
            }))
        }
        initQuickview() {
            const e = this.items.querySelector(_d),
                t = this.bottom.querySelector(_d);
            t && t.remove(), this.cartPage && e && (this.bottom.insertBefore(e, this.bottom.firstChild), Alpine.initTree(this.bottom))
        }
        initQuantity() {
            cl(this.container), this.initInputs(), this.initRemove()
        }
        showForm() {
            this.bar && this.bar.classList.remove(Md), this.ship && this.ship.classList.remove(Md), this.progress && this.progress.classList.remove(Md), this.form.classList.remove(Md), this.bottom.classList.remove(Md), this.loader.classList.remove(Dd), this.emptystate.classList.add(Md)
        }
        showEmpty() {
            this.bar && this.bar.classList.add(Md), this.ship && this.ship.classList.add(Md), this.progress && this.progress.classList.add(Md), this.emptystate.classList.remove(Md), this.loader.classList.remove(Dd), this.form.classList.add(Md), this.bottom.classList.add(Md)
        }
        handleErrors(e) {
            return e.ok ? e : e.json().then((function (t) {
                throw new Z({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                })
            }))
        }
        constructor(e) {
            this.section = e, this.container = e.container, this.cartMessages = document.querySelectorAll($d), this.bar = this.container.querySelector(qd), this.ship = this.container.querySelector(Cd), this.drawer = this.container.querySelector(pd), this.form = this.container.querySelector(gd), this.loader = this.container.querySelector(fd), this.bottom = this.container.querySelector(Sd), this.items = this.container.querySelector(bd), this.subtotal = this.container.querySelector(wd), this.errors = this.container.querySelector(Ed), this.finalPrice = this.container.querySelector(kd), this.emptystate = this.container.querySelector(yd), this.progress = this.container.querySelector(vd), this.latestClick = null, this.cart = null, this.stale = !0, this.cartPage = document.querySelector(Ad), this.listen()
        }
    };
    const Hd = {
        onLoad() {
            document.querySelector(pd) && (this.cart = new Od(this));
            this.container.querySelector(md) && new rd(this)
        },
        onUnload: function () {
            this.cart && "function" == typeof this.cart.unload && this.cart.unload()
        }
    },
        Fd = {
            ajaxDisable: "data-ajax-disable",
            shipping: "[data-shipping-estimate-form]",
            input: "[data-update-cart]",
            update: "[data-update-button]",
            bottom: "[data-cart-bottom]",
            upsellWrapper: "[data-cart-page-upsell-wrapper]"
        },
        Bd = "cart--dirty",
        Wd = "heart-beat",
        Nd = {
            onLoad() {
                if (this.container.querySelector(Fd.shipping) && new rd(this), this.disabled = "true" == this.container.getAttribute(Fd.ajaxDisable), this.disabled) return void (this.cart = new Rd(this));
                this.cart = new Od(this);
                this.cart.init().then((() => {
                    this.cart.loadHTML(!0)
                }))
            }
        };
    let Rd = class {
        initQuantity() {
            cl(this.container)
        }
        moveUpsell() {
            const e = this.container.querySelector(Fd.bottom);
            e.insertBefore(this.upsellWrapper, e.firstChild)
        }
        initInputs() {
            this.inputs.forEach((e => {
                e.addEventListener("change", function () {
                    this.updateBtn.classList.add(Bd), this.updateBtn.classList.add(Wd), setTimeout(function () {
                        this.updateBtn.classList.remove(Wd)
                    }.bind(this), 1300)
                }.bind(this))
            }))
        }
        constructor(e) {
            window.theme.state.cartOpen = !0, this.section = e, this.container = e.container, this.inputs = this.container.querySelectorAll(Fd.input), this.quantityWrappers = this.container.querySelectorAll(Fd.qty), this.updateBtn = this.container.querySelector(Fd.update), this.upsellWrapper = this.container.querySelector(Fd.upsellWrapper), this.initQuantity(), this.initInputs(), this.upsellWrapper && this.moveUpsell(), document.addEventListener("theme:cart:reload", function () {
                window.location.reload()
            }.bind(this))
        }
    };
    oi("cart", [Nd, Kr]), oi("cart-drawer", [ss, Hd, Kr]), oi("accordion-single", Kr);
    const jd = (e, t, i = null) => {
        e.style.opacity = 0, e.style.display = t || "block",
            function t() {
                let s = parseFloat(e.style.opacity);
                (s += .1) > 1 || (e.style.opacity = s, requestAnimationFrame(t)), 1 === s && "function" == typeof i && i()
            }()
    },
        zd = (e, t = null) => {
            e.style.opacity = 1,
                function i() {
                    (e.style.opacity -= .1) < 0 ? e.style.display = "none" : requestAnimationFrame(i), 0 === parseFloat(e.style.opacity) && "function" == typeof t && t()
                }()
        },
        Vd = "[data-tracking-consent]",
        Ud = "[data-confirm-cookies]",
        Gd = "[data-close-modal]",
        Jd = "[data-popup-inner]",
        Qd = "[data-newsletter]",
        Yd = "[data-newsletter-holder]",
        Kd = "[data-newsletter-field]",
        Xd = "[data-newsletter-form]",
        Zd = "[data-promo-text]",
        eu = "data-popup-delay",
        tu = "data-cookie-name",
        iu = "data-target-referrer",
        su = "has-value",
        ru = "has-success",
        nu = "has-error",
        ou = "desktop",
        au = "mobile";
    let lu = {},
        cu = class {
            write() {
                (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((e => e.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((e => e.startsWith(this.name)))) {
                    return document.cookie.split("; ").find((e => e.startsWith(this.name))).split("=")[1]
                }
                return !1
            }
            destroy() {
                document.cookie.split("; ").find((e => e.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            constructor(e, t) {
                this.configuration = {
                    expires: null,
                    path: "/",
                    domain: window.location.hostname
                }, this.name = e, this.value = t
            }
        },
        hu = class {
            hide() {
                this.show = !1
            }
            always() {
                this.show && jd(this.element)
            }
            delayed() {
                setTimeout((() => {
                    this.always()
                }), 1e4)
            }
            bottom() {
                let e;
                const t = () => {
                    e && window.cancelAnimationFrame(e), e = window.requestAnimationFrame((() => {
                        window.requestIdleCallback((() => {
                            Math.round(window.scrollY + window.innerHeight) >= Math.round(document.body.clientHeight) && (this.always(), window.removeEventListener("scroll", t, {
                                passive: !0
                            }))
                        }), {
                            timeout: 300
                        })
                    }))
                };
                window.addEventListener("scroll", t, {
                    passive: !0
                })
            }
            onScroll() { }
            idle() {
                let e = 0;
                const t = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        e = setTimeout((() => {
                            e = 0, this.always()
                        }), 6e4), t.forEach((e => {
                            document.addEventListener(e, r)
                        })), i.forEach((e => {
                            window.addEventListener(e, r)
                        }))
                    },
                    r = () => {
                        e && clearTimeout(e), t.forEach((e => {
                            document.removeEventListener(e, r)
                        })), i.forEach((e => {
                            window.removeEventListener(e, r)
                        })), s()
                    };
                s()
            }
            constructor(e, t) {
                this.show = !0, this.element = t, this.delay = e.getAttribute(eu), "always" === this.delay && this.always(), "delayed" === this.delay && this.delayed(), "bottom" === this.delay && this.bottom(), "idle" === this.delay && this.idle()
            }
        },
        du = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(iu)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(e) {
                this.el = e, this.locationPath = location.href, this.el.hasAttribute(iu) && this.init()
            }
        };
    oi("popups", [zn, {
        onLoad() {
            lu[this.id] = [];
            this.container.querySelectorAll(Vd).forEach((e => {
                lu[this.id].push(new class {
                    init() {
                        this.showPopup && jd(this.modalInner), this.clickEvents()
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (e => {
                            e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, (() => zd(this.modalInner)))
                        })), this.acceptButton.addEventListener("click", (e => {
                            e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, (() => zd(this.modalInner)))
                        })), document.addEventListener("trackingConsentAccepted", (function () {
                            console.log("trackingConsentAccepted event fired")
                        }))
                    }
                    onBlockSelect(e) {
                        this.popup.contains(e.target) && this.showPopup && jd(this.modalInner)
                    }
                    onBlockDeselect(e) {
                        this.popup.contains(e.target) && zd(this.modalInner)
                    }
                    constructor(e) {
                        this.popup = e, this.modal = document.querySelector(Vd), this.modalInner = this.popup.querySelector(Jd), this.close = this.modal.querySelector(Gd), this.acceptButton = this.modal.querySelector(Ud), this.enable = "true" === this.modal.getAttribute("data-enable"), this.showPopup = !1, window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], (e => {
                            if (e) throw e;
                            const t = window.Shopify.customerPrivacy.userCanBeTracked(),
                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.showPopup = !t && "no_interaction" === i && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
                        }))
                    }
                }(e))
            }));
            this.container.querySelectorAll(Qd).forEach((e => {
                lu[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (this.show(), this.checkForSuccess())
                    }
                    show() {
                        window.Shopify.designMode ? jd(this.popupInner) : this.delayShow = new hu(this.popup, this.popupInner), this.inputField(), this.closePopup()
                    }
                    preventDelayShow() {
                        this.delayShow && this.delayShow.hide()
                    }
                    checkForSuccess() {
                        const e = this.form.classList.contains(nu),
                            t = this.form.classList.contains(ru);
                        (t || e) && (jd(this.popupInner), this.preventDelayShow(), t && this.cookie.write())
                    }
                    closePopup() {
                        this.close.addEventListener("click", (e => {
                            e.preventDefault(), zd(this.popupInner), this.cookie.write(), this.preventDelayShow()
                        }))
                    }
                    inputField() {
                        this.newsletterField.addEventListener("input", (() => {
                            "" !== this.newsletterField.value && this.holder.classList.add(su, "" !== this.newsletterField.value)
                        })), this.newsletterField.addEventListener("focus", (() => {
                            "" !== this.newsletterField.value && this.holder.classList.add(su, "" !== this.newsletterField.value)
                        })), this.newsletterField.addEventListener("focusout", (() => {
                            setTimeout((() => {
                                this.holder.classList.remove(su)
                            }), 2e3)
                        }))
                    }
                    onBlockSelect(e) {
                        this.popup.contains(e.target) && jd(this.popupInner)
                    }
                    onBlockDeselect(e) {
                        this.popup.contains(e.target) && zd(this.popupInner)
                    }
                    constructor(e) {
                        this.popup = e, this.popupInner = this.popup.querySelector(Jd), this.holder = this.popup.querySelector(Yd), this.close = this.popup.querySelector(Gd), this.newsletterField = this.popup.querySelector(Kd), this.cookie = new cu(this.popup.getAttribute(tu), "newsletter_is_closed"), this.form = this.popup.querySelector(Xd), this.isTargeted = new du(this.popup), this.delayShow = null, this.init()
                    }
                }(e))
            }));
            this.container.querySelectorAll(Zd).forEach((e => {
                lu[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? jd(this.popupInner) : new hu(this.popup, this.popupInner), this.clickEvents())
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (e => {
                            e.preventDefault(), zd(this.popupInner), this.cookie.write()
                        }))
                    }
                    onBlockSelect(e) {
                        this.popup.classList.contains(au) && (this.hasDeviceClass = au), this.popup.classList.contains(ou) && (this.hasDeviceClass = ou), "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass), this.popup.contains(e.target) && jd(this.popupInner)
                    }
                    onBlockDeselect(e) {
                        this.popup.contains(e.target) && zd(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass)
                    }
                    constructor(e) {
                        this.popup = e, this.popupInner = this.popup.querySelector(Jd), this.close = this.popup.querySelector(Gd), this.cookie = new cu(this.popup.getAttribute(tu), "user_has_closed"), this.isTargeted = new du(this.popup), this.hasDeviceClass = "", this.init()
                    }
                }(e))
            }))
        },
        onBlockSelect(e) {
            lu[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }))
        },
        onBlockDeselect(e) {
            lu[this.id].forEach((t => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            }))
        }
    }]);
    const uu = "data-look-dot",
        pu = "data-products-holder",
        mu = "[data-carousel]",
        fu = "[data-button-close-holder]",
        gu = "data-carousel-index",
        yu = "data-block-id",
        vu = "button",
        bu = "is-active",
        wu = "is-expanded",
        Su = {};
    oi("look", [{
        onLoad() {
            Su[this.id] = [], Su[this.id].push(new class {
                init() {
                    this.keyEvents = e => this.keyboardEventShowProductHolder(e), this.keyCloseEvent = e => this.hideProductsHolder(e), this.clickEventsDot = e => this.clickEventShowProductsHolder(e), this.clickEventToClose = e => this.clickEventCloseProductsHolder(e), this.toggleOnResize = e => T(this.onResize(e), 200), this.initSlider(), this.addEvents()
                }
                initSlider() {
                    this.slider && (this.carousel = s.data(this.slider), this.carousel.options.wrapAround = !0, this.carousel.options.freeScroll = !1, this.carousel.resize(), this.carousel.on("change", (e => {
                        this.currentDot = this.container.querySelector(`[${uu}="${e}"]`), this.currentDot.classList.add(bu), this.removeClassOnSiblingDots()
                    })))
                }
                addEvents() {
                    this.dots.forEach((e => {
                        e.addEventListener("click", this.clickEventsDot), e.addEventListener("keyup", this.keyEvents)
                    })), document.addEventListener("keyup", this.keyCloseEvent), document.addEventListener("theme:resize", this.toggleOnResize), this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose)
                }
                showProductsHolder() {
                    const e = !this.productsHolder.classList.contains(wu);
                    this.currentDot.classList.toggle(bu), this.productsHolder.classList.toggle(wu, this.currentDot.classList.contains(bu)), this.currentDot.classList.contains(bu) && (this.hasDefaultOpen = !0, this.carousel.selectCell(Number(this.currentDot.getAttribute(uu)), !0, e)), this.removeClassOnSiblingDots()
                }
                hideProductsHolder(e) {
                    "Escape" === e.code && (this.removeClasses(), vi(), this.currentDot.focus())
                }
                removeClasses() {
                    this.productsHolder.classList.remove(wu), this.currentDot.classList.remove(bu), this.hasDefaultOpen = !1
                }
                clickEventShowProductsHolder(e) {
                    this.currentDot = e.currentTarget, this.showProductsHolder()
                }
                clickEventCloseProductsHolder() {
                    this.removeClasses()
                }
                keyboardEventShowProductHolder(e) {
                    "Enter" !== e.code && "Space" !== e.code || setTimeout((() => {
                        const e = this.productsHolder.querySelector(vu);
                        yi(this.productsHolder, {
                            elementToFocus: e
                        })
                    }), 400)
                }
                onResize() {
                    this.currentDot && (window.innerWidth < window.theme.sizes.medium ? (this.currentDot.classList.remove(bu), this.productsHolder.classList.remove(wu)) : this.hasDefaultOpen && (this.currentDot.classList.add(bu), this.productsHolder.classList.add(wu)))
                }
                removeEvents() {
                    this.dots.forEach((e => {
                        e.removeEventListener("click", this.clickEventsDot), e.removeEventListener("keyup", this.keyEvents)
                    })), document.removeEventListener("keyup", this.keyCloseEvent), document.removeEventListener("theme:resize", this.toggleOnResize), this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose)
                }
                removeClassOnSiblingDots() {
                    for (let e of this.currentDot.parentNode.children) e !== this.currentDot && e.classList.remove(bu)
                }
                onUnload() {
                    this.slider && this.carousel && this.carousel.destroy(), this.removeEvents()
                }
                onBlockSelect(e) {
                    if (this.slider && this.carousel) {
                        const t = this.container.querySelector(`[${yu}="${e.detail.blockId}"]`);
                        this.productsHolder.classList.add(wu), this.carousel.selectCell(Number(t.getAttribute(gu)), !0, !0)
                    }
                }
                onBlockDeselect() {
                    window.innerWidth < window.theme.sizes.medium && (this.productsHolder.classList.remove(wu), this.currentDot.classList.remove(bu))
                }
                constructor(e) {
                    this.section = e, this.container = this.section.container, this.dots = this.container.querySelectorAll(`[${uu}]`), this.productsHolder = this.container.querySelector(`[${pu}]`), this.slider = this.container.querySelector(mu), this.buttonClose = this.container.querySelector(fu), this.currentDot = this.container.querySelector(`[${uu}].${bu}`), this.hasDefaultOpen = Boolean(this.currentDot), this.init()
                }
            }(this))
        },
        onUnload() {
            Su[this.id].forEach((e => {
                "function" == typeof e.onUnload && e.onUnload()
            }))
        },
        onBlockSelect(e) {
            Su[this.id].forEach((t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }))
        },
        onBlockDeselect(e) {
            Su[this.id].forEach((t => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            }))
        }
    }]);
    const Eu = (e, t = "", i) => ((i = i || document.createElement("div")).classList.add(t), e.parentNode.insertBefore(i, e), i.appendChild(e));
    window.theme.settings.animate_scroll && e.init({
        once: !0
    }), document.addEventListener("DOMContentLoaded", (function () {
        const e = document.querySelector("[data-header-height]");
        if (e) {
            const t = e.clientHeight || 0;
            document.documentElement.style.setProperty("--menu-height", `${t}px`)
        }
        ai("*"), window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover");
        document.querySelectorAll(".rte table").forEach((e => {
            Eu(e, "rte__table-wrapper")
        }));
        document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((e => {
            Eu(e, "rte__video-wrapper")
        })), document.addEventListener("mousedown", (() => {
            document.body.classList.remove("focus-enabled")
        })), document.addEventListener("keyup", (e => {
            "Tab" === e.code && document.body.classList.add("focus-enabled")
        })), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")), pi(), mi(), "scrollBehavior" in document.documentElement.style || Fe({
            url: window.theme.assets.smoothscroll
        })
    }));
    var Lu = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"],
        ku = Lu.join(","),
        Tu = "undefined" == typeof Element ? function () { } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
        xu = function (e, t, i) {
            var s = Array.prototype.slice.apply(e.querySelectorAll(ku));
            return t && Tu.call(e, ku) && s.unshift(e), s = s.filter(i)
        },
        _u = function (e) {
            var t = parseInt(e.getAttribute("tabindex"), 10);
            return isNaN(t) ? function (e) {
                return "true" === e.contentEditable
            }(e) ? 0 : "AUDIO" !== e.nodeName && "VIDEO" !== e.nodeName && "DETAILS" !== e.nodeName || null !== e.getAttribute("tabindex") ? e.tabIndex : 0 : t
        },
        Au = function (e, t) {
            return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex
        },
        qu = function (e) {
            return "INPUT" === e.tagName
        },
        Cu = function (e) {
            return function (e) {
                return qu(e) && "radio" === e.type
            }(e) && ! function (e) {
                if (!e.name) return !0;
                var t, i = e.form || e.ownerDocument,
                    s = function (e) {
                        return i.querySelectorAll('input[type="radio"][name="' + e + '"]')
                    };
                if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = s(window.CSS.escape(e.name));
                else try {
                    t = s(e.name)
                } catch (e) {
                    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1
                }
                var r = function (e, t) {
                    for (var i = 0; i < e.length; i++)
                        if (e[i].checked && e[i].form === t) return e[i]
                }(t, e.form);
                return !r || r === e
            }(e)
        },
        Pu = function (e, t) {
            return !(t.disabled || function (e) {
                return qu(e) && "hidden" === e.type
            }(t) || function (e, t) {
                if ("hidden" === getComputedStyle(e).visibility) return !0;
                var i = Tu.call(e, "details>summary:first-of-type") ? e.parentElement : e;
                if (Tu.call(i, "details:not([open]) *")) return !0;
                if (t && "full" !== t) {
                    if ("non-zero-area" === t) {
                        var s = e.getBoundingClientRect(),
                            r = s.width,
                            n = s.height;
                        return 0 === r && 0 === n
                    }
                } else
                    for (; e;) {
                        if ("none" === getComputedStyle(e).display) return !0;
                        e = e.parentElement
                    }
                return !1
            }(t, e.displayCheck) || function (e) {
                return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some((function (e) {
                    return "SUMMARY" === e.tagName
                }))
            }(t) || function (e) {
                if (qu(e) || "SELECT" === e.tagName || "TEXTAREA" === e.tagName || "BUTTON" === e.tagName)
                    for (var t = e.parentElement; t;) {
                        if ("FIELDSET" === t.tagName && t.disabled) {
                            for (var i = 0; i < t.children.length; i++) {
                                var s = t.children.item(i);
                                if ("LEGEND" === s.tagName) return !s.contains(e)
                            }
                            return !0
                        }
                        t = t.parentElement
                    }
                return !1
            }(t))
        },
        $u = function (e, t) {
            return !(!Pu(e, t) || Cu(t) || _u(t) < 0)
        },
        Iu = function (e, t) {
            var i = [],
                s = [];
            return xu(e, (t = t || {}).includeContainer, $u.bind(null, t)).forEach((function (e, t) {
                var r = _u(e);
                0 === r ? i.push(e) : s.push({
                    documentOrder: t,
                    tabIndex: r,
                    node: e
                })
            })), s.sort(Au).map((function (e) {
                return e.node
            })).concat(i)
        },
        Mu = Lu.concat("iframe").join(","),
        Du = function (e, t) {
            if (t = t || {}, !e) throw new Error("No node provided");
            return !1 !== Tu.call(e, Mu) && Pu(t, e)
        };

    function Ou(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter((function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }))), i.push.apply(i, s)
        }
        return i
    }

    function Hu(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e
    }
    var Fu, Bu = (Fu = [], {
        activateTrap: function (e) {
            if (Fu.length > 0) {
                var t = Fu[Fu.length - 1];
                t !== e && t.pause()
            }
            var i = Fu.indexOf(e); - 1 === i || Fu.splice(i, 1), Fu.push(e)
        },
        deactivateTrap: function (e) {
            var t = Fu.indexOf(e); - 1 !== t && Fu.splice(t, 1), Fu.length > 0 && Fu[Fu.length - 1].unpause()
        }
    }),
        Wu = function (e) {
            return setTimeout(e, 0)
        },
        Nu = function (e, t) {
            var i = -1;
            return e.every((function (e, s) {
                return !t(e) || (i = s, !1)
            })), i
        },
        Ru = function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
            return "function" == typeof e ? e.apply(void 0, i) : e
        },
        ju = function (e, t) {
            var i, s = document,
                r = function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var i = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Ou(Object(i), !0).forEach((function (t) {
                            Hu(e, t, i[t])
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Ou(Object(i)).forEach((function (t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t))
                        }))
                    }
                    return e
                }({
                    returnFocusOnDeactivate: !0,
                    escapeDeactivates: !0,
                    delayInitialFocus: !0
                }, t),
                n = {
                    containers: [],
                    tabbableGroups: [],
                    nodeFocusedBeforeActivation: null,
                    mostRecentlyFocusedNode: null,
                    active: !1,
                    paused: !1,
                    delayInitialFocusTimer: void 0
                },
                o = function (e, t, i) {
                    return e && void 0 !== e[t] ? e[t] : r[i || t]
                },
                a = function (e) {
                    return n.containers.some((function (t) {
                        return t.contains(e)
                    }))
                },
                l = function (e) {
                    var t = r[e];
                    if (!t) return null;
                    var i = t;
                    if ("string" == typeof t && !(i = s.querySelector(t))) throw new Error("`".concat(e, "` refers to no known node"));
                    if ("function" == typeof t && !(i = t())) throw new Error("`".concat(e, "` did not return a node"));
                    return i
                },
                c = function () {
                    var e;
                    if (!1 === o({}, "initialFocus")) return !1;
                    if (null !== l("initialFocus")) e = l("initialFocus");
                    else if (a(s.activeElement)) e = s.activeElement;
                    else {
                        var t = n.tabbableGroups[0];
                        e = t && t.firstTabbableNode || l("fallbackFocus")
                    }
                    if (!e) throw new Error("Your focus-trap needs to have at least one focusable element");
                    return e
                },
                h = function () {
                    if (n.tabbableGroups = n.containers.map((function (e) {
                        var t = Iu(e);
                        if (t.length > 0) return {
                            container: e,
                            firstTabbableNode: t[0],
                            lastTabbableNode: t[t.length - 1]
                        }
                    })).filter((function (e) {
                        return !!e
                    })), n.tabbableGroups.length <= 0 && !l("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times")
                },
                d = function e(t) {
                    !1 !== t && t !== s.activeElement && (t && t.focus ? (t.focus({
                        preventScroll: !!r.preventScroll
                    }), n.mostRecentlyFocusedNode = t, function (e) {
                        return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select
                    }(t) && t.select()) : e(c()))
                },
                u = function (e) {
                    var t = l("setReturnFocus");
                    return t || e
                },
                p = function (e) {
                    a(e.target) || (Ru(r.clickOutsideDeactivates, e) ? i.deactivate({
                        returnFocus: r.returnFocusOnDeactivate && !Du(e.target)
                    }) : Ru(r.allowOutsideClick, e) || e.preventDefault())
                },
                m = function (e) {
                    var t = a(e.target);
                    t || e.target instanceof Document ? t && (n.mostRecentlyFocusedNode = e.target) : (e.stopImmediatePropagation(), d(n.mostRecentlyFocusedNode || c()))
                },
                f = function (e) {
                    if (function (e) {
                        return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode
                    }(e) && !1 !== Ru(r.escapeDeactivates)) return e.preventDefault(), void i.deactivate();
                    (function (e) {
                        return "Tab" === e.key || 9 === e.keyCode
                    })(e) && function (e) {
                        h();
                        var t = null;
                        if (n.tabbableGroups.length > 0) {
                            var i = Nu(n.tabbableGroups, (function (t) {
                                return t.container.contains(e.target)
                            }));
                            if (i < 0) t = e.shiftKey ? n.tabbableGroups[n.tabbableGroups.length - 1].lastTabbableNode : n.tabbableGroups[0].firstTabbableNode;
                            else if (e.shiftKey) {
                                var s = Nu(n.tabbableGroups, (function (t) {
                                    var i = t.firstTabbableNode;
                                    return e.target === i
                                }));
                                if (s < 0 && n.tabbableGroups[i].container === e.target && (s = i), s >= 0) {
                                    var r = 0 === s ? n.tabbableGroups.length - 1 : s - 1;
                                    t = n.tabbableGroups[r].lastTabbableNode
                                }
                            } else {
                                var o = Nu(n.tabbableGroups, (function (t) {
                                    var i = t.lastTabbableNode;
                                    return e.target === i
                                }));
                                if (o < 0 && n.tabbableGroups[i].container === e.target && (o = i), o >= 0) {
                                    var a = o === n.tabbableGroups.length - 1 ? 0 : o + 1;
                                    t = n.tabbableGroups[a].firstTabbableNode
                                }
                            }
                        } else t = l("fallbackFocus");
                        t && (e.preventDefault(), d(t))
                    }(e)
                },
                g = function (e) {
                    Ru(r.clickOutsideDeactivates, e) || a(e.target) || Ru(r.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation())
                },
                y = function () {
                    if (n.active) return Bu.activateTrap(i), n.delayInitialFocusTimer = r.delayInitialFocus ? Wu((function () {
                        d(c())
                    })) : d(c()), s.addEventListener("focusin", m, !0), s.addEventListener("mousedown", p, {
                        capture: !0,
                        passive: !1
                    }), s.addEventListener("touchstart", p, {
                        capture: !0,
                        passive: !1
                    }), s.addEventListener("click", g, {
                        capture: !0,
                        passive: !1
                    }), s.addEventListener("keydown", f, {
                        capture: !0,
                        passive: !1
                    }), i
                },
                v = function () {
                    if (n.active) return s.removeEventListener("focusin", m, !0), s.removeEventListener("mousedown", p, !0), s.removeEventListener("touchstart", p, !0), s.removeEventListener("click", g, !0), s.removeEventListener("keydown", f, !0), i
                };
            return (i = {
                activate: function (e) {
                    if (n.active) return this;
                    var t = o(e, "onActivate"),
                        i = o(e, "onPostActivate"),
                        r = o(e, "checkCanFocusTrap");
                    r || h(), n.active = !0, n.paused = !1, n.nodeFocusedBeforeActivation = s.activeElement, t && t();
                    var a = function () {
                        r && h(), y(), i && i()
                    };
                    return r ? (r(n.containers.concat()).then(a, a), this) : (a(), this)
                },
                deactivate: function (e) {
                    if (!n.active) return this;
                    clearTimeout(n.delayInitialFocusTimer), n.delayInitialFocusTimer = void 0, v(), n.active = !1, n.paused = !1, Bu.deactivateTrap(i);
                    var t = o(e, "onDeactivate"),
                        s = o(e, "onPostDeactivate"),
                        r = o(e, "checkCanReturnFocus");
                    t && t();
                    var a = o(e, "returnFocus", "returnFocusOnDeactivate"),
                        l = function () {
                            Wu((function () {
                                a && d(u(n.nodeFocusedBeforeActivation)), s && s()
                            }))
                        };
                    return a && r ? (r(u(n.nodeFocusedBeforeActivation)).then(l, l), this) : (l(), this)
                },
                pause: function () {
                    return n.paused || !n.active || (n.paused = !0, v()), this
                },
                unpause: function () {
                    return n.paused && n.active ? (n.paused = !1, h(), y(), this) : this
                },
                updateContainerElements: function (e) {
                    var t = [].concat(e).filter(Boolean);
                    return n.containers = t.map((function (e) {
                        return "string" == typeof e ? s.querySelector(e) : e
                    })), n.active && h(), this
                }
            }).updateContainerElements(e), i
        };

    function zu(e) {
        let t = [];
        return Vu(e, (e => {
            let i = e.hasAttribute("aria-hidden");
            e.setAttribute("aria-hidden", "true"), t.push((() => i || e.removeAttribute("aria-hidden")))
        })), () => {
            for (; t.length;) t.pop()()
        }
    }

    function Vu(e, t) {
        !e.isSameNode(document.body) && e.parentNode && Array.from(e.parentNode.children).forEach((i => {
            i.isSameNode(e) ? Vu(e.parentNode, t) : t(i)
        }))
    }
    var Uu, Gu, Ju, Qu, Yu = function (e) {
        let t, i;
        window.addEventListener("focusin", (() => {
            t = i, i = document.activeElement
        })), e.magic("focus", (e => {
            let s = e;
            return {
                __noscroll: !1,
                __wrapAround: !1,
                within(e) {
                    return s = e, this
                },
                withoutScrolling() {
                    return this.__noscroll = !0, this
                },
                noscroll() {
                    return this.__noscroll = !0, this
                },
                withWrapAround() {
                    return this.__wrapAround = !0, this
                },
                wrap() {
                    return this.withWrapAround()
                },
                focusable: e => Du(e),
                previouslyFocused: () => t,
                lastFocused: () => t,
                focused: () => i,
                focusables: () => Array.isArray(s) ? s : function (e, t) {
                    return xu(e, (t = t || {}).includeContainer, Pu.bind(null, t))
                }(s, {
                    displayCheck: "none"
                }),
                all() {
                    return this.focusables()
                },
                isFirst(e) {
                    let t = this.all();
                    return t[0] && t[0].isSameNode(e)
                },
                isLast(e) {
                    let t = this.all();
                    return t.length && t.slice(-1)[0].isSameNode(e)
                },
                getFirst() {
                    return this.all()[0]
                },
                getLast() {
                    return this.all().slice(-1)[0]
                },
                getNext() {
                    let e = this.all(),
                        t = document.activeElement;
                    if (-1 !== e.indexOf(t)) return this.__wrapAround && e.indexOf(t) === e.length - 1 ? e[0] : e[e.indexOf(t) + 1]
                },
                getPrevious() {
                    let e = this.all(),
                        t = document.activeElement;
                    if (-1 !== e.indexOf(t)) return this.__wrapAround && 0 === e.indexOf(t) ? e.slice(-1)[0] : e[e.indexOf(t) - 1]
                },
                first() {
                    this.focus(this.getFirst())
                },
                last() {
                    this.focus(this.getLast())
                },
                next() {
                    this.focus(this.getNext())
                },
                previous() {
                    this.focus(this.getPrevious())
                },
                prev() {
                    return this.previous()
                },
                focus(e) {
                    e && setTimeout((() => {
                        e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"), e.focus({
                            preventScroll: this._noscroll
                        })
                    }))
                }
            }
        })), e.directive("trap", e.skipDuringClone(((e, {
            expression: t,
            modifiers: i
        }, {
            effect: s,
            evaluateLater: r,
            cleanup: n
        }) => {
            let o = r(t),
                a = !1,
                l = ju(e, {
                    escapeDeactivates: !1,
                    allowOutsideClick: !0,
                    fallbackFocus: () => e,
                    initialFocus: e.querySelector("[autofocus]")
                }),
                c = () => { },
                h = () => { };
            const d = () => {
                c(), c = () => { }, h(), h = () => { }, l.deactivate({
                    returnFocus: !i.includes("noreturn")
                })
            };
            s((() => o((t => {
                a !== t && (t && !a && setTimeout((() => {
                    i.includes("inert") && (c = zu(e)), i.includes("noscroll") && (h = function () {
                        let e = document.documentElement.style.overflow,
                            t = document.documentElement.style.paddingRight,
                            i = window.innerWidth - document.documentElement.clientWidth;
                        return document.documentElement.style.overflow = "hidden", document.documentElement.style.paddingRight = `${i}px`, () => {
                            document.documentElement.style.overflow = e, document.documentElement.style.paddingRight = t
                        }
                    }()), l.activate()
                })), !t && a && d(), a = !!t)
            })))), n(d)
        }), ((e, {
            expression: t,
            modifiers: i
        }, {
            evaluate: s
        }) => {
            i.includes("inert") && s(t) && zu(e)
        })))
    },
        Ku = !1,
        Xu = !1,
        Zu = [],
        ep = -1;

    function tp(e) {
        ! function (e) {
            Zu.includes(e) || Zu.push(e);
            Xu || Ku || (Ku = !0, queueMicrotask(sp))
        }(e)
    }

    function ip(e) {
        let t = Zu.indexOf(e); - 1 !== t && t > ep && Zu.splice(t, 1)
    }

    function sp() {
        Ku = !1, Xu = !0;
        for (let e = 0; e < Zu.length; e++) Zu[e](), ep = e;
        Zu.length = 0, ep = -1, Xu = !1
    }
    var rp = !0;

    function np(e) {
        Gu = e
    }
    var op = [],
        ap = [],
        lp = [];

    function cp(e, t) {
        "function" == typeof t ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t)) : (t = e, ap.push(t))
    }

    function hp(e, t) {
        e._x_attributeCleanups && Object.entries(e._x_attributeCleanups).forEach((([i, s]) => {
            (void 0 === t || t.includes(i)) && (s.forEach((e => e())), delete e._x_attributeCleanups[i])
        }))
    }
    var dp = new MutationObserver(wp),
        up = !1;

    function pp() {
        dp.observe(document, {
            subtree: !0,
            childList: !0,
            attributes: !0,
            attributeOldValue: !0
        }), up = !0
    }

    function mp() {
        (fp = fp.concat(dp.takeRecords())).length && !gp && (gp = !0, queueMicrotask((() => {
            wp(fp), fp.length = 0, gp = !1
        }))), dp.disconnect(), up = !1
    }
    var fp = [],
        gp = !1;

    function yp(e) {
        if (!up) return e();
        mp();
        let t = e();
        return pp(), t
    }
    var vp = !1,
        bp = [];

    function wp(e) {
        if (vp) return void (bp = bp.concat(e));
        let t = [],
            i = [],
            s = new Map,
            r = new Map;
        for (let n = 0; n < e.length; n++)
            if (!e[n].target._x_ignoreMutationObserver && ("childList" === e[n].type && (e[n].addedNodes.forEach((e => 1 === e.nodeType && t.push(e))), e[n].removedNodes.forEach((e => 1 === e.nodeType && i.push(e)))), "attributes" === e[n].type)) {
                let t = e[n].target,
                    i = e[n].attributeName,
                    o = e[n].oldValue,
                    a = () => {
                        s.has(t) || s.set(t, []), s.get(t).push({
                            name: i,
                            value: t.getAttribute(i)
                        })
                    },
                    l = () => {
                        r.has(t) || r.set(t, []), r.get(t).push(i)
                    };
                t.hasAttribute(i) && null === o ? a() : t.hasAttribute(i) ? (l(), a()) : l()
            } r.forEach(((e, t) => {
                hp(t, e)
            })), s.forEach(((e, t) => {
                op.forEach((i => i(t, e)))
            }));
        for (let e of i)
            if (!t.includes(e) && (ap.forEach((t => t(e))), e._x_cleanups))
                for (; e._x_cleanups.length;) e._x_cleanups.pop()();
        t.forEach((e => {
            e._x_ignoreSelf = !0, e._x_ignore = !0
        }));
        for (let e of t) i.includes(e) || e.isConnected && (delete e._x_ignoreSelf, delete e._x_ignore, lp.forEach((t => t(e))), e._x_ignore = !0, e._x_ignoreSelf = !0);
        t.forEach((e => {
            delete e._x_ignoreSelf, delete e._x_ignore
        })), t = null, i = null, s = null, r = null
    }

    function Sp(e) {
        return kp(Lp(e))
    }

    function Ep(e, t, i) {
        return e._x_dataStack = [t, ...Lp(i || e)], () => {
            e._x_dataStack = e._x_dataStack.filter((e => e !== t))
        }
    }

    function Lp(e) {
        return e._x_dataStack ? e._x_dataStack : "function" == typeof ShadowRoot && e instanceof ShadowRoot ? Lp(e.host) : e.parentNode ? Lp(e.parentNode) : []
    }

    function kp(e) {
        let t = new Proxy({}, {
            ownKeys: () => Array.from(new Set(e.flatMap((e => Object.keys(e))))),
            has: (t, i) => e.some((e => e.hasOwnProperty(i))),
            get: (i, s) => (e.find((e => {
                if (e.hasOwnProperty(s)) {
                    let i = Object.getOwnPropertyDescriptor(e, s);
                    if (i.get && i.get._x_alreadyBound || i.set && i.set._x_alreadyBound) return !0;
                    if ((i.get || i.set) && i.enumerable) {
                        let r = i.get,
                            n = i.set,
                            o = i;
                        r = r && r.bind(t), n = n && n.bind(t), r && (r._x_alreadyBound = !0), n && (n._x_alreadyBound = !0), Object.defineProperty(e, s, {
                            ...o,
                            get: r,
                            set: n
                        })
                    }
                    return !0
                }
                return !1
            })) || {})[s],
            set: (t, i, s) => {
                let r = e.find((e => e.hasOwnProperty(i)));
                return r ? r[i] = s : e[e.length - 1][i] = s, !0
            }
        });
        return t
    }

    function Tp(e) {
        let t = (i, s = "") => {
            Object.entries(Object.getOwnPropertyDescriptors(i)).forEach((([r, {
                value: n,
                enumerable: o
            }]) => {
                if (!1 === o || void 0 === n) return;
                let a = "" === s ? r : `${s}.${r}`;
                var l;
                "object" == typeof n && null !== n && n._x_interceptor ? i[r] = n.initialize(e, a, r) : "object" != typeof (l = n) || Array.isArray(l) || null === l || n === i || n instanceof Element || t(n, a)
            }))
        };
        return t(e)
    }

    function xp(e, t = (() => { })) {
        let i = {
            initialValue: void 0,
            _x_interceptor: !0,
            initialize(t, i, s) {
                return e(this.initialValue, (() => function (e, t) {
                    return t.split(".").reduce(((e, t) => e[t]), e)
                }(t, i)), (e => _p(t, i, e)), i, s)
            }
        };
        return t(i), e => {
            if ("object" == typeof e && null !== e && e._x_interceptor) {
                let t = i.initialize.bind(i);
                i.initialize = (s, r, n) => {
                    let o = e.initialize(s, r, n);
                    return i.initialValue = o, t(s, r, n)
                }
            } else i.initialValue = e;
            return i
        }
    }

    function _p(e, t, i) {
        if ("string" == typeof t && (t = t.split(".")), 1 !== t.length) {
            if (0 === t.length) throw error;
            return e[t[0]] || (e[t[0]] = {}), _p(e[t[0]], t.slice(1), i)
        }
        e[t[0]] = i
    }
    var Ap = {};

    function qp(e, t) {
        Ap[e] = t
    }

    function Cp(e, t) {
        return Object.entries(Ap).forEach((([i, s]) => {
            let r = null;
            Object.defineProperty(e, `$${i}`, {
                get: () => s(t, function () {
                    if (r) return r;
                    {
                        let [e, i] = Yp(t);
                        return r = {
                            interceptor: xp,
                            ...e
                        }, cp(t, i), r
                    }
                }()),
                enumerable: !1
            })
        })), e
    }

    function Pp(e, t, i, ...s) {
        try {
            return i(...s)
        } catch (i) {
            $p(i, e, t)
        }
    }

    function $p(e, t, i) {
        Object.assign(e, {
            el: t,
            expression: i
        }), console.warn(`Alpine Expression Error: ${e.message}\n\n${i ? 'Expression: "' + i + '"\n\n' : ""}`, t), setTimeout((() => {
            throw e
        }), 0)
    }
    var Ip = !0;

    function Mp(e) {
        let t = Ip;
        Ip = !1;
        let i = e();
        return Ip = t, i
    }

    function Dp(e, t, i = {}) {
        let s;
        return Op(e, t)((e => s = e), i), s
    }

    function Op(...e) {
        return Hp(...e)
    }
    var Hp = Fp;

    function Fp(e, t) {
        let i = {};
        Cp(i, e);
        let s = [i, ...Lp(e)],
            r = "function" == typeof t ? function (e, t) {
                return (i = (() => { }), {
                    scope: s = {},
                    params: r = []
                } = {}) => {
                    Wp(i, t.apply(kp([s, ...e]), r))
                }
            }(s, t) : function (e, t, i) {
                let s = function (e, t) {
                    if (Bp[e]) return Bp[e];
                    let i = Object.getPrototypeOf((async function () { })).constructor,
                        s = /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e) ? `(async()=>{ ${e} })()` : e;
                    let r = (() => {
                        try {
                            return new i(["__self", "scope"], `with (scope) { __self.result = ${s} }; __self.finished = true; return __self.result;`)
                        } catch (i) {
                            return $p(i, t, e), Promise.resolve()
                        }
                    })();
                    return Bp[e] = r, r
                }(t, i);
                return (r = (() => { }), {
                    scope: n = {},
                    params: o = []
                } = {}) => {
                    s.result = void 0, s.finished = !1;
                    let a = kp([n, ...e]);
                    if ("function" == typeof s) {
                        let e = s(s, a).catch((e => $p(e, i, t)));
                        s.finished ? (Wp(r, s.result, a, o, i), s.result = void 0) : e.then((e => {
                            Wp(r, e, a, o, i)
                        })).catch((e => $p(e, i, t))).finally((() => s.result = void 0))
                    }
                }
            }(s, t, e);
        return Pp.bind(null, e, t, r)
    }
    var Bp = {};

    function Wp(e, t, i, s, r) {
        if (Ip && "function" == typeof t) {
            let n = t.apply(i, s);
            n instanceof Promise ? n.then((t => Wp(e, t, i, s))).catch((e => $p(e, r, t))) : e(n)
        } else "object" == typeof t && t instanceof Promise ? t.then((t => e(t))) : e(t)
    }
    var Np = "x-";

    function Rp(e = "") {
        return Np + e
    }
    var jp = {};

    function zp(e, t) {
        return jp[e] = t, {
            before(t) {
                if (!jp[t]) return void console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                const i = rm.indexOf(t);
                rm.splice(i >= 0 ? i : rm.indexOf("DEFAULT"), 0, e)
            }
        }
    }

    function Vp(e, t, i) {
        if (t = Array.from(t), e._x_virtualDirectives) {
            let i = Object.entries(e._x_virtualDirectives).map((([e, t]) => ({
                name: e,
                value: t
            }))),
                s = Up(i);
            i = i.map((e => s.find((t => t.name === e.name)) ? {
                name: `x-bind:${e.name}`,
                value: `"${e.value}"`
            } : e)), t = t.concat(i)
        }
        let s = {},
            r = t.map(Xp(((e, t) => s[e] = t))).filter(tm).map(function (e, t) {
                return ({
                    name: i,
                    value: s
                }) => {
                    let r = i.match(im()),
                        n = i.match(/:([a-zA-Z0-9\-:]+)/),
                        o = i.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                        a = t || e[i] || i;
                    return {
                        type: r ? r[1] : null,
                        value: n ? n[1] : null,
                        modifiers: o.map((e => e.replace(".", ""))),
                        expression: s,
                        original: a
                    }
                }
            }(s, i)).sort(nm);
        return r.map((t => function (e, t) {
            let i = () => { },
                s = jp[t.type] || i,
                [r, n] = Yp(e);
            ! function (e, t, i) {
                e._x_attributeCleanups || (e._x_attributeCleanups = {}), e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []), e._x_attributeCleanups[t].push(i)
            }(e, t.original, n);
            let o = () => {
                e._x_ignore || e._x_ignoreSelf || (s.inline && s.inline(e, t, r), s = s.bind(s, e, t, r), Gp ? Jp.get(Qp).push(s) : s())
            };
            return o.runCleanups = n, o
        }(e, t)))
    }

    function Up(e) {
        return Array.from(e).map(Xp()).filter((e => !tm(e)))
    }
    var Gp = !1,
        Jp = new Map,
        Qp = Symbol();

    function Yp(e) {
        let t = [],
            [i, s] = function (e) {
                let t = () => { };
                return [i => {
                    let s = Gu(i);
                    return e._x_effects || (e._x_effects = new Set, e._x_runEffects = () => {
                        e._x_effects.forEach((e => e()))
                    }), e._x_effects.add(s), t = () => {
                        void 0 !== s && (e._x_effects.delete(s), Ju(s))
                    }, s
                }, () => {
                    t()
                }]
            }(e);
        t.push(s);
        return [{
            Alpine: Gm,
            effect: i,
            cleanup: e => t.push(e),
            evaluateLater: Op.bind(Op, e),
            evaluate: Dp.bind(Dp, e)
        }, () => t.forEach((e => e()))]
    }
    var Kp = (e, t) => ({
        name: i,
        value: s
    }) => (i.startsWith(e) && (i = i.replace(e, t)), {
        name: i,
        value: s
    });

    function Xp(e = (() => { })) {
        return ({
            name: t,
            value: i
        }) => {
            let {
                name: s,
                value: r
            } = Zp.reduce(((e, t) => t(e)), {
                name: t,
                value: i
            });
            return s !== t && e(s, t), {
                name: s,
                value: r
            }
        }
    }
    var Zp = [];

    function em(e) {
        Zp.push(e)
    }

    function tm({
        name: e
    }) {
        return im().test(e)
    }
    var im = () => new RegExp(`^${Np}([^:^.]+)\\b`);
    var sm = "DEFAULT",
        rm = ["ignore", "ref", "data", "id", "bind", "init", "for", "model", "modelable", "transition", "show", "if", sm, "teleport"];

    function nm(e, t) {
        let i = -1 === rm.indexOf(e.type) ? sm : e.type,
            s = -1 === rm.indexOf(t.type) ? sm : t.type;
        return rm.indexOf(i) - rm.indexOf(s)
    }

    function om(e, t, i = {}) {
        e.dispatchEvent(new CustomEvent(t, {
            detail: i,
            bubbles: !0,
            composed: !0,
            cancelable: !0
        }))
    }

    function am(e, t) {
        if ("function" == typeof ShadowRoot && e instanceof ShadowRoot) return void Array.from(e.children).forEach((e => am(e, t)));
        let i = !1;
        if (t(e, (() => i = !0)), i) return;
        let s = e.firstElementChild;
        for (; s;) am(s, t), s = s.nextElementSibling
    }

    function lm(e, ...t) {
        console.warn(`Alpine Warning: ${e}`, ...t)
    }
    var cm = !1;
    var hm = [],
        dm = [];

    function um() {
        return hm.map((e => e()))
    }

    function pm() {
        return hm.concat(dm).map((e => e()))
    }

    function mm(e) {
        hm.push(e)
    }

    function fm(e) {
        dm.push(e)
    }

    function gm(e, t = !1) {
        return ym(e, (e => {
            if ((t ? pm() : um()).some((t => e.matches(t)))) return !0
        }))
    }

    function ym(e, t) {
        if (e) {
            if (t(e)) return e;
            if (e._x_teleportBack && (e = e._x_teleportBack), e.parentElement) return ym(e.parentElement, t)
        }
    }
    var vm = [];

    function bm(e, t = am, i = (() => { })) {
        ! function (e) {
            Gp = !0;
            let t = Symbol();
            Qp = t, Jp.set(t, []);
            let i = () => {
                for (; Jp.get(t).length;) Jp.get(t).shift()();
                Jp.delete(t)
            };
            e(i), Gp = !1, i()
        }((() => {
            t(e, ((e, t) => {
                i(e, t), vm.forEach((i => i(e, t))), Vp(e, e.attributes).forEach((e => e())), e._x_ignore && t()
            }))
        }))
    }

    function wm(e) {
        am(e, (e => hp(e)))
    }
    var Sm = [],
        Em = !1;

    function Lm(e = (() => { })) {
        return queueMicrotask((() => {
            Em || setTimeout((() => {
                km()
            }))
        })), new Promise((t => {
            Sm.push((() => {
                e(), t()
            }))
        }))
    }

    function km() {
        for (Em = !1; Sm.length;) Sm.shift()()
    }

    function Tm(e, t) {
        return Array.isArray(t) ? xm(e, t.join(" ")) : "object" == typeof t && null !== t ? function (e, t) {
            let i = e => e.split(" ").filter(Boolean),
                s = Object.entries(t).flatMap((([e, t]) => !!t && i(e))).filter(Boolean),
                r = Object.entries(t).flatMap((([e, t]) => !t && i(e))).filter(Boolean),
                n = [],
                o = [];
            return r.forEach((t => {
                e.classList.contains(t) && (e.classList.remove(t), o.push(t))
            })), s.forEach((t => {
                e.classList.contains(t) || (e.classList.add(t), n.push(t))
            })), () => {
                o.forEach((t => e.classList.add(t))), n.forEach((t => e.classList.remove(t)))
            }
        }(e, t) : "function" == typeof t ? Tm(e, t()) : xm(e, t)
    }

    function xm(e, t) {
        return t = !0 === t ? t = "" : t || "", (t => (e.classList.add(...t), () => {
            e.classList.remove(...t)
        }))(t.split(" ").filter((t => !e.classList.contains(t))).filter(Boolean))
    }

    function _m(e, t) {
        return "object" == typeof t && null !== t ? function (e, t) {
            let i = {};
            return Object.entries(t).forEach((([t, s]) => {
                i[t] = e.style[t], t.startsWith("--") || (t = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()), e.style.setProperty(t, s)
            })), setTimeout((() => {
                0 === e.style.length && e.removeAttribute("style")
            })), () => {
                _m(e, i)
            }
        }(e, t) : function (e, t) {
            let i = e.getAttribute("style", t);
            return e.setAttribute("style", t), () => {
                e.setAttribute("style", i || "")
            }
        }(e, t)
    }

    function Am(e, t = (() => { })) {
        let i = !1;
        return function () {
            i ? t.apply(this, arguments) : (i = !0, e.apply(this, arguments))
        }
    }

    function qm(e, t, i = {}) {
        e._x_transition || (e._x_transition = {
            enter: {
                during: i,
                start: i,
                end: i
            },
            leave: {
                during: i,
                start: i,
                end: i
            },
            in(i = (() => { }), s = (() => { })) {
                Pm(e, t, {
                    during: this.enter.during,
                    start: this.enter.start,
                    end: this.enter.end
                }, i, s)
            },
            out(i = (() => { }), s = (() => { })) {
                Pm(e, t, {
                    during: this.leave.during,
                    start: this.leave.start,
                    end: this.leave.end
                }, i, s)
            }
        })
    }

    function Cm(e) {
        let t = e.parentNode;
        if (t) return t._x_hidePromise ? t : Cm(t)
    }

    function Pm(e, t, {
        during: i,
        start: s,
        end: r
    } = {}, n = (() => { }), o = (() => { })) {
        if (e._x_transitioning && e._x_transitioning.cancel(), 0 === Object.keys(i).length && 0 === Object.keys(s).length && 0 === Object.keys(r).length) return n(), void o();
        let a, l, c;
        ! function (e, t) {
            let i, s, r, n = Am((() => {
                yp((() => {
                    i = !0, s || t.before(), r || (t.end(), km()), t.after(), e.isConnected && t.cleanup(), delete e._x_transitioning
                }))
            }));
            e._x_transitioning = {
                beforeCancels: [],
                beforeCancel(e) {
                    this.beforeCancels.push(e)
                },
                cancel: Am((function () {
                    for (; this.beforeCancels.length;) this.beforeCancels.shift()();
                    n()
                })),
                finish: n
            }, yp((() => {
                t.start(), t.during()
            })), Em = !0, requestAnimationFrame((() => {
                if (i) return;
                let n = 1e3 * Number(getComputedStyle(e).transitionDuration.replace(/,.*/, "").replace("s", "")),
                    o = 1e3 * Number(getComputedStyle(e).transitionDelay.replace(/,.*/, "").replace("s", ""));
                0 === n && (n = 1e3 * Number(getComputedStyle(e).animationDuration.replace("s", ""))), yp((() => {
                    t.before()
                })), s = !0, requestAnimationFrame((() => {
                    i || (yp((() => {
                        t.end()
                    })), km(), setTimeout(e._x_transitioning.finish, n + o), r = !0)
                }))
            }))
        }(e, {
            start() {
                a = t(e, s)
            },
            during() {
                l = t(e, i)
            },
            before: n,
            end() {
                a(), c = t(e, r)
            },
            after: o,
            cleanup() {
                l(), c()
            }
        })
    }

    function $m(e, t, i) {
        if (-1 === e.indexOf(t)) return i;
        const s = e[e.indexOf(t) + 1];
        if (!s) return i;
        if ("scale" === t && isNaN(s)) return i;
        if ("duration" === t || "delay" === t) {
            let e = s.match(/([0-9]+)ms/);
            if (e) return e[1]
        }
        return "origin" === t && ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2]) ? [s, e[e.indexOf(t) + 2]].join(" ") : s
    }
    zp("transition", ((e, {
        value: t,
        modifiers: i,
        expression: s
    }, {
        evaluate: r
    }) => {
        "function" == typeof s && (s = r(s)), !1 !== s && (s && "boolean" != typeof s ? function (e, t, i) {
            qm(e, Tm, "");
            let s = {
                enter: t => {
                    e._x_transition.enter.during = t
                },
                "enter-start": t => {
                    e._x_transition.enter.start = t
                },
                "enter-end": t => {
                    e._x_transition.enter.end = t
                },
                leave: t => {
                    e._x_transition.leave.during = t
                },
                "leave-start": t => {
                    e._x_transition.leave.start = t
                },
                "leave-end": t => {
                    e._x_transition.leave.end = t
                }
            };
            s[i](t)
        }(e, s, t) : function (e, t, i) {
            qm(e, _m);
            let s = !t.includes("in") && !t.includes("out") && !i,
                r = s || t.includes("in") || ["enter"].includes(i),
                n = s || t.includes("out") || ["leave"].includes(i);
            t.includes("in") && !s && (t = t.filter(((e, i) => i < t.indexOf("out"))));
            t.includes("out") && !s && (t = t.filter(((e, i) => i > t.indexOf("out"))));
            let o = !t.includes("opacity") && !t.includes("scale"),
                a = o || t.includes("opacity"),
                l = o || t.includes("scale"),
                c = a ? 0 : 1,
                h = l ? $m(t, "scale", 95) / 100 : 1,
                d = $m(t, "delay", 0) / 1e3,
                u = $m(t, "origin", "center"),
                p = "opacity, transform",
                m = $m(t, "duration", 150) / 1e3,
                f = $m(t, "duration", 75) / 1e3,
                g = "cubic-bezier(0.4, 0.0, 0.2, 1)";
            r && (e._x_transition.enter.during = {
                transformOrigin: u,
                transitionDelay: `${d}s`,
                transitionProperty: p,
                transitionDuration: `${m}s`,
                transitionTimingFunction: g
            }, e._x_transition.enter.start = {
                opacity: c,
                transform: `scale(${h})`
            }, e._x_transition.enter.end = {
                opacity: 1,
                transform: "scale(1)"
            });
            n && (e._x_transition.leave.during = {
                transformOrigin: u,
                transitionDelay: `${d}s`,
                transitionProperty: p,
                transitionDuration: `${f}s`,
                transitionTimingFunction: g
            }, e._x_transition.leave.start = {
                opacity: 1,
                transform: "scale(1)"
            }, e._x_transition.leave.end = {
                opacity: c,
                transform: `scale(${h})`
            })
        }(e, i, t))
    })), window.Element.prototype._x_toggleAndCascadeWithTransitions = function (e, t, i, s) {
        const r = "visible" === document.visibilityState ? requestAnimationFrame : setTimeout;
        let n = () => r(i);
        t ? e._x_transition && (e._x_transition.enter || e._x_transition.leave) ? e._x_transition.enter && (Object.entries(e._x_transition.enter.during).length || Object.entries(e._x_transition.enter.start).length || Object.entries(e._x_transition.enter.end).length) ? e._x_transition.in(i) : n() : e._x_transition ? e._x_transition.in(i) : n() : (e._x_hidePromise = e._x_transition ? new Promise(((t, i) => {
            e._x_transition.out((() => { }), (() => t(s))), e._x_transitioning.beforeCancel((() => i({
                isFromCancelledTransition: !0
            })))
        })) : Promise.resolve(s), queueMicrotask((() => {
            let t = Cm(e);
            t ? (t._x_hideChildren || (t._x_hideChildren = []), t._x_hideChildren.push(e)) : r((() => {
                let t = e => {
                    let i = Promise.all([e._x_hidePromise, ...(e._x_hideChildren || []).map(t)]).then((([e]) => e()));
                    return delete e._x_hidePromise, delete e._x_hideChildren, i
                };
                t(e).catch((e => {
                    if (!e.isFromCancelledTransition) throw e
                }))
            }))
        })))
    };
    var Im = !1;

    function Mm(e, t = (() => { })) {
        return (...i) => Im ? t(...i) : e(...i)
    }

    function Dm(e, t, i, s = []) {
        switch (e._x_bindings || (e._x_bindings = Uu({})), e._x_bindings[t] = i, t = s.includes("camel") ? t.toLowerCase().replace(/-(\w)/g, ((e, t) => t.toUpperCase())) : t) {
            case "value":
                ! function (e, t) {
                    if ("radio" === e.type) void 0 === e.attributes.value && (e.value = t), window.fromModel && (e.checked = Hm(e.value, t));
                    else if ("checkbox" === e.type) Number.isInteger(t) ? e.value = t : Number.isInteger(t) || Array.isArray(t) || "boolean" == typeof t || [null, void 0].includes(t) ? Array.isArray(t) ? e.checked = t.some((t => Hm(t, e.value))) : e.checked = !!t : e.value = String(t);
                    else if ("SELECT" === e.tagName) ! function (e, t) {
                        const i = [].concat(t).map((e => e + ""));
                        Array.from(e.options).forEach((e => {
                            e.selected = i.includes(e.value)
                        }))
                    }(e, t);
                    else {
                        if (e.value === t) return;
                        e.value = t
                    }
                }(e, i);
                break;
            case "style":
                ! function (e, t) {
                    e._x_undoAddedStyles && e._x_undoAddedStyles();
                    e._x_undoAddedStyles = _m(e, t)
                }(e, i);
                break;
            case "class":
                ! function (e, t) {
                    e._x_undoAddedClasses && e._x_undoAddedClasses();
                    e._x_undoAddedClasses = Tm(e, t)
                }(e, i);
                break;
            case "selected":
            case "checked":
                ! function (e, t, i) {
                    Om(e, t, i),
                        function (e, t, i) {
                            e[t] !== i && (e[t] = i)
                        }(e, t, i)
                }(e, t, i);
                break;
            default:
                Om(e, t, i)
        }
    }

    function Om(e, t, i) {
        [null, void 0, !1].includes(i) && function (e) {
            return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(e)
        }(t) ? e.removeAttribute(t) : (Fm(t) && (i = t), function (e, t, i) {
            e.getAttribute(t) != i && e.setAttribute(t, i)
        }(e, t, i))
    }

    function Hm(e, t) {
        return e == t
    }

    function Fm(e) {
        return ["disabled", "checked", "required", "readonly", "hidden", "open", "selected", "autofocus", "itemscope", "multiple", "novalidate", "allowfullscreen", "allowpaymentrequest", "formnovalidate", "autoplay", "controls", "loop", "muted", "playsinline", "default", "ismap", "reversed", "async", "defer", "nomodule"].includes(e)
    }

    function Bm(e, t, i) {
        let s = e.getAttribute(t);
        return null === s ? "function" == typeof i ? i() : i : "" === s || (Fm(t) ? !![t, "true"].includes(s) : s)
    }

    function Wm(e, t) {
        var i;
        return function () {
            var s = this,
                r = arguments,
                n = function () {
                    i = null, e.apply(s, r)
                };
            clearTimeout(i), i = setTimeout(n, t)
        }
    }

    function Nm(e, t) {
        let i;
        return function () {
            let s = this,
                r = arguments;
            i || (e.apply(s, r), i = !0, setTimeout((() => i = !1), t))
        }
    }
    var Rm = {},
        jm = !1;
    var zm = {};

    function Vm(e, t, i) {
        let s = [];
        for (; s.length;) s.pop()();
        let r = Object.entries(t).map((([e, t]) => ({
            name: e,
            value: t
        }))),
            n = Up(r);
        r = r.map((e => n.find((t => t.name === e.name)) ? {
            name: `x-bind:${e.name}`,
            value: `"${e.value}"`
        } : e)), Vp(e, r, i).map((e => {
            s.push(e.runCleanups), e()
        }))
    }
    var Um = {};
    var Gm = {
        get reactive() {
            return Uu
        },
        get release() {
            return Ju
        },
        get effect() {
            return Gu
        },
        get raw() {
            return Qu
        },
        version: "3.12.3",
        flushAndStopDeferringMutations: function () {
            vp = !1, wp(bp), bp = []
        },
        dontAutoEvaluateFunctions: Mp,
        disableEffectScheduling: function (e) {
            rp = !1, e(), rp = !0
        },
        startObservingMutations: pp,
        stopObservingMutations: mp,
        setReactivityEngine: function (e) {
            Uu = e.reactive, Ju = e.release, Gu = t => e.effect(t, {
                scheduler: e => {
                    rp ? tp(e) : e()
                }
            }), Qu = e.raw
        },
        closestDataStack: Lp,
        skipDuringClone: Mm,
        onlyDuringClone: function (e) {
            return (...t) => Im && e(...t)
        },
        addRootSelector: mm,
        addInitSelector: fm,
        addScopeToNode: Ep,
        deferMutations: function () {
            vp = !0
        },
        mapAttributes: em,
        evaluateLater: Op,
        interceptInit: function (e) {
            vm.push(e)
        },
        setEvaluator: function (e) {
            Hp = e
        },
        mergeProxies: kp,
        extractProp: function (e, t, i, s = !0) {
            if (e._x_bindings && void 0 !== e._x_bindings[t]) return e._x_bindings[t];
            if (e._x_inlineBindings && void 0 !== e._x_inlineBindings[t]) {
                let i = e._x_inlineBindings[t];
                return i.extract = s, Mp((() => Dp(e, i.expression)))
            }
            return Bm(e, t, i)
        },
        findClosest: ym,
        closestRoot: gm,
        destroyTree: wm,
        interceptor: xp,
        transition: Pm,
        setStyles: _m,
        mutateDom: yp,
        directive: zp,
        throttle: Nm,
        debounce: Wm,
        evaluate: Dp,
        initTree: bm,
        nextTick: Lm,
        prefixed: Rp,
        prefix: function (e) {
            Np = e
        },
        plugin: function (e) {
            (Array.isArray(e) ? e : [e]).forEach((e => e(Gm)))
        },
        magic: qp,
        store: function (e, t) {
            if (jm || (Rm = Uu(Rm), jm = !0), void 0 === t) return Rm[e];
            Rm[e] = t, "object" == typeof t && null !== t && t.hasOwnProperty("init") && "function" == typeof t.init && Rm[e].init(), Tp(Rm[e])
        },
        start: function () {
            var e;
            cm && lm("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."), cm = !0, document.body || lm("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"), om(document, "alpine:init"), om(document, "alpine:initializing"), pp(), e = e => bm(e, am), lp.push(e), cp((e => wm(e))),
                function (e) {
                    op.push(e)
                }(((e, t) => {
                    Vp(e, t).forEach((e => e()))
                })), Array.from(document.querySelectorAll(pm())).filter((e => !gm(e.parentElement, !0))).forEach((e => {
                    bm(e)
                })), om(document, "alpine:initialized")
        },
        clone: function (e, t) {
            t._x_dataStack || (t._x_dataStack = e._x_dataStack), Im = !0,
                function (e) {
                    let t = Gu;
                    np(((e, i) => {
                        let s = t(e);
                        return Ju(s), () => { }
                    })), e(), np(t)
                }((() => {
                    ! function (e) {
                        let t = !1;
                        bm(e, ((e, i) => {
                            am(e, ((e, s) => {
                                if (t && function (e) {
                                    return um().some((t => e.matches(t)))
                                }(e)) return s();
                                t = !0, i(e, s)
                            }))
                        }))
                    }(t)
                })), Im = !1
        },
        bound: function (e, t, i) {
            return e._x_bindings && void 0 !== e._x_bindings[t] ? e._x_bindings[t] : Bm(e, t, i)
        },
        $data: Sp,
        walk: am,
        data: function (e, t) {
            Um[e] = t
        },
        bind: function (e, t) {
            let i = "function" != typeof t ? () => t : t;
            e instanceof Element ? Vm(e, i()) : zm[e] = i
        }
    };

    function Jm(e, t) {
        const i = Object.create(null),
            s = e.split(",");
        for (let e = 0; e < s.length; e++) i[s[e]] = !0;
        return t ? e => !!i[e.toLowerCase()] : e => !!i[e]
    }
    var Qm = Object.freeze({});
    Object.freeze([]);
    var Ym, Km = Object.assign,
        Xm = Object.prototype.hasOwnProperty,
        Zm = (e, t) => Xm.call(e, t),
        ef = Array.isArray,
        tf = e => "[object Map]" === of(e),
        sf = e => "symbol" == typeof e,
        rf = e => null !== e && "object" == typeof e,
        nf = Object.prototype.toString,
        of = e => nf.call(e),
        af = e => of(e).slice(8, -1),
        lf = e => "string" == typeof e && "NaN" !== e && "-" !== e[0] && "" + parseInt(e, 10) === e,
        cf = (e => {
            const t = Object.create(null);
            return i => t[i] || (t[i] = e(i))
        })((e => e.charAt(0).toUpperCase() + e.slice(1))),
        hf = (e, t) => e !== t && (e == e || t == t),
        df = new WeakMap,
        uf = [],
        pf = Symbol("iterate"),
        mf = Symbol("Map key iterate");
    var ff = 0;

    function gf(e) {
        const {
            deps: t
        } = e;
        if (t.length) {
            for (let i = 0; i < t.length; i++) t[i].delete(e);
            t.length = 0
        }
    }
    var yf = !0,
        vf = [];

    function bf() {
        const e = vf.pop();
        yf = void 0 === e || e
    }

    function wf(e, t, i) {
        if (!yf || void 0 === Ym) return;
        let s = df.get(e);
        s || df.set(e, s = new Map);
        let r = s.get(i);
        r || s.set(i, r = new Set), r.has(Ym) || (r.add(Ym), Ym.deps.push(r), Ym.options.onTrack && Ym.options.onTrack({
            effect: Ym,
            target: e,
            type: t,
            key: i
        }))
    }

    function Sf(e, t, i, s, r, n) {
        const o = df.get(e);
        if (!o) return;
        const a = new Set,
            l = e => {
                e && e.forEach((e => {
                    (e !== Ym || e.allowRecurse) && a.add(e)
                }))
            };
        if ("clear" === t) o.forEach(l);
        else if ("length" === i && ef(e)) o.forEach(((e, t) => {
            ("length" === t || t >= s) && l(e)
        }));
        else switch (void 0 !== i && l(o.get(i)), t) {
            case "add":
                ef(e) ? lf(i) && l(o.get("length")) : (l(o.get(pf)), tf(e) && l(o.get(mf)));
                break;
            case "delete":
                ef(e) || (l(o.get(pf)), tf(e) && l(o.get(mf)));
                break;
            case "set":
                tf(e) && l(o.get(pf))
        }
        a.forEach((o => {
            o.options.onTrigger && o.options.onTrigger({
                effect: o,
                target: e,
                key: i,
                type: t,
                newValue: s,
                oldValue: r,
                oldTarget: n
            }), o.options.scheduler ? o.options.scheduler(o) : o()
        }))
    }
    var Ef = Jm("__proto__,__v_isRef,__isVue"),
        Lf = new Set(Object.getOwnPropertyNames(Symbol).map((e => Symbol[e])).filter(sf)),
        kf = qf(),
        Tf = qf(!1, !0),
        xf = qf(!0),
        _f = qf(!0, !0),
        Af = {};

    function qf(e = !1, t = !1) {
        return function (i, s, r) {
            if ("__v_isReactive" === s) return !e;
            if ("__v_isReadonly" === s) return e;
            if ("__v_raw" === s && r === (e ? t ? rg : sg : t ? ig : tg).get(i)) return i;
            const n = ef(i);
            if (!e && n && Zm(Af, s)) return Reflect.get(Af, s, r);
            const o = Reflect.get(i, s, r);
            if (sf(s) ? Lf.has(s) : Ef(s)) return o;
            if (e || wf(i, "get", s), t) return o;
            if (cg(o)) {
                return !n || !lf(s) ? o.value : o
            }
            return rf(o) ? e ? og(o) : ng(o) : o
        }
    }

    function Cf(e = !1) {
        return function (t, i, s, r) {
            let n = t[i];
            if (!e && (s = lg(s), n = lg(n), !ef(t) && cg(n) && !cg(s))) return n.value = s, !0;
            const o = ef(t) && lf(i) ? Number(i) < t.length : Zm(t, i),
                a = Reflect.set(t, i, s, r);
            return t === lg(r) && (o ? hf(s, n) && Sf(t, "set", i, s, n) : Sf(t, "add", i, s)), a
        }
    } ["includes", "indexOf", "lastIndexOf"].forEach((e => {
        const t = Array.prototype[e];
        Af[e] = function (...e) {
            const i = lg(this);
            for (let e = 0, t = this.length; e < t; e++) wf(i, "get", e + "");
            const s = t.apply(i, e);
            return -1 === s || !1 === s ? t.apply(i, e.map(lg)) : s
        }
    })), ["push", "pop", "shift", "unshift", "splice"].forEach((e => {
        const t = Array.prototype[e];
        Af[e] = function (...e) {
            vf.push(yf), yf = !1;
            const i = t.apply(this, e);
            return bf(), i
        }
    }));
    var Pf = {
        get: kf,
        set: Cf(),
        deleteProperty: function (e, t) {
            const i = Zm(e, t),
                s = e[t],
                r = Reflect.deleteProperty(e, t);
            return r && i && Sf(e, "delete", t, void 0, s), r
        },
        has: function (e, t) {
            const i = Reflect.has(e, t);
            return sf(t) && Lf.has(t) || wf(e, "has", t), i
        },
        ownKeys: function (e) {
            return wf(e, "iterate", ef(e) ? "length" : pf), Reflect.ownKeys(e)
        }
    },
        $f = {
            get: xf,
            set: (e, t) => (console.warn(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0),
            deleteProperty: (e, t) => (console.warn(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0)
        };
    Km({}, Pf, {
        get: Tf,
        set: Cf(!0)
    }), Km({}, $f, {
        get: _f
    });
    var If = e => rf(e) ? ng(e) : e,
        Mf = e => rf(e) ? og(e) : e,
        Df = e => e,
        Of = e => Reflect.getPrototypeOf(e);

    function Hf(e, t, i = !1, s = !1) {
        const r = lg(e = e.__v_raw),
            n = lg(t);
        t !== n && !i && wf(r, "get", t), !i && wf(r, "get", n);
        const {
            has: o
        } = Of(r), a = s ? Df : i ? Mf : If;
        return o.call(r, t) ? a(e.get(t)) : o.call(r, n) ? a(e.get(n)) : void (e !== r && e.get(t))
    }

    function Ff(e, t = !1) {
        const i = this.__v_raw,
            s = lg(i),
            r = lg(e);
        return e !== r && !t && wf(s, "has", e), !t && wf(s, "has", r), e === r ? i.has(e) : i.has(e) || i.has(r)
    }

    function Bf(e, t = !1) {
        return e = e.__v_raw, !t && wf(lg(e), "iterate", pf), Reflect.get(e, "size", e)
    }

    function Wf(e) {
        e = lg(e);
        const t = lg(this);
        return Of(t).has.call(t, e) || (t.add(e), Sf(t, "add", e, e)), this
    }

    function Nf(e, t) {
        t = lg(t);
        const i = lg(this),
            {
                has: s,
                get: r
            } = Of(i);
        let n = s.call(i, e);
        n ? eg(i, s, e) : (e = lg(e), n = s.call(i, e));
        const o = r.call(i, e);
        return i.set(e, t), n ? hf(t, o) && Sf(i, "set", e, t, o) : Sf(i, "add", e, t), this
    }

    function Rf(e) {
        const t = lg(this),
            {
                has: i,
                get: s
            } = Of(t);
        let r = i.call(t, e);
        r ? eg(t, i, e) : (e = lg(e), r = i.call(t, e));
        const n = s ? s.call(t, e) : void 0,
            o = t.delete(e);
        return r && Sf(t, "delete", e, void 0, n), o
    }

    function jf() {
        const e = lg(this),
            t = 0 !== e.size,
            i = tf(e) ? new Map(e) : new Set(e),
            s = e.clear();
        return t && Sf(e, "clear", void 0, void 0, i), s
    }

    function zf(e, t) {
        return function (i, s) {
            const r = this,
                n = r.__v_raw,
                o = lg(n),
                a = t ? Df : e ? Mf : If;
            return !e && wf(o, "iterate", pf), n.forEach(((e, t) => i.call(s, a(e), a(t), r)))
        }
    }

    function Vf(e, t, i) {
        return function (...s) {
            const r = this.__v_raw,
                n = lg(r),
                o = tf(n),
                a = "entries" === e || e === Symbol.iterator && o,
                l = "keys" === e && o,
                c = r[e](...s),
                h = i ? Df : t ? Mf : If;
            return !t && wf(n, "iterate", l ? mf : pf), {
                next() {
                    const {
                        value: e,
                        done: t
                    } = c.next();
                    return t ? {
                        value: e,
                        done: t
                    } : {
                        value: a ? [h(e[0]), h(e[1])] : h(e),
                        done: t
                    }
                },
                [Symbol.iterator]() {
                    return this
                }
            }
        }
    }

    function Uf(e) {
        return function (...t) {
            {
                const i = t[0] ? `on key "${t[0]}" ` : "";
                console.warn(`${cf(e)} operation ${i}failed: target is readonly.`, lg(this))
            }
            return "delete" !== e && this
        }
    }
    var Gf = {
        get(e) {
            return Hf(this, e)
        },
        get size() {
            return Bf(this)
        },
        has: Ff,
        add: Wf,
        set: Nf,
        delete: Rf,
        clear: jf,
        forEach: zf(!1, !1)
    },
        Jf = {
            get(e) {
                return Hf(this, e, !1, !0)
            },
            get size() {
                return Bf(this)
            },
            has: Ff,
            add: Wf,
            set: Nf,
            delete: Rf,
            clear: jf,
            forEach: zf(!1, !0)
        },
        Qf = {
            get(e) {
                return Hf(this, e, !0)
            },
            get size() {
                return Bf(this, !0)
            },
            has(e) {
                return Ff.call(this, e, !0)
            },
            add: Uf("add"),
            set: Uf("set"),
            delete: Uf("delete"),
            clear: Uf("clear"),
            forEach: zf(!0, !1)
        },
        Yf = {
            get(e) {
                return Hf(this, e, !0, !0)
            },
            get size() {
                return Bf(this, !0)
            },
            has(e) {
                return Ff.call(this, e, !0)
            },
            add: Uf("add"),
            set: Uf("set"),
            delete: Uf("delete"),
            clear: Uf("clear"),
            forEach: zf(!0, !0)
        };

    function Kf(e, t) {
        const i = t ? e ? Yf : Jf : e ? Qf : Gf;
        return (t, s, r) => "__v_isReactive" === s ? !e : "__v_isReadonly" === s ? e : "__v_raw" === s ? t : Reflect.get(Zm(i, s) && s in t ? i : t, s, r)
    } ["keys", "values", "entries", Symbol.iterator].forEach((e => {
        Gf[e] = Vf(e, !1, !1), Qf[e] = Vf(e, !0, !1), Jf[e] = Vf(e, !1, !0), Yf[e] = Vf(e, !0, !0)
    }));
    var Xf = {
        get: Kf(!1, !1)
    },
        Zf = {
            get: Kf(!0, !1)
        };

    function eg(e, t, i) {
        const s = lg(i);
        if (s !== i && t.call(e, s)) {
            const t = af(e);
            console.warn(`Reactive ${t} contains both the raw and reactive versions of the same object${"Map" === t ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`)
        }
    }
    var tg = new WeakMap,
        ig = new WeakMap,
        sg = new WeakMap,
        rg = new WeakMap;

    function ng(e) {
        return e && e.__v_isReadonly ? e : ag(e, !1, Pf, Xf, tg)
    }

    function og(e) {
        return ag(e, !0, $f, Zf, sg)
    }

    function ag(e, t, i, s, r) {
        if (!rf(e)) return console.warn(`value cannot be made reactive: ${String(e)}`), e;
        if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
        const n = r.get(e);
        if (n) return n;
        const o = (a = e).__v_skip || !Object.isExtensible(a) ? 0 : function (e) {
            switch (e) {
                case "Object":
                case "Array":
                    return 1;
                case "Map":
                case "Set":
                case "WeakMap":
                case "WeakSet":
                    return 2;
                default:
                    return 0
            }
        }(af(a));
        var a;
        if (0 === o) return e;
        const l = new Proxy(e, 2 === o ? s : i);
        return r.set(e, l), l
    }

    function lg(e) {
        return e && lg(e.__v_raw) || e
    }

    function cg(e) {
        return Boolean(e && !0 === e.__v_isRef)
    }
    qp("nextTick", (() => Lm)), qp("dispatch", (e => om.bind(om, e))), qp("watch", ((e, {
        evaluateLater: t,
        effect: i
    }) => (s, r) => {
        let n, o = t(s),
            a = !0,
            l = i((() => o((e => {
                JSON.stringify(e), a ? n = e : queueMicrotask((() => {
                    r(e, n), n = e
                })), a = !1
            }))));
        e._x_effects.delete(l)
    })), qp("store", (function () {
        return Rm
    })), qp("data", (e => Sp(e))), qp("root", (e => gm(e))), qp("refs", (e => (e._x_refs_proxy || (e._x_refs_proxy = kp(function (e) {
        let t = [],
            i = e;
        for (; i;) i._x_refs && t.push(i._x_refs), i = i.parentNode;
        return t
    }(e))), e._x_refs_proxy)));
    var hg = {};

    function dg(e) {
        return hg[e] || (hg[e] = 0), ++hg[e]
    }

    function ug(e, t, i) {
        qp(t, (t => lm(`You can't use [$${directiveName}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`, t)))
    }
    qp("id", (e => (t, i = null) => {
        let s = function (e, t) {
            return ym(e, (e => {
                if (e._x_ids && e._x_ids[t]) return !0
            }))
        }(e, t),
            r = s ? s._x_ids[t] : dg(t);
        return i ? `${t}-${r}-${i}` : `${t}-${r}`
    })), qp("el", (e => e)), ug("Focus", "focus", "focus"), ug("Persist", "persist", "persist"), zp("modelable", ((e, {
        expression: t
    }, {
        effect: i,
        evaluateLater: s,
        cleanup: r
    }) => {
        let n = s(t),
            o = () => {
                let e;
                return n((t => e = t)), e
            },
            a = s(`${t} = __placeholder`),
            l = e => a((() => { }), {
                scope: {
                    __placeholder: e
                }
            }),
            c = o();
        l(c), queueMicrotask((() => {
            if (!e._x_model) return;
            e._x_removeModelListeners.default();
            let t = e._x_model.get,
                i = e._x_model.set,
                s = function ({
                    get: e,
                    set: t
                }, {
                    get: i,
                    set: s
                }) {
                    let r, n, o = !0,
                        a = Gu((() => {
                            let a, l;
                            o ? (a = e(), s(a), l = i(), o = !1) : (a = e(), l = i(), n = JSON.stringify(a), JSON.stringify(l), n !== r ? (l = i(), s(a), l = a) : (t(l), a = l)), r = JSON.stringify(a), JSON.stringify(l)
                        }));
                    return () => {
                        Ju(a)
                    }
                }({
                    get: () => t(),
                    set(e) {
                        i(e)
                    }
                }, {
                    get: () => o(),
                    set(e) {
                        l(e)
                    }
                });
            r(s)
        }))
    }));
    var pg = document.createElement("div");
    zp("teleport", ((e, {
        modifiers: t,
        expression: i
    }, {
        cleanup: s
    }) => {
        "template" !== e.tagName.toLowerCase() && lm("x-teleport can only be used on a <template> tag", e);
        let r = Mm((() => document.querySelector(i)), (() => pg))();
        r || lm(`Cannot find x-teleport element for selector: "${i}"`);
        let n = e.content.cloneNode(!0).firstElementChild;
        e._x_teleport = n, n._x_teleportBack = e, e._x_forwardEvents && e._x_forwardEvents.forEach((t => {
            n.addEventListener(t, (t => {
                t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t))
            }))
        })), Ep(n, {}, e), yp((() => {
            t.includes("prepend") ? r.parentNode.insertBefore(n, r) : t.includes("append") ? r.parentNode.insertBefore(n, r.nextSibling) : r.appendChild(n), bm(n), n._x_ignore = !0
        })), s((() => n.remove()))
    }));
    var mg = () => { };

    function fg(e, t, i, s) {
        let r = e,
            n = e => s(e),
            o = {},
            a = (e, t) => i => t(e, i);
        if (i.includes("dot") && (t = t.replace(/-/g, ".")), i.includes("camel") && (t = function (e) {
            return e.toLowerCase().replace(/-(\w)/g, ((e, t) => t.toUpperCase()))
        }(t)), i.includes("passive") && (o.passive = !0), i.includes("capture") && (o.capture = !0), i.includes("window") && (r = window), i.includes("document") && (r = document), i.includes("debounce")) {
            let e = i[i.indexOf("debounce") + 1] || "invalid-wait",
                t = gg(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
            n = Wm(n, t)
        }
        if (i.includes("throttle")) {
            let e = i[i.indexOf("throttle") + 1] || "invalid-wait",
                t = gg(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
            n = Nm(n, t)
        }
        return i.includes("prevent") && (n = a(n, ((e, t) => {
            t.preventDefault(), e(t)
        }))), i.includes("stop") && (n = a(n, ((e, t) => {
            t.stopPropagation(), e(t)
        }))), i.includes("self") && (n = a(n, ((t, i) => {
            i.target === e && t(i)
        }))), (i.includes("away") || i.includes("outside")) && (r = document, n = a(n, ((t, i) => {
            e.contains(i.target) || !1 !== i.target.isConnected && (e.offsetWidth < 1 && e.offsetHeight < 1 || !1 !== e._x_isShown && t(i))
        }))), i.includes("once") && (n = a(n, ((e, i) => {
            e(i), r.removeEventListener(t, n, o)
        }))), n = a(n, ((e, s) => {
            (function (e) {
                return ["keydown", "keyup"].includes(e)
            })(t) && function (e, t) {
                let i = t.filter((e => !["window", "document", "prevent", "stop", "once", "capture"].includes(e)));
                if (i.includes("debounce")) {
                    let e = i.indexOf("debounce");
                    i.splice(e, gg((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1)
                }
                if (i.includes("throttle")) {
                    let e = i.indexOf("throttle");
                    i.splice(e, gg((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1)
                }
                if (0 === i.length) return !1;
                if (1 === i.length && yg(e.key).includes(i[0])) return !1;
                const s = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter((e => i.includes(e)));
                if (i = i.filter((e => !s.includes(e))), s.length > 0) {
                    if (s.filter((t => ("cmd" !== t && "super" !== t || (t = "meta"), e[`${t}Key`]))).length === s.length && yg(e.key).includes(i[0])) return !1
                }
                return !0
            }(s, i) || e(s)
        })), r.addEventListener(t, n, o), () => {
            r.removeEventListener(t, n, o)
        }
    }

    function gg(e) {
        return !Array.isArray(e) && !isNaN(e)
    }

    function yg(e) {
        if (!e) return [];
        var t;
        e = [" ", "_"].includes(t = e) ? t : t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
        let i = {
            ctrl: "control",
            slash: "/",
            space: " ",
            spacebar: " ",
            cmd: "meta",
            esc: "escape",
            up: "arrow-up",
            down: "arrow-down",
            left: "arrow-left",
            right: "arrow-right",
            period: ".",
            equal: "=",
            minus: "-",
            underscore: "_"
        };
        return i[e] = e, Object.keys(i).map((t => {
            if (i[t] === e) return t
        })).filter((e => e))
    }

    function vg(e) {
        let t = e ? parseFloat(e) : null;
        return i = t, Array.isArray(i) || isNaN(i) ? e : t;
        var i
    }

    function bg(e) {
        return null !== e && "object" == typeof e && "function" == typeof e.get && "function" == typeof e.set
    }
    mg.inline = (e, {
        modifiers: t
    }, {
        cleanup: i
    }) => {
        t.includes("self") ? e._x_ignoreSelf = !0 : e._x_ignore = !0, i((() => {
            t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore
        }))
    }, zp("ignore", mg), zp("effect", ((e, {
        expression: t
    }, {
        effect: i
    }) => i(Op(e, t)))), zp("model", ((e, {
        modifiers: t,
        expression: i
    }, {
        effect: s,
        cleanup: r
    }) => {
        let n = e;
        t.includes("parent") && (n = e.parentNode);
        let o, a = Op(n, i);
        o = "string" == typeof i ? Op(n, `${i} = __placeholder`) : "function" == typeof i && "string" == typeof i() ? Op(n, `${i()} = __placeholder`) : () => { };
        let l = () => {
            let e;
            return a((t => e = t)), bg(e) ? e.get() : e
        },
            c = e => {
                let t;
                a((e => t = e)), bg(t) ? t.set(e) : o((() => { }), {
                    scope: {
                        __placeholder: e
                    }
                })
            };
        "string" == typeof i && "radio" === e.type && yp((() => {
            e.hasAttribute("name") || e.setAttribute("name", i)
        }));
        var h = "select" === e.tagName.toLowerCase() || ["checkbox", "radio"].includes(e.type) || t.includes("lazy") ? "change" : "input";
        let d = Im ? () => { } : fg(e, h, t, (i => {
            c(function (e, t, i, s) {
                return yp((() => {
                    var r;
                    if (i instanceof CustomEvent && void 0 !== i.detail) return null !== (r = i.detail) && void 0 !== r ? r : i.target.value;
                    if ("checkbox" === e.type) {
                        if (Array.isArray(s)) {
                            let e = t.includes("number") ? vg(i.target.value) : i.target.value;
                            return i.target.checked ? s.concat([e]) : s.filter((t => !(t == e)))
                        }
                        return i.target.checked
                    }
                    if ("select" === e.tagName.toLowerCase() && e.multiple) return t.includes("number") ? Array.from(i.target.selectedOptions).map((e => vg(e.value || e.text))) : Array.from(i.target.selectedOptions).map((e => e.value || e.text));
                    {
                        let e = i.target.value;
                        return t.includes("number") ? vg(e) : t.includes("trim") ? e.trim() : e
                    }
                }))
            }(e, t, i, l()))
        }));
        if (t.includes("fill") && [null, ""].includes(l()) && e.dispatchEvent(new Event(h, {})), e._x_removeModelListeners || (e._x_removeModelListeners = {}), e._x_removeModelListeners.default = d, r((() => e._x_removeModelListeners.default())), e.form) {
            let t = fg(e.form, "reset", [], (t => {
                Lm((() => e._x_model && e._x_model.set(e.value)))
            }));
            r((() => t()))
        }
        e._x_model = {
            get: () => l(),
            set(e) {
                c(e)
            }
        }, e._x_forceModelUpdate = t => {
            void 0 === (t = void 0 === t ? l() : t) && "string" == typeof i && i.match(/\./) && (t = ""), window.fromModel = !0, yp((() => Dm(e, "value", t))), delete window.fromModel
        }, s((() => {
            let i = l();
            t.includes("unintrusive") && document.activeElement.isSameNode(e) || e._x_forceModelUpdate(i)
        }))
    })), zp("cloak", (e => queueMicrotask((() => yp((() => e.removeAttribute(Rp("cloak")))))))), fm((() => `[${Rp("init")}]`)), zp("init", Mm(((e, {
        expression: t
    }, {
        evaluate: i
    }) => "string" == typeof t ? !!t.trim() && i(t, {}, !1) : i(t, {}, !1)))), zp("text", ((e, {
        expression: t
    }, {
        effect: i,
        evaluateLater: s
    }) => {
        let r = s(t);
        i((() => {
            r((t => {
                yp((() => {
                    e.textContent = t
                }))
            }))
        }))
    })), zp("html", ((e, {
        expression: t
    }, {
        effect: i,
        evaluateLater: s
    }) => {
        let r = s(t);
        i((() => {
            r((t => {
                yp((() => {
                    e.innerHTML = t, e._x_ignoreSelf = !0, bm(e), delete e._x_ignoreSelf
                }))
            }))
        }))
    })), em(Kp(":", Rp("bind:")));
    var wg = (e, {
        value: t,
        modifiers: i,
        expression: s,
        original: r
    }, {
        effect: n
    }) => {
        if (!t) {
            let t = {};
            return o = t, Object.entries(zm).forEach((([e, t]) => {
                Object.defineProperty(o, e, {
                    get: () => (...e) => t(...e)
                })
            })), void Op(e, s)((t => {
                Vm(e, t, r)
            }), {
                scope: t
            })
        }
        var o;
        if ("key" === t) return function (e, t) {
            e._x_keyExpression = t
        }(e, s);
        if (e._x_inlineBindings && e._x_inlineBindings[t] && e._x_inlineBindings[t].extract) return;
        let a = Op(e, s);
        n((() => a((r => {
            void 0 === r && "string" == typeof s && s.match(/\./) && (r = ""), yp((() => Dm(e, t, r, i)))
        }))))
    };

    function Sg(e, t, i, s) {
        let r = {};
        if (/^\[.*\]$/.test(e.item) && Array.isArray(t)) {
            e.item.replace("[", "").replace("]", "").split(",").map((e => e.trim())).forEach(((e, i) => {
                r[e] = t[i]
            }))
        } else if (/^\{.*\}$/.test(e.item) && !Array.isArray(t) && "object" == typeof t) {
            e.item.replace("{", "").replace("}", "").split(",").map((e => e.trim())).forEach((e => {
                r[e] = t[e]
            }))
        } else r[e.item] = t;
        return e.index && (r[e.index] = i), e.collection && (r[e.collection] = s), r
    }

    function Eg() { }

    function Lg(e, t, i) {
        zp(t, (s => lm(`You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`, s)))
    }
    wg.inline = (e, {
        value: t,
        modifiers: i,
        expression: s
    }) => {
        t && (e._x_inlineBindings || (e._x_inlineBindings = {}), e._x_inlineBindings[t] = {
            expression: s,
            extract: !1
        })
    }, zp("bind", wg), mm((() => `[${Rp("data")}]`)), zp("data", Mm(((e, {
        expression: t
    }, {
        cleanup: i
    }) => {
        t = "" === t ? "{}" : t;
        let s = {};
        Cp(s, e);
        let r = {};
        var n, o;
        n = r, o = s, Object.entries(Um).forEach((([e, t]) => {
            Object.defineProperty(n, e, {
                get: () => (...e) => t.bind(o)(...e),
                enumerable: !1
            })
        }));
        let a = Dp(e, t, {
            scope: r
        });
        void 0 !== a && !0 !== a || (a = {}), Cp(a, e);
        let l = Uu(a);
        Tp(l);
        let c = Ep(e, l);
        l.init && Dp(e, l.init), i((() => {
            l.destroy && Dp(e, l.destroy), c()
        }))
    }))), zp("show", ((e, {
        modifiers: t,
        expression: i
    }, {
        effect: s
    }) => {
        let r = Op(e, i);
        e._x_doHide || (e._x_doHide = () => {
            yp((() => {
                e.style.setProperty("display", "none", t.includes("important") ? "important" : void 0)
            }))
        }), e._x_doShow || (e._x_doShow = () => {
            yp((() => {
                1 === e.style.length && "none" === e.style.display ? e.removeAttribute("style") : e.style.removeProperty("display")
            }))
        });
        let n, o = () => {
            e._x_doHide(), e._x_isShown = !1
        },
            a = () => {
                e._x_doShow(), e._x_isShown = !0
            },
            l = () => setTimeout(a),
            c = Am((e => e ? a() : o()), (t => {
                "function" == typeof e._x_toggleAndCascadeWithTransitions ? e._x_toggleAndCascadeWithTransitions(e, t, a, o) : t ? l() : o()
            })),
            h = !0;
        s((() => r((e => {
            (h || e !== n) && (t.includes("immediate") && (e ? l() : o()), c(e), n = e, h = !1)
        }))))
    })), zp("for", ((e, {
        expression: t
    }, {
        effect: i,
        cleanup: s
    }) => {
        let r = function (e) {
            let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
                i = /^\s*\(|\)\s*$/g,
                s = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
                r = e.match(s);
            if (!r) return;
            let n = {};
            n.items = r[2].trim();
            let o = r[1].replace(i, "").trim(),
                a = o.match(t);
            a ? (n.item = o.replace(t, "").trim(), n.index = a[1].trim(), a[2] && (n.collection = a[2].trim())) : n.item = o;
            return n
        }(t),
            n = Op(e, r.items),
            o = Op(e, e._x_keyExpression || "index");
        e._x_prevKeys = [], e._x_lookup = {}, i((() => function (e, t, i, s) {
            let r = e => "object" == typeof e && !Array.isArray(e),
                n = e;
            i((i => {
                var o;
                o = i, !Array.isArray(o) && !isNaN(o) && i >= 0 && (i = Array.from(Array(i).keys(), (e => e + 1))), void 0 === i && (i = []);
                let a = e._x_lookup,
                    l = e._x_prevKeys,
                    c = [],
                    h = [];
                if (r(i)) i = Object.entries(i).map((([e, r]) => {
                    let n = Sg(t, r, e, i);
                    s((e => h.push(e)), {
                        scope: {
                            index: e,
                            ...n
                        }
                    }), c.push(n)
                }));
                else
                    for (let e = 0; e < i.length; e++) {
                        let r = Sg(t, i[e], e, i);
                        s((e => h.push(e)), {
                            scope: {
                                index: e,
                                ...r
                            }
                        }), c.push(r)
                    }
                let d = [],
                    u = [],
                    p = [],
                    m = [];
                for (let e = 0; e < l.length; e++) {
                    let t = l[e]; - 1 === h.indexOf(t) && p.push(t)
                }
                l = l.filter((e => !p.includes(e)));
                let f = "template";
                for (let e = 0; e < h.length; e++) {
                    let t = h[e],
                        i = l.indexOf(t);
                    if (-1 === i) l.splice(e, 0, t), d.push([f, e]);
                    else if (i !== e) {
                        let t = l.splice(e, 1)[0],
                            s = l.splice(i - 1, 1)[0];
                        l.splice(e, 0, s), l.splice(i, 0, t), u.push([t, s])
                    } else m.push(t);
                    f = t
                }
                for (let e = 0; e < p.length; e++) {
                    let t = p[e];
                    a[t]._x_effects && a[t]._x_effects.forEach(ip), a[t].remove(), a[t] = null, delete a[t]
                }
                for (let e = 0; e < u.length; e++) {
                    let [t, i] = u[e], s = a[t], r = a[i], o = document.createElement("div");
                    yp((() => {
                        r || lm('x-for ":key" is undefined or invalid', n), r.after(o), s.after(r), r._x_currentIfEl && r.after(r._x_currentIfEl), o.before(s), s._x_currentIfEl && s.after(s._x_currentIfEl), o.remove()
                    })), r._x_refreshXForScope(c[h.indexOf(i)])
                }
                for (let e = 0; e < d.length; e++) {
                    let [t, i] = d[e], s = "template" === t ? n : a[t];
                    s._x_currentIfEl && (s = s._x_currentIfEl);
                    let r = c[i],
                        o = h[i],
                        l = document.importNode(n.content, !0).firstElementChild,
                        u = Uu(r);
                    Ep(l, u, n), l._x_refreshXForScope = e => {
                        Object.entries(e).forEach((([e, t]) => {
                            u[e] = t
                        }))
                    }, yp((() => {
                        s.after(l), bm(l)
                    })), "object" == typeof o && lm("x-for key cannot be an object, it must be a string or an integer", n), a[o] = l
                }
                for (let e = 0; e < m.length; e++) a[m[e]]._x_refreshXForScope(c[h.indexOf(m[e])]);
                n._x_prevKeys = h
            }))
        }(e, r, n, o))), s((() => {
            Object.values(e._x_lookup).forEach((e => e.remove())), delete e._x_prevKeys, delete e._x_lookup
        }))
    })), Eg.inline = (e, {
        expression: t
    }, {
        cleanup: i
    }) => {
        let s = gm(e);
        s._x_refs || (s._x_refs = {}), s._x_refs[t] = e, i((() => delete s._x_refs[t]))
    }, zp("ref", Eg), zp("if", ((e, {
        expression: t
    }, {
        effect: i,
        cleanup: s
    }) => {
        let r = Op(e, t);
        i((() => r((t => {
            t ? (() => {
                if (e._x_currentIfEl) return e._x_currentIfEl;
                let t = e.content.cloneNode(!0).firstElementChild;
                Ep(t, {}, e), yp((() => {
                    e.after(t), bm(t)
                })), e._x_currentIfEl = t, e._x_undoIf = () => {
                    am(t, (e => {
                        e._x_effects && e._x_effects.forEach(ip)
                    })), t.remove(), delete e._x_currentIfEl
                }
            })() : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf)
        })))), s((() => e._x_undoIf && e._x_undoIf()))
    })), zp("id", ((e, {
        expression: t
    }, {
        evaluate: i
    }) => {
        i(t).forEach((t => function (e, t) {
            e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = dg(t))
        }(e, t)))
    })), em(Kp("@", Rp("on:"))), zp("on", Mm(((e, {
        value: t,
        modifiers: i,
        expression: s
    }, {
        cleanup: r
    }) => {
        let n = s ? Op(e, s) : () => { };
        "template" === e.tagName.toLowerCase() && (e._x_forwardEvents || (e._x_forwardEvents = []), e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
        let o = fg(e, t, i, (e => {
            n((() => { }), {
                scope: {
                    $event: e
                },
                params: [e]
            })
        }));
        r((() => o()))
    }))), Lg("Collapse", "collapse", "collapse"), Lg("Intersect", "intersect", "intersect"), Lg("Focus", "trap", "focus"), Lg("Mask", "mask", "mask"), Gm.setEvaluator(Fp), Gm.setReactivityEngine({
        reactive: ng,
        effect: function (e, t = Qm) {
            (function (e) {
                return e && !0 === e._isEffect
            })(e) && (e = e.raw);
            const i = function (e, t) {
                const i = function () {
                    if (!i.active) return e();
                    if (!uf.includes(i)) {
                        gf(i);
                        try {
                            return vf.push(yf), yf = !0, uf.push(i), Ym = i, e()
                        } finally {
                            uf.pop(), bf(), Ym = uf[uf.length - 1]
                        }
                    }
                };
                return i.id = ff++, i.allowRecurse = !!t.allowRecurse, i._isEffect = !0, i.active = !0, i.raw = e, i.deps = [], i.options = t, i
            }(e, t);
            return t.lazy || i(), i
        },
        release: function (e) {
            e.active && (gf(e), e.options.onStop && e.options.onStop(), e.active = !1)
        },
        raw: lg
    });
    var kg = Gm;
    const Tg = "[data-announcement-bar]",
        xg = "[data-ticker-frame]",
        _g = "[data-ticker-scale]",
        Ag = "[data-ticker-text]",
        qg = "is-selected",
        Cg = "ticker--animated";
    const Pg = 0,
        $g = 1,
        Ig = 2,
        Mg = 3,
        Dg = "[data-product-add-popdown-wrapper]",
        Og = "[data-add-action-errors]",
        Hg = "[data-error-boundary]",
        Fg = "[data-error-display]",
        Bg = "[data-quickview-modal]",
        Wg = "[data-cart-page-upsell-wrapper]",
        Ng = '[data-section-type="cart"]',
        Rg = '[data-ajax-disable="true"]',
        jg = {
            durationAddButtonDisable: 3500,
            hideErrorTime: 5e3
        };
    const zg = 0,
        Vg = 1,
        Ug = "data-quickview-holder",
        Gg = "[data-product-quickview-ajax]",
        Jg = "[data-quickview-modal]",
        Qg = "[data-drawer-scrolls]",
        Yg = "[data-quickview-modal-template]",
        Kg = "[data-quickview-head]",
        Xg = "[data-quickview-form-area]",
        Zg = "[data-toggle-button]",
        ey = "[data-media-slide]",
        ty = "[data-media-id]",
        iy = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        sy = "hide",
        ry = "is-active",
        ny = "is-expanded",
        oy = "loading",
        ay = 250,
        ly = 400;

    function cy() {
        return {
            isOpen: !1,
            get isClosed() {
                return !this.isOpen
            },
            toggle() {
                if (this.isOpen) return this.close();
                this.open()
            },
            open() {
                this.isOpen = !0
            },
            close() {
                this.isOpen && (this.isOpen = !1)
            }
        }
    }
    const hy = '[role="tablist"]',
        dy = '[role="tab"]';
    kg.data("announcement", (function () {
        new ud(this.$el)
    })), kg.data("announcementSlider", (function (e = 4e3) {
        return {
            options: {
                initialIndex: 0,
                autoPlay: e,
                contain: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                wrapAround: !0,
                groupCells: !1,
                cellAlign: "left",
                freeScroll: !1,
                prevNextButtons: !0,
                draggable: !0,
                rightToLeft: window.isRTL,
                on: {
                    ready: () => {
                        setTimeout((() => {
                            this.$el.dispatchEvent(new CustomEvent("theme:announcement:loaded", {
                                bubbles: !0,
                                detail: {
                                    slider: this.$el
                                }
                            }))
                        }), 50)
                    }
                }
            },
            flkty: null,
            desktopSlides: [],
            mobileSlides: [],
            isMobileSliderInitialized: !1,
            init() {
                this.$nextTick((() => {
                    this.$el.children.length < 2 || (this.flkty = new s(this.$el, this.options), this.removeDeviceSpecificSlides(), Ae.onChange((() => {
                        this.updateDeviceSpecificSlides()
                    })), this.scrollEvent = () => this.scrollEvents(), this.resizeEvent = () => this.resizeEvents(), document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                }))
            },
            removeDeviceSpecificSlides() {
                this.flkty.getCellElements().forEach(((e, t) => {
                    e.classList.remove(qg), "desktop" == e.dataset.device && (this.desktopSlides.push([e, t]), Ae.isMobile() && this.flkty.remove(e)), "mobile" == e.dataset.device && (this.mobileSlides.push([e, t]), (Ae.isDesktop() || Ae.isTablet()) && this.flkty.remove(e))
                })), setTimeout((() => {
                    this.flkty.resize()
                }), 1e3), this.handleSliderAutoplay(), this.isMobileSliderInitialized = Ae.isMobile()
            },
            updateDeviceSpecificSlides() {
                (Ae.isDesktop() || Ae.isTablet()) && this.isMobileSliderInitialized && (this.desktopSlides.forEach((e => {
                    this.flkty.insert(e[0], e[1])
                })), this.mobileSlides.forEach((e => {
                    this.flkty.remove(e[0])
                }))), Ae.isMobile() && (this.isMobileSliderInitialized || (this.mobileSlides.forEach((e => {
                    this.flkty.insert(e[0], e[1])
                })), this.desktopSlides.forEach((e => {
                    this.flkty.remove(e[0])
                })))), setTimeout((() => {
                    this.flkty.resize()
                }), 1e3), this.handleSliderAutoplay(), this.isMobileSliderInitialized = Ae.isMobile()
            },
            handleSliderAutoplay() {
                var e;
                (null === (e = this.flkty) || void 0 === e ? void 0 : e.slides.length) > 1 ? this.flkty.playPlayer() : this.flkty.pausePlayer()
            },
            resizeEvents() {
                this.flkty.resize()
            },
            scrollEvents() {
                if (!this.flkty.options.autoPlay) return;
                const e = this.flkty.element,
                    t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
                window.pageYOffset > t ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer()
            },
            onBlockSelect(e) {
                const t = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
                if (!t) return;
                const i = parseInt([...t.parentNode.children].indexOf(t));
                this.flkty.selectCell(i), this.flkty.stopPlayer()
            },
            onBlockDeselect() {
                this.flkty.playPlayer()
            },
            onUnload() {
                this.flkty.options.watchCSS = !1, this.flkty.destroy()
            }
        }
    })), kg.data("announcementTicker", (function (e = {
        stopClone: !1,
        waitForSlider: !1
    }) {
        var t;
        return {
            tickerFrames: null === (t = this.$el.closest(Tg)) || void 0 === t ? void 0 : t.querySelectorAll(xg),
            init() {
                var t;
                (null == e ? void 0 : e.waitForSlider) && (null === (t = this.tickerFrames) || void 0 === t ? void 0 : t.length) > 1 ? document.addEventListener("theme:announcement:loaded", this.initTicker.bind(this)) : this.initTicker()
            },
            initTicker() {
                new Fi(this.$el, null == e ? void 0 : e.stopClone)
            },
            toggleTicker(e, t) {
                const i = this.$el.querySelector(_g),
                    s = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
                if (s && null !== s.offsetParent) {
                    if (t) {
                        const e = Number(getComputedStyle(s).getPropertyValue("--items-spacing").replace("px", "")),
                            t = -(s.offsetLeft + e);
                        i.setAttribute("data-stop", ""), i.querySelectorAll(Ag).forEach((e => {
                            e.classList.remove(Cg), e.style.transform = `translate3d(${t}px, 0, 0)`
                        }))
                    }
                    t || (i.querySelectorAll(Ag).forEach((e => {
                        e.classList.add(Cg), e.removeAttribute("style")
                    })), i.removeAttribute("data-stop"))
                }
            },
            onBlockSelect(e) {
                this.toggleTicker(e, !0)
            },
            onBlockDeselect(e) {
                this.toggleTicker(e, !1)
            }
        }
    })), kg.data("productAddButtonForm", (function (e = {}) {
        const t = {
            ...jg,
            ...e.times
        };
        return {
            state: Pg,
            error: "",
            isUpsell: !1,
            isInCartPage: !1,
            get cartPageUpsellWrapper() {
                return this.$el.closest(Wg)
            },
            get sectionTypeCart() {
                return this.$el.closest(Ng)
            },
            get form() {
                return this.isUpsell && this.isInCartPage ? this.$el.closest("form") : this.$el.querySelector("form")
            },
            get button() {
                return this.$el.querySelector("button")
            },
            get popdown() {
                return document.querySelector(Dg)
            },
            get errorDisplay() {
                let e = this.$el.querySelector(Og);
                if (!e) {
                    const t = this.$el.closest(Hg);
                    t && (e = t.querySelector(Fg))
                }
                return e || (e = this.$el.querySelector(Fg)), e
            },
            get quickViewModal() {
                return this.$el.closest(Bg)
            },
            get isInitial() {
                return this.state === Pg
            },
            get isLoading() {
                return this.state === $g
            },
            get isSuccess() {
                return this.state === Ig
            },
            get isError() {
                return this.state === Mg
            },
            get isDisabled() {
                return this.isLoading
            },
            get isAjaxDisabled() {
                return !!this.$el.closest(Rg)
            },
            get isInsideQuickViewModal() {
                return Boolean(this.quickViewModal)
            },
            handleClickAddButton(e) {
                e.preventDefault(), this.state = $g;
                const t = new FormData(this.form);
                this.addToCart(t).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this))
            },
            handleSuccess(e) {
                const i = e.data;
                this.state = Ig, this.updateHeaderTotal(), setTimeout((() => {
                    this.state = Pg
                }), t.durationAddButtonDisable), this.isInsideQuickViewModal && this.closeQuickView(), window.theme.state.cartOpen || this.isInCartPage || this.isOnCartPage ? this.reloadCart() : this.openPopdown(i)
            },
            handleError(e) {
                if (!(null == e ? void 0 : e.data)) throw e;
                if (this.state = Mg, e.data.description && "string" == typeof e.data.description ? this.error = e.data.description : e.data.message && "string" == typeof e.data.message ? this.error = e.data.message : e.data.description && "object" == typeof e.data.description ? this.error = Object.keys(e.data.description).map((t => `${t}: ${e.data.description[t]}`)).join("<br>") : this.error = "Network error: please try again", this.errorDisplay) {
                    const e = `<div class="errors">${this.error}</div>`;
                    this.errorDisplay.innerHTML = e, Wr(this.errorDisplay), setTimeout((() => {
                        Nr(this.errorDisplay)
                    }), t.hideErrorTime)
                }
            },
            addToCart(e) {
                const t = `${window.theme.routes.cart}/add.js`,
                    i = new URLSearchParams(e).toString();
                return l.post(t, i, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                })
            },
            updateHeaderTotal: () => l.get(`${window.theme.routes.cart}.js`).then((e => {
                document.dispatchEvent(new CustomEvent("theme:cart:change", {
                    detail: {
                        cart: e.data
                    },
                    bubbles: !0
                }))
            })).catch((e => {
                console.error(e)
            })),
            closeQuickView() {
                this.quickViewModal.dispatchEvent(new CustomEvent("theme:quickview:close"))
            },
            reloadCart() {
                document.dispatchEvent(new CustomEvent("theme:cart:reload", {
                    bubbles: !0
                }))
            },
            openPopdown(e) {
                this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown", {
                    detail: {
                        variant: e
                    },
                    bubbles: !0
                }))
            },
            get isInCartPage() {
                return Boolean(this.sectionTypeCart)
            },
            get isOnCartPage() {
                return Boolean(document.body.querySelector(Ng))
            },
            get isUpsell() {
                return Boolean(this.cartPageUpsellWrapper)
            },
            init() {
                this.button.addEventListener("click", this.handleClickAddButton.bind(this))
            }
        }
    })), kg.data("productQuickViewButton", (function (e, t) {
        return {
            state: zg,
            get quickviewHolder() {
                return this.$el.querySelector(`[${Ug}]`)
            },
            get isInitial() {
                return this.state === zg
            },
            get isLoading() {
                return this.state === Vg
            },
            get isDisabled() {
                return this.isLoading
            },
            clickQuickviewButton(e) {
                this.modal && this.modalID && (this.modal.id = this.modalID), document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1), this.state = Vg, this.getQuickviewHTML()
            },
            getQuickviewHTML() {
                window.fetch(`${window.theme.routes.root_url}products/${t}?section_id=api-product-quickview`).then(this.handleErrors).then((e => e.text())).then((e => {
                    const t = document.createElement("div");
                    t.innerHTML = e, this.modalContent = this.modal.querySelector(Gg), this.modalContent.innerHTML = t.querySelector("[data-api-content]").innerHTML, this.modalScroll = this.modal.querySelector(Qg);
                    const i = this.modalContent.querySelector(ty);
                    if (i) {
                        const e = document.createElement("div");
                        e.innerHTML = i.parentElement.innerHTML, this.quickviewHolder.dispatchEvent(new CustomEvent("theme:quickview:media", {
                            bubbles: !0,
                            detail: {
                                media: e
                            }
                        }))
                    }
                    const s = {
                        container: this.modalContent
                    };
                    this.media = new Ua(s), this.modalCreate(), this.state = zg
                }))
            },
            modalCreate() {
                n.show(this.modalID, {
                    onShow: (e, t, i) => {
                        this.quickviewHead = e.querySelector(Kg), this.quickviewFormArea = e.querySelector(Xg), this.toggleButton = e.querySelector(Zg), this.toggleForm("loading"), document.addEventListener("theme:resize", Zo((() => {
                            this.toggleForm("resize")
                        }), 500)), this.clickEventToggleForm();
                        const s = e.querySelector(iy);
                        yi(e, {
                            elementToFocus: s
                        }), this.modal.addEventListener("theme:quickview:close", this.modalClose), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0,
                            detail: this.modalScroll
                        })), new Yc(this.modal)
                    },
                    onClose: (e, t, i) => {
                        this.media.destroy();
                        e.querySelectorAll(ey).forEach((e => {
                            e.dispatchEvent(new CustomEvent("pause"))
                        })), vi(), t.focus(), this.modal.removeEventListener("theme:quickview:close", this.modalClose), this.scrollLockEnable ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })) : this.scrollLockEnable = !0
                    }
                })
            },
            modalClose() {
                n.close(this.modalID)
            },
            handleErrors: e => e.ok ? e : e.json().then((function (t) {
                throw new Z({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                })
            })),
            toggleForm(e) {
                this.windowH === window.innerHeight && "resize" === e || (this.toggleButton.classList.contains(sy) || this.toggleButton.classList.add(sy), this.quickviewFormArea.classList.contains(ny) || this.quickviewFormArea.classList.add(ny), "resize" === e && (this.quickviewFormArea.classList.add(ny), this.toggleButton.classList.add(sy), this.windowH = window.innerHeight), setTimeout((() => {
                    const t = window.innerHeight - this.quickviewHead.offsetHeight - this.quickviewFormArea.offsetHeight,
                        i = t < ay;
                    t < ly && t > ay || i ? (this.toggleButton.classList.remove(sy), this.toggleButton.classList.add(ry)) : this.toggleButton.classList.add(sy), i ? ("loading" === e && (this.quickviewFormArea.classList.add(oy), setTimeout((() => {
                        this.quickviewFormArea.classList.remove(oy)
                    }), 50)), this.quickviewFormArea.classList.remove(ny), this.toggleButton.classList.remove(ry)) : this.quickviewFormArea.classList.add(ny)
                }), 200))
            },
            clickEventToggleForm() {
                this.toggleButton && this.toggleButton.addEventListener("click", (() => {
                    this.toggleButton.classList.toggle(ry), this.quickviewFormArea.classList.toggle(ny)
                }))
            },
            init() {
                if (this.quickviewHolder && (this.modalTemplate = this.quickviewHolder.querySelector(Yg), this.modal = document.querySelector(Jg), this.modalID = this.quickviewHolder.getAttribute(Ug), this.modalContent = null, this.modalScroll = null, this.scrollLockEnable = !0, this.windowH = window.innerHeight, this.modalTemplate && !this.modal)) {
                    const e = this.modalTemplate.innerHTML,
                        t = document.createElement("div");
                    t.innerHTML = e, this.modalHtml = t.querySelector(Jg), document.body.appendChild(this.modalHtml), this.modal = document.querySelector(Jg)
                }
            }
        }
    })), kg.data("productGridItemQuickAddMenu", (function () {
        return function (...e) {
            return e.reduce(((e, t) => {
                const i = "function" == typeof t ? t() : t;
                return i.init && e._initializers.push(i.init), delete i.init, Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
            }), {
                _initializers: [],
                init() {
                    this._initializers.forEach((e => e.call(this)))
                }
            })
        }(cy(), {
            controller: null,
            init() {
                this.$watch("isOpen", (e => {
                    e ? this.listen() : this.unlisten()
                }))
            },
            listen() {
                this.controller = new AbortController, this.$el.addEventListener("mouseleave", (() => {
                    this.close()
                }), {
                    signal: this.controller.signal
                }), document.addEventListener("click", (e => {
                    this.$el.contains(e.target) || !1 !== this.$el._x_isShown && this.close()
                }), {
                    signal: this.controller.signal
                }), document.addEventListener("focusin", (e => {
                    this.$el.contains(e.target) || this.close()
                }), {
                    signal: this.controller.signal
                }), document.addEventListener("keydown", (e => {
                    "Escape" === e.key && this.close()
                }), {
                    signal: this.controller.signal
                })
            },
            unlisten() {
                this.controller.abort(), this.controller = null
            }
        })
    })), kg.data("toggle", cy), kg.data("tabs", (function (e = 0) {
        return {
            selectedIndex: null,
            init() {
                this.$nextTick((() => this.select(e)))
            },
            get tablist() {
                return this.$el.querySelector(hy)
            },
            get tabs() {
                var e;
                return null === (e = this.tablist) || void 0 === e ? void 0 : e.querySelectorAll(dy)
            },
            getTab(e) {
                var t;
                return null === (t = this.tabs) || void 0 === t ? void 0 : t[e]
            },
            isSelected(e) {
                return this.selectedIndex === e
            },
            select(e, t = !0) {
                this.selectedIndex = e;
                const i = this.getTab(e);
                i && t && this.tablist.scrollTo({
                    top: 0,
                    left: i.offsetLeft - i.clientWidth,
                    behavior: "smooth"
                })
            },
            bindTabs: {
                "x-id": "['tab', 'tab-panel']"
            },
            bindTablist: {
                ":role": "'tablist'",
                "@keydown.right.prevent.stop": "$focus.wrap().next()",
                "@keydown.home.prevent.stop": "$focus.first()",
                "@keydown.page-up.prevent.stop": "$focus.first()",
                "@keydown.left.prevent.stop": "$focus.wrap().prev()",
                "@keydown.end.prevent.stop": "$focus.last()",
                "@keydown.page-down.prevent.stop": "$focus.last()"
            },
            bindTabpanels: {},
            bindTab: e => ({
                ":id": `$id('tab', ${e + 1})`,
                ":role": "'tab'",
                "@click": `select(${e})`,
                "@mousedown.prevent": "",
                "@focus": `select(${e})`,
                ":tabindex": `isSelected(${e}) ? 0 : -1`,
                ":aria-selected": `isSelected(${e})`,
                ":aria-controls": `$id('tab-panel', ${e + 1})`
            }),
            bindTabpanel: e => ({
                ":id": `$id('tab-panel', ${e + 1})`,
                ":role": "'tabpanel'",
                "x-show": `isSelected(${e})`,
                ":aria-labelledby": `$id('tab', ${e + 1})`
            })
        }
    })), kg.data("overflow", (function (e = {}) {
        const t = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...e.inset
        };
        return {
            get overflowContainer() {
                return this.$refs.overflowContainer
            },
            isOverflowing: {
                top: !1,
                bottom: !1,
                left: !1,
                right: !1
            },
            checkOverflow() {
                const e = this.overflowContainer.scrollHeight - this.overflowContainer.scrollTop - t.bottom,
                    i = this.overflowContainer.scrollWidth - this.overflowContainer.scrollLeft - t.right;
                this.isOverflowing.top = this.overflowContainer.scrollTop - t.top > 0, this.isOverflowing.bottom = e > this.overflowContainer.clientHeight, this.isOverflowing.left = this.overflowContainer.scrollLeft - t.left > 0, this.isOverflowing.right = i > this.overflowContainer.clientWidth
            },
            scrollTo(e) {
                this.overflowContainer.scrollTo(e)
            }
        }
    })), kg.magic("nudge", (function (e) {
        return (e, {
            left: t,
            top: i,
            ...s
        }) => {
            e.scrollTo({
                ...t && {
                    left: Math.max(Math.min(e.scrollLeft + t, e.scrollWidth), 0)
                },
                ...i && {
                    left: Math.max(Math.min(e.scrollTop + i, e.scrollHeight), 0)
                },
                ...s
            })
        }
    })), kg.directive("hold", ((e, {
        modifiers: t,
        expression: i
    }, {
        cleanup: s,
        evaluate: r
    }) => {
        let n = null,
            o = t[0] || "",
            a = Number.isInteger(o.split("ms")[0]) ? Number(o.split("ms")[0]) : 25;
        const l = () => {
            n = setInterval((() => {
                r(i)
            }), a)
        },
            c = () => {
                clearInterval(n)
            };
        e.addEventListener("mousedown", l), e.addEventListener("mouseup", c), e.addEventListener("mouseleave", c), e.addEventListener("touchstart", l), e.addEventListener("touchend", c), s((() => {
            e.removeEventListener("mousedown", l), e.removeEventListener("mouseup", c), e.removeEventListener("mouseleave", c), e.removeEventListener("touchstart", l), e.removeEventListener("touchend", c)
        }))
    })), kg.directive("target-referrer", ((e, {
        expression: t
    }) => {
        t && (-1 !== document.referrer.indexOf(t) || window.Shopify.designMode || e.parentNode.removeChild(e))
    })), kg.plugin(Yu), kg.start(), window.Alpine = kg
}(themeVendor.AOS, themeVendor.FlickityFade, themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.Sqrl, themeVendor.MicroModal, themeVendor.Rellax, themeVendor.themeCurrency, themeVendor.axios, themeVendor.FlickitySync, themeVendor.themeAddresses);